var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagEs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26626_59562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.13 0H0.5V23.1H139.13V0Z",
    fill: "#D01317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.13 69.3199H0.5V92.4199H139.13V69.3199Z",
    fill: "#D01317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.13 23.1H0.5V69.31H139.13V23.1Z",
    fill: "#F8EA3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.61 40.7401C59.62 40.7401 59.63 40.7301 59.63 40.7301C59.65 40.6801 59.67 40.6101 59.67 40.5201C59.67 40.2101 59.43 39.9701 59.13 39.9701C59.04 39.9701 58.91 40.0001 58.82 40.0801C58.81 40.0901 58.81 40.1001 58.82 40.1101C58.83 40.1201 58.84 40.1201 58.85 40.1101C58.92 40.0401 59.04 40.0101 59.13 40.0101C59.41 40.0101 59.63 40.2401 59.63 40.5201C59.63 40.6001 59.61 40.6701 59.59 40.7101C59.59 40.7301 59.59 40.7401 59.61 40.7401Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7201 40.55C58.7301 40.55 58.7401 40.54 58.7401 40.54C58.7601 40.49 58.7801 40.42 58.7801 40.33C58.7801 40.02 58.5401 39.78 58.2401 39.78C58.1501 39.78 58.0201 39.81 57.9301 39.89C57.9201 39.9 57.9201 39.91 57.9301 39.92C57.9401 39.93 57.9501 39.93 57.9601 39.92C58.0301 39.85 58.1501 39.82 58.2401 39.82C58.5201 39.82 58.7401 40.05 58.7401 40.33C58.7401 40.41 58.7201 40.48 58.7001 40.52C58.6901 40.54 58.7001 40.55 58.7201 40.55Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6501 40.55C56.6401 40.55 56.6301 40.54 56.6301 40.54C56.6101 40.49 56.5901 40.42 56.5901 40.33C56.5901 40.02 56.8301 39.78 57.1301 39.78C57.2201 39.78 57.3501 39.81 57.4401 39.89C57.4501 39.9 57.4501 39.91 57.4401 39.92C57.4301 39.93 57.4201 39.93 57.4101 39.92C57.3401 39.85 57.2201 39.82 57.1301 39.82C56.8501 39.82 56.6301 40.05 56.6301 40.33C56.6301 40.41 56.6501 40.48 56.6701 40.52C56.6801 40.54 56.6701 40.55 56.6501 40.55Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6901 41.14C28.6901 41.14 28.6001 41.14 28.5401 41.11C28.4901 41.08 28.3301 40.93 28.3301 40.93L28.2001 40.84L28.0901 40.68C28.0901 40.68 27.9501 40.46 28.0201 40.29C28.0801 40.12 28.1901 40.06 28.2801 40.01C28.3701 39.96 28.5701 39.9 28.5701 39.9C28.5701 39.9 28.7301 39.83 28.7801 39.82C28.8301 39.81 29.0201 39.76 29.0201 39.76C29.0201 39.76 29.0701 39.73 29.1201 39.71C29.1701 39.69 29.2501 39.69 29.2901 39.68C29.3301 39.67 29.4401 39.64 29.5001 39.63C29.6001 39.63 29.7501 39.65 29.8001 39.65C29.8501 39.65 30.0301 39.66 30.1001 39.66C30.1701 39.66 30.4301 39.64 30.5101 39.64C30.5801 39.64 30.6401 39.63 30.7201 39.64C30.8001 39.65 30.9501 39.7 30.9901 39.72C31.0301 39.74 31.2801 39.83 31.3801 39.86C31.4701 39.89 31.7001 39.93 31.8101 39.98C31.9101 40.03 31.9801 40.11 32.0301 40.18C32.0801 40.25 32.0901 40.32 32.1101 40.37C32.1301 40.42 32.1301 40.53 32.1101 40.58C32.0901 40.63 32.0201 40.73 32.0201 40.73L31.9001 40.92L31.7501 41.04C31.7501 41.04 31.6401 41.14 31.5601 41.13C31.4801 41.12 30.6301 40.97 30.0901 40.97C29.5601 40.98 28.6901 41.14 28.6901 41.14Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3701 39.9301C30.3701 39.6801 30.2601 39.4701 30.1101 39.4701C29.9701 39.4701 29.8501 39.6801 29.8501 39.9301C29.8501 40.1901 29.9601 40.3901 30.1101 40.3901C30.2501 40.3901 30.3701 40.1801 30.3701 39.9301Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.23 39.93C30.23 39.7 30.18 39.5 30.11 39.5C30.04 39.5 29.99 39.69 29.99 39.93C29.99 40.17 30.04 40.36 30.11 40.36C30.18 40.35 30.23 40.16 30.23 39.93Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.29 39.44C30.29 39.35 30.21 39.28 30.12 39.28C30.02 39.28 29.95 39.35 29.95 39.44C29.95 39.53 30.03 39.6 30.12 39.6C30.21 39.6 30.29 39.53 30.29 39.44Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3501 39.3801V39.4901H29.8801V39.3801H30.0601V39.1401H29.9401V39.0401H30.0601V38.9301H30.1701V39.0401H30.2801V39.1401H30.1701V39.3801H30.3501Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.0485,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.16 39.28C30.23 39.3 30.29 39.36 30.29 39.44C30.29 39.53 30.21 39.6 30.12 39.6C30.03 39.6 29.95 39.53 29.95 39.44C29.95 39.37 30 39.3 30.08 39.29L30.16 39.28Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1101 41.1101H29.2201L29.2001 40.8901L29.1601 40.6601L29.1201 40.3801C28.8701 40.0601 28.6501 39.8401 28.5701 39.8901C28.5901 39.8301 28.6101 39.7901 28.6601 39.7601C28.8801 39.6301 29.3301 39.9401 29.6701 40.4501C29.7001 40.5001 29.7301 40.5401 29.7501 40.5901H30.4801C30.5101 40.5401 30.5401 40.5001 30.5701 40.4501C30.9101 39.9401 31.3601 39.6301 31.5701 39.7601C31.6201 39.7901 31.6401 39.8301 31.6601 39.8901C31.5801 39.8501 31.3601 40.0601 31.1101 40.3801L31.0701 40.6601L31.0301 40.8901L31.0101 41.1101H30.1101Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7601 40.5901L30.7301 40.5701C31.0101 40.1401 31.3501 39.8501 31.5501 39.8501C31.5801 39.8501 31.6101 39.8601 31.6301 39.8701L31.6101 39.9101C31.4501 39.8101 31.0701 40.1201 30.7601 40.5901ZM29.4701 40.5901C29.1701 40.1301 28.7801 39.8201 28.6201 39.9101L28.6001 39.8701C28.7801 39.7701 29.1801 40.0701 29.5001 40.5701L29.4701 40.5901Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7999 41.51C28.7599 41.4 28.6899 41.31 28.6899 41.31C29.0499 41.21 29.5499 41.14 30.1099 41.14C30.6699 41.14 31.1699 41.21 31.5299 41.31C31.5299 41.31 31.4899 41.38 31.4299 41.48C31.3999 41.54 31.3599 41.63 31.3599 41.63C31.0399 41.53 30.6199 41.48 30.0999 41.48C29.5799 41.48 29.0899 41.54 28.8299 41.64C28.8499 41.64 28.8199 41.58 28.7999 41.51Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.11 41.9701C30.56 41.9701 31.05 41.9001 31.24 41.8501C31.36 41.8101 31.43 41.7601 31.42 41.6901C31.41 41.6601 31.39 41.6301 31.35 41.6201C31.08 41.5301 30.6 41.4701 30.11 41.4701C29.62 41.4701 29.14 41.5301 28.87 41.6201C28.84 41.6301 28.81 41.6601 28.8 41.6901C28.79 41.7501 28.86 41.8101 28.98 41.8501C29.17 41.9001 29.66 41.9701 30.11 41.9701Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5599 41.1101L31.4499 41.0101C31.4499 41.0101 31.3499 41.0701 31.2099 41.0501C31.0799 41.0301 31.0399 40.8701 31.0399 40.8701C31.0399 40.8701 30.8899 40.9901 30.7699 40.9801C30.6499 40.9701 30.5699 40.8701 30.5699 40.8701C30.5699 40.8701 30.4399 40.9601 30.3199 40.9601C30.2099 40.9501 30.0999 40.8101 30.0999 40.8101C30.0999 40.8101 29.9799 40.9601 29.8699 40.9701C29.7599 40.9801 29.6599 40.8701 29.6599 40.8701C29.6599 40.8701 29.6099 40.9801 29.4599 41.0001C29.3099 41.0201 29.1899 40.8901 29.1899 40.8901C29.1899 40.8901 29.1099 41.0201 29.0099 41.0601C28.9099 41.0901 28.7799 41.0101 28.7799 41.0101C28.7799 41.0101 28.7599 41.0601 28.7399 41.0901C28.7299 41.1201 28.6799 41.1301 28.6799 41.1301L28.7099 41.2201C29.0699 41.1201 29.5499 41.0501 30.0999 41.0501C30.6499 41.0501 31.1499 41.1101 31.5099 41.2201L31.5599 41.1101Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1101 40.63L30.1601 40.64C30.1501 40.66 30.1501 40.68 30.1501 40.71C30.1501 40.82 30.2401 40.9 30.3601 40.9C30.4501 40.9 30.5301 40.84 30.5601 40.77C30.5601 40.77 30.5801 40.7 30.5901 40.7C30.6001 40.7 30.6001 40.78 30.6001 40.78C30.6101 40.88 30.7001 40.95 30.8001 40.95C30.9101 40.95 31.0001 40.86 31.0001 40.75C31.0001 40.74 31.0001 40.74 31.0001 40.73L31.0701 40.67L31.1001 40.75C31.0901 40.78 31.0801 40.8 31.0801 40.84C31.0801 40.94 31.1701 41.03 31.2801 41.03C31.3501 41.03 31.4101 41 31.4401 40.95L31.4801 40.9V40.97C31.4801 41.03 31.5001 41.09 31.5701 41.1C31.5701 41.1 31.6401 41.11 31.7401 41.03C31.8401 40.96 31.8901 40.89 31.8901 40.89V40.97C31.8901 40.97 31.8001 41.12 31.7101 41.17C31.6601 41.2 31.5901 41.23 31.5301 41.22C31.4701 41.21 31.4301 41.16 31.4101 41.11C31.3701 41.14 31.3201 41.15 31.2601 41.15C31.1401 41.15 31.0401 41.09 31.0001 40.99C30.9501 41.05 30.8701 41.08 30.7901 41.08C30.6901 41.08 30.6101 41.04 30.5601 40.97C30.5101 41.02 30.4401 41.05 30.3601 41.05C30.2601 41.05 30.1701 41 30.1101 40.92C30.0601 41 29.9701 41.05 29.8601 41.05C29.7801 41.05 29.7101 41.02 29.6601 40.97C29.6101 41.03 29.5201 41.08 29.4301 41.08C29.3401 41.08 29.2701 41.05 29.2101 40.99C29.1701 41.08 29.0601 41.15 28.9501 41.15C28.9001 41.15 28.8501 41.14 28.8001 41.11C28.7801 41.17 28.7301 41.21 28.6701 41.22C28.6101 41.23 28.5401 41.2 28.5001 41.17C28.4101 41.12 28.3101 40.97 28.3101 40.97L28.3201 40.89C28.3201 40.89 28.3701 40.95 28.4701 41.03C28.5701 41.11 28.6401 41.1 28.6401 41.1C28.7001 41.09 28.7301 41.03 28.7301 40.97V40.9L28.7701 40.95C28.8001 41 28.8601 41.03 28.9301 41.03C29.0401 41.03 29.1301 40.95 29.1301 40.84C29.1301 40.81 29.1301 40.78 29.1101 40.75L29.1501 40.67L29.2101 40.73C29.2101 40.74 29.2101 40.74 29.2101 40.75C29.2101 40.86 29.3001 40.95 29.4201 40.95C29.5201 40.95 29.6101 40.88 29.6301 40.78C29.6301 40.78 29.6301 40.7 29.6401 40.7C29.6501 40.7 29.6701 40.77 29.6701 40.77C29.7001 40.85 29.7701 40.9 29.8701 40.9C29.9801 40.9 30.0701 40.81 30.0701 40.71C30.0701 40.69 30.0701 40.66 30.0601 40.64L30.1101 40.63Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1101 41.14C29.5501 41.14 29.0501 41.21 28.6901 41.31C28.6701 41.32 28.6401 41.3 28.6301 41.28C28.6201 41.26 28.6401 41.23 28.6601 41.22C29.0201 41.11 29.5301 41.04 30.1001 41.04C30.6701 41.04 31.1901 41.11 31.5501 41.22C31.5701 41.23 31.5901 41.25 31.5801 41.28C31.5701 41.3 31.5401 41.32 31.5201 41.31C31.1701 41.21 30.6701 41.14 30.1101 41.14Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.22 40.91C28.22 40.91 28.15 40.82 28.1 40.77C28.06 40.74 27.97 40.71 27.97 40.71C27.97 40.7 28.02 40.66 28.08 40.66C28.11 40.66 28.14 40.67 28.16 40.7L28.17 40.66C28.17 40.66 28.21 40.67 28.23 40.72C28.25 40.77 28.24 40.85 28.24 40.85C28.24 40.85 28.24 40.89 28.22 40.91Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.57 40.7701L28.55 40.8901L28.29 40.9201L28.25 40.9001L28.26 40.8601L28.46 40.7001L28.57 40.7701Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.57 40.7701L28.55 40.8901L28.29 40.9201L28.25 40.9001L28.26 40.8601L28.46 40.7001L28.57 40.7701Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2201 40.86C28.2401 40.84 28.2901 40.84 28.3201 40.87C28.3501 40.9 28.3701 40.94 28.3401 40.96C28.3201 40.98 28.2701 40.98 28.2401 40.95C28.2101 40.93 28.2001 40.89 28.2201 40.86Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7 40.8901C28.69 40.8601 28.7 40.8201 28.72 40.8101C28.75 40.8001 28.78 40.8301 28.79 40.8601C28.8 40.9001 28.79 40.9301 28.77 40.9401C28.74 40.9501 28.71 40.9201 28.7 40.8901Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8201 40.7301L28.9101 40.8201L29.1401 40.7001L29.1601 40.6601L29.1301 40.6301L28.8701 40.6101L28.8201 40.7301Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8201 40.7301L28.9101 40.8201L29.1401 40.7001L29.1601 40.6601L29.1301 40.6301L28.8701 40.6101L28.8201 40.7301Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.08 40.3101L28.96 40.4301L29.12 40.6401L29.16 40.6601L29.19 40.6301L29.25 40.3801L29.08 40.3101Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.08 40.3101L28.96 40.4301L29.12 40.6401L29.16 40.6601L29.19 40.6301L29.25 40.3801L29.08 40.3101Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4999 40.6L29.4499 40.72L29.1899 40.7L29.1599 40.67L29.1799 40.63L29.4099 40.51L29.4999 40.6Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4999 40.6L29.4499 40.72L29.1899 40.7L29.1599 40.67L29.1799 40.63L29.4099 40.51L29.4999 40.6Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2501 40.6601C29.2501 40.6101 29.2101 40.5701 29.1601 40.5701C29.1101 40.5701 29.0701 40.6101 29.0701 40.6601C29.0701 40.7101 29.1101 40.7501 29.1601 40.7501C29.2101 40.7501 29.2501 40.7101 29.2501 40.6601Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.59 40.72C29.58 40.68 29.6 40.65 29.63 40.65C29.65 40.65 29.68 40.67 29.68 40.71C29.69 40.74 29.67 40.78 29.64 40.78C29.62 40.78 29.6 40.75 29.59 40.72Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.76 40.5901L29.83 40.7001L30.08 40.6201L30.11 40.5901L30.08 40.5501L29.83 40.4801L29.76 40.5901Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.76 40.5901L29.83 40.7001L30.08 40.6201L30.11 40.5901L30.08 40.5501L29.83 40.4801L29.76 40.5901Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.11 40.2001L29.95 40.3001L30.07 40.5501L30.11 40.5801L30.15 40.5501L30.27 40.3001L30.11 40.2001Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4601 40.5901L30.3901 40.6901L30.1401 40.6101L30.1101 40.5801L30.1401 40.5401L30.3901 40.4701L30.4601 40.5901Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2 40.5801C30.2 40.5301 30.16 40.4901 30.11 40.4901C30.06 40.4901 30.02 40.5301 30.02 40.5801C30.02 40.6301 30.06 40.6701 30.11 40.6701C30.16 40.6701 30.2 40.6301 30.2 40.5801Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.63 40.72C30.63 40.68 30.61 40.65 30.59 40.65C30.56 40.65 30.54 40.67 30.53 40.71C30.53 40.74 30.54 40.78 30.57 40.78C30.6 40.78 30.63 40.75 30.63 40.72Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.73 40.6L30.78 40.72L31.04 40.7L31.07 40.67L31.05 40.63L30.82 40.51L30.73 40.6Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.73 40.6L30.78 40.72L31.04 40.7L31.07 40.67L31.05 40.63L30.82 40.51L30.73 40.6Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.15 40.3101L31.27 40.4301L31.11 40.6401L31.07 40.6601L31.04 40.6301L30.98 40.3801L31.15 40.3101Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.15 40.3101L31.27 40.4301L31.11 40.6401L31.07 40.6601L31.04 40.6301L30.98 40.3801L31.15 40.3101Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4101 40.7301L31.3201 40.8201L31.0901 40.7001L31.0701 40.6601L31.1101 40.6301L31.3701 40.6101L31.4101 40.7301Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4101 40.7301L31.3201 40.8201L31.0901 40.7001L31.0701 40.6601L31.1101 40.6301L31.3701 40.6101L31.4101 40.7301Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.16 40.6601C31.16 40.6101 31.12 40.5701 31.07 40.5701C31.02 40.5701 30.98 40.6101 30.98 40.6601C30.98 40.7101 31.02 40.7501 31.07 40.7501C31.12 40.7501 31.16 40.7101 31.16 40.6601Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.53 40.8901C31.54 40.8601 31.53 40.8201 31.51 40.8101C31.48 40.8001 31.45 40.8301 31.44 40.8601C31.43 40.9001 31.44 40.9301 31.47 40.9401C31.49 40.9501 31.52 40.9201 31.53 40.8901Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.97 40.91C31.97 40.91 32.04 40.82 32.09 40.77C32.12 40.74 32.21 40.71 32.21 40.71C32.21 40.7 32.16 40.66 32.1 40.66C32.07 40.66 32.04 40.67 32.02 40.7L32.01 40.66C32.01 40.66 31.96 40.67 31.94 40.72C31.92 40.77 31.93 40.85 31.93 40.85C31.93 40.85 31.96 40.89 31.97 40.91Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6201 40.7701L31.6401 40.8901L31.9001 40.9201L31.9401 40.9001L31.9301 40.8601L31.7401 40.7001L31.6201 40.7701Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6201 40.7701L31.6401 40.8901L31.9001 40.9201L31.9401 40.9001L31.9301 40.8601L31.7401 40.7001L31.6201 40.7701Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.97 40.86C31.95 40.84 31.91 40.84 31.87 40.87C31.84 40.9 31.83 40.94 31.85 40.96C31.87 40.98 31.92 40.98 31.95 40.95C31.99 40.93 32 40.89 31.97 40.86Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7 41.5201L28.76 41.4301L28.8799 41.4501L28.8099 41.5601L28.7 41.5201Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.22 41.43L29.09 41.4501C29.06 41.4501 29.02 41.4301 29.02 41.4001C29.02 41.3701 29.04 41.34 29.07 41.34L29.2 41.32L29.33 41.3C29.36 41.3 29.39 41.32 29.4 41.35C29.4 41.38 29.38 41.41 29.35 41.42L29.22 41.43Z",
    fill: "#419846"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.22 41.43L29.09 41.4501C29.06 41.4501 29.02 41.4301 29.02 41.4001C29.02 41.3701 29.04 41.34 29.07 41.34L29.2 41.32L29.33 41.3C29.36 41.3 29.39 41.32 29.4 41.35C29.4 41.38 29.38 41.41 29.35 41.42L29.22 41.43Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7301 41.34C29.7301 41.3 29.6901 41.26 29.6501 41.26C29.6101 41.26 29.5701 41.29 29.5701 41.34C29.5701 41.38 29.6101 41.42 29.6501 41.42C29.7001 41.41 29.7301 41.38 29.7301 41.34Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1201 41.37H29.9401C29.9101 41.37 29.8801 41.34 29.8801 41.31C29.8801 41.28 29.9001 41.25 29.9401 41.25H30.3001C30.3401 41.25 30.3601 41.28 30.3601 41.31C30.3601 41.34 30.3301 41.37 30.3001 41.37H30.1201Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.65 41.34C30.65 41.3 30.61 41.26 30.57 41.26C30.52 41.26 30.49 41.29 30.49 41.34C30.49 41.38 30.53 41.42 30.57 41.42C30.62 41.41 30.65 41.38 30.65 41.34Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0001 41.43L31.1301 41.4501C31.1601 41.4501 31.1901 41.4301 31.2001 41.4001C31.2001 41.3701 31.1801 41.34 31.1501 41.34L31.0201 41.32L30.8901 41.3C30.8601 41.3 30.8301 41.32 30.8201 41.35C30.8101 41.38 30.8401 41.41 30.8701 41.42L31.0001 41.43Z",
    fill: "#419846"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0001 41.43L31.1301 41.4501C31.1601 41.4501 31.1901 41.4301 31.2001 41.4001C31.2001 41.3701 31.1801 41.34 31.1501 41.34L31.0201 41.32L30.8901 41.3C30.8601 41.3 30.8301 41.32 30.8201 41.35C30.8101 41.38 30.8401 41.41 30.8701 41.42L31.0001 41.43Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5101 41.5301L31.4601 41.4301L31.3401 41.4401L31.4001 41.5501L31.5101 41.5301Z",
    fill: "#BF1818"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5101 41.5301L31.4601 41.4301L31.3401 41.4401L31.4001 41.5501L31.5101 41.5301Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.11 41.8601C29.66 41.8601 29.25 41.8201 28.95 41.7401C29.26 41.6601 29.67 41.6101 30.11 41.6101C30.56 41.6101 30.97 41.6601 31.28 41.7401C30.97 41.8201 30.56 41.8601 30.11 41.8601Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3199 41.85V41.63M30.2099 41.86V41.63M30.1399 41.86V41.63",
    stroke: "#020203",
    strokeWidth: 0.001595,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0701 41.86V41.63",
    stroke: "#020203",
    strokeWidth: 0.003233,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 41.86V41.63",
    stroke: "#020203",
    strokeWidth: 0.004829,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.95 41.86V41.63",
    stroke: "#020203",
    strokeWidth: 0.006467,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8801 41.86V41.63",
    stroke: "#020203",
    strokeWidth: 0.006467,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8301 41.86V41.63",
    stroke: "#020203",
    strokeWidth: 0.008062,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.73 41.85V41.64M29.78 41.85V41.63",
    stroke: "#020203",
    strokeWidth: 0.009722,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6399 41.84V41.64M29.6799 41.85V41.64",
    stroke: "#020203",
    strokeWidth: 0.0113,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.51 41.83V41.66M29.55 41.83V41.65M29.6 41.84V41.65",
    stroke: "#020203",
    strokeWidth: 0.013,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.47 41.83V41.66",
    stroke: "#020203",
    strokeWidth: 0.0145,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4299 41.82V41.66",
    stroke: "#020203",
    strokeWidth: 0.0162,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3801 41.82V41.67",
    stroke: "#020203",
    strokeWidth: 0.0178,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.29 41.8001V41.6901M29.34 41.8101V41.6801",
    stroke: "#020203",
    strokeWidth: 0.0194,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.25 41.7901V41.6901",
    stroke: "#020203",
    strokeWidth: 0.0194,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2 41.7801V41.7001",
    stroke: "#020203",
    strokeWidth: 0.021,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1599 41.7701V41.7001",
    stroke: "#020203",
    strokeWidth: 0.0226,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1101 41.7701V41.7201",
    stroke: "#020203",
    strokeWidth: 0.0242,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0601 41.7601V41.7401",
    stroke: "#020203",
    strokeWidth: 0.0291,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 61.1801C32.72 61.1801 32.46 61.1201 32.27 61.0201C32.09 60.9301 31.83 60.8701 31.56 60.8701C31.28 60.8701 31.02 60.9301 30.84 61.0201C30.65 61.1201 30.4 61.1801 30.12 61.1801C29.84 61.1801 29.58 61.1101 29.39 61.0101C29.21 60.9201 28.96 60.8601 28.69 60.8601C28.41 60.8601 28.16 60.9101 27.98 61.0101C27.79 61.1101 27.53 61.1701 27.25 61.1701V61.6201C27.53 61.6201 27.79 61.5501 27.98 61.4601C28.17 61.3601 28.41 61.3101 28.69 61.3101C28.96 61.3101 29.21 61.3701 29.39 61.4601C29.58 61.5601 29.83 61.6301 30.12 61.6301C30.4 61.6301 30.66 61.5701 30.84 61.4701C31.03 61.3701 31.28 61.3101 31.56 61.3101C31.84 61.3101 32.09 61.3701 32.27 61.4601C32.46 61.5601 32.71 61.6201 32.99 61.6201L33 61.1801Z",
    fill: "#3955A2",
    stroke: "#020203",
    strokeWidth: 0.0986,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 61.6301C32.72 61.6301 32.46 61.5701 32.27 61.4701C32.09 61.3801 31.83 61.3201 31.56 61.3201C31.28 61.3201 31.02 61.3801 30.84 61.4701C30.65 61.5701 30.4 61.6301 30.12 61.6301C29.84 61.6301 29.58 61.5601 29.39 61.4601C29.21 61.3701 28.96 61.3101 28.69 61.3101C28.41 61.3101 28.16 61.3601 27.98 61.4601C27.79 61.5601 27.53 61.6201 27.25 61.6201V62.0701C27.53 62.0701 27.79 62.0001 27.98 61.9101C28.17 61.8101 28.41 61.7601 28.69 61.7601C28.96 61.7601 29.21 61.8201 29.39 61.9101C29.58 62.0101 29.83 62.0801 30.12 62.0801C30.4 62.0801 30.66 62.0201 30.84 61.9201C31.03 61.8201 31.28 61.7701 31.56 61.7701C31.84 61.7701 32.09 61.8301 32.27 61.9201C32.46 62.0201 32.71 62.0801 32.99 62.0801L33 61.6301Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 62.08C32.72 62.08 32.46 62.02 32.27 61.92C32.09 61.82 31.83 61.77 31.56 61.77C31.28 61.77 31.02 61.83 30.84 61.92C30.65 62.02 30.4 62.08 30.12 62.08C29.84 62.08 29.58 62.01 29.39 61.91C29.21 61.82 28.96 61.76 28.69 61.76C28.41 61.76 28.16 61.81 27.98 61.91C27.79 62.01 27.53 62.07 27.25 62.07V62.51C27.53 62.51 27.79 62.45 27.98 62.35C28.17 62.26 28.41 62.2 28.69 62.2C28.96 62.2 29.21 62.26 29.39 62.35C29.58 62.45 29.83 62.52 30.12 62.52C30.4 62.52 30.66 62.46 30.84 62.36C31.03 62.26 31.28 62.21 31.56 62.21C31.84 62.21 32.09 62.27 32.27 62.36C32.46 62.46 32.71 62.52 32.99 62.52L33 62.08Z",
    fill: "#3955A2",
    stroke: "#020203",
    strokeWidth: 0.0986,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.99 62.9701C32.71 62.9701 32.46 62.9101 32.27 62.8101C32.09 62.7201 31.83 62.6601 31.56 62.6601C31.28 62.6601 31.02 62.7201 30.84 62.8101C30.65 62.9101 30.4 62.9701 30.12 62.9701C29.84 62.9701 29.58 62.9001 29.39 62.8001C29.21 62.7101 28.96 62.6501 28.69 62.6501C28.41 62.6501 28.16 62.7001 27.98 62.8001C27.79 62.9001 27.53 62.9601 27.25 62.9601V62.5201C27.53 62.5201 27.79 62.4501 27.98 62.3501C28.17 62.2601 28.41 62.2001 28.69 62.2001C28.96 62.2001 29.21 62.2601 29.39 62.3501C29.58 62.4501 29.83 62.5201 30.12 62.5201C30.4 62.5201 30.66 62.4601 30.84 62.3601C31.03 62.2601 31.28 62.2101 31.56 62.2101C31.84 62.2101 32.09 62.2701 32.27 62.3601C32.46 62.4601 32.71 62.5201 33 62.5201L32.99 62.9701Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.99 62.9701C32.71 62.9701 32.46 62.9101 32.27 62.8101C32.09 62.7201 31.83 62.6601 31.56 62.6601C31.28 62.6601 31.02 62.7201 30.84 62.8101C30.65 62.9101 30.4 62.9701 30.12 62.9701C29.84 62.9701 29.58 62.9001 29.39 62.8001C29.21 62.7101 28.96 62.6501 28.69 62.6501C28.41 62.6501 28.16 62.7001 27.98 62.8001C27.79 62.9001 27.53 62.9601 27.25 62.9601V62.5201C27.53 62.5201 27.79 62.4501 27.98 62.3501C28.17 62.2601 28.41 62.2001 28.69 62.2001C28.96 62.2001 29.21 62.2601 29.39 62.3501C29.58 62.4501 29.83 62.5201 30.12 62.5201C30.4 62.5201 30.66 62.4601 30.84 62.3601C31.03 62.2601 31.28 62.2101 31.56 62.2101C31.84 62.2101 32.09 62.2701 32.27 62.3601C32.46 62.4601 32.71 62.5201 33 62.5201L32.99 62.9701Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.99 63.41C32.71 63.41 32.46 63.35 32.27 63.25C32.09 63.15 31.83 63.1 31.56 63.1C31.28 63.1 31.02 63.16 30.84 63.25C30.65 63.35 30.4 63.41 30.12 63.41C29.84 63.41 29.58 63.34 29.39 63.24C29.21 63.15 28.96 63.09 28.69 63.09C28.41 63.09 28.16 63.15 27.98 63.24C27.79 63.34 27.53 63.4 27.25 63.4V62.96C27.53 62.96 27.79 62.89 27.98 62.79C28.17 62.69 28.41 62.64 28.69 62.64C28.96 62.64 29.21 62.7 29.39 62.79C29.58 62.89 29.83 62.96 30.12 62.96C30.4 62.96 30.66 62.9 30.84 62.8C31.03 62.7 31.28 62.65 31.56 62.65C31.84 62.65 32.09 62.71 32.27 62.8C32.46 62.9 32.71 62.96 33 62.96L32.99 63.41Z",
    fill: "#3955A2",
    stroke: "#020203",
    strokeWidth: 0.0986,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.49 59.3501C28.5 59.3901 28.51 59.4201 28.51 59.4701C28.51 59.7401 28.27 59.9601 27.99 59.9601H32.23C31.94 59.9601 31.71 59.7401 31.71 59.4701C31.71 59.4301 31.72 59.3901 31.73 59.3501C31.71 59.3601 31.68 59.3601 31.65 59.3601H28.57C28.55 59.3701 28.52 59.3601 28.49 59.3501Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5701 59.0801H31.6501C31.7601 59.0801 31.8401 59.1401 31.8401 59.2201C31.8401 59.3001 31.7601 59.3701 31.6501 59.3701H28.5701C28.4701 59.3701 28.3801 59.3001 28.3801 59.2201C28.3801 59.1401 28.4701 59.0801 28.5701 59.0801Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.23 59.9601H28V61.0401H32.23V59.9601Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6101 44.1801H28.6101V58.9001H31.6101V44.1801Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.75 44.2001V58.8901M31.09 44.2001V58.8901",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1801 41.9301H28.0601V43.0101H32.1801V41.9301Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.49 43.73C28.52 43.72 28.53 43.72 28.57 43.72H31.65C31.68 43.72 31.71 43.73 31.74 43.74C31.63 43.71 31.56 43.61 31.56 43.5C31.56 43.39 31.64 43.29 31.75 43.25C31.72 43.26 31.69 43.26 31.66 43.26H28.57C28.54 43.26 28.51 43.26 28.48 43.25H28.5C28.61 43.28 28.67 43.38 28.67 43.49C28.67 43.59 28.6 43.7 28.49 43.73Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5701 43.7201H31.6501C31.7601 43.7201 31.8401 43.7901 31.8401 43.8701C31.8401 43.9501 31.7601 44.0201 31.6501 44.0201H28.5701C28.4701 44.0201 28.3801 43.9601 28.3801 43.8701C28.3801 43.7801 28.4701 43.7201 28.5701 43.7201Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5701 43.01H31.6601C31.7701 43.01 31.8501 43.07 31.8501 43.13C31.8501 43.2 31.7601 43.25 31.6601 43.25H28.5701C28.4701 43.25 28.3801 43.19 28.3801 43.13C28.3801 43.07 28.4701 43.01 28.5701 43.01Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6699 55.26C27.2499 55.5 26.9699 55.75 27.0099 55.87C27.0299 55.98 27.1699 56.07 27.3599 56.19C27.6599 56.4 27.8399 56.77 27.6999 56.94C27.9499 56.74 28.0999 56.44 28.0999 56.11C28.1099 55.77 27.9399 55.46 27.6699 55.26Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.68 49.6901C34.03 49.4201 32.91 49.2201 31.63 49.1801C31.19 49.1801 30.7 49.2301 30.19 49.3101C28.39 49.6101 27.02 50.3301 27.13 50.9101C27.13 50.9201 27.14 50.9501 27.14 50.9601C27.14 50.9601 26.47 49.4401 26.46 49.3901C26.34 48.7401 27.86 47.9401 29.85 47.6101C30.48 47.5001 31.09 47.4601 31.62 47.4701C32.9 47.4701 34 47.6301 34.67 47.8801L34.68 49.6901Z",
    fill: "#BF1818"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.68 49.6901C34.03 49.4201 32.91 49.2201 31.63 49.1801C31.19 49.1801 30.7 49.2301 30.19 49.3101C28.39 49.6101 27.02 50.3301 27.13 50.9101C27.13 50.9201 27.14 50.9501 27.14 50.9601C27.14 50.9601 26.47 49.4401 26.46 49.3901C26.34 48.7401 27.86 47.9401 29.85 47.6101C30.48 47.5001 31.09 47.4601 31.62 47.4701C32.9 47.4701 34 47.6301 34.67 47.8801L34.68 49.6901Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.61 51.53C27.78 51.47 27.21 51.25 27.14 50.9C27.09 50.62 27.37 50.31 27.87 50.04C28.09 50.07 28.35 50.1 28.61 50.1V51.53Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6201 50.41C32.1401 50.49 32.5301 50.62 32.7201 50.78L32.7401 50.81C32.8301 51 32.3801 51.41 31.6101 51.86L31.6201 50.41Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7401 54.38C26.6601 54.14 27.4701 53.66 28.6201 53.24C29.1501 53.05 29.5801 52.86 30.1201 52.62C31.7201 51.91 32.8901 51.11 32.7501 50.81L32.7301 50.78C32.8201 50.85 32.9501 52.3 32.9501 52.3C33.0901 52.57 32.0201 53.37 30.5501 54.07C30.0801 54.3 29.0901 54.66 28.6201 54.83C27.7801 55.12 26.9501 55.67 27.0301 55.87L26.7401 54.38Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.69 40.8001C57.69 40.8001 57.55 40.9401 57.45 40.9601C57.35 40.9801 57.23 40.8701 57.23 40.8701C57.23 40.8701 57.14 40.9601 57.03 40.9901C56.92 41.0201 56.77 40.8701 56.77 40.8701C56.77 40.8701 56.66 41.0201 56.57 41.0501C56.48 41.0801 56.36 41.0101 56.36 41.0101C56.36 41.0101 56.32 41.0801 56.24 41.1201C56.21 41.1401 56.15 41.1101 56.15 41.1101L56.04 41.0401L55.91 40.9101L55.8 40.8701C55.8 40.8701 55.75 40.7001 55.74 40.6701C55.74 40.6401 55.72 40.5601 55.72 40.5601C55.7 40.4401 55.88 40.3001 56.15 40.2401C56.3 40.2001 56.43 40.2101 56.53 40.2401C56.63 40.1501 56.86 40.0901 57.12 40.0901C57.36 40.0901 57.57 40.1401 57.68 40.2201C57.79 40.1401 58 40.0901 58.24 40.0901C58.5 40.0901 58.72 40.1501 58.83 40.2401C58.93 40.2101 59.06 40.2101 59.21 40.2401C59.47 40.3001 59.66 40.4401 59.63 40.5601C59.63 40.5601 59.62 40.6401 59.62 40.6701C59.62 40.7001 59.56 40.8701 59.56 40.8701L59.44 40.9101L59.31 41.0401L59.2 41.1101C59.2 41.1101 59.14 41.1401 59.11 41.1201C59.03 41.0801 58.99 41.0101 58.99 41.0101C58.99 41.0101 58.87 41.0901 58.78 41.0501C58.69 41.0201 58.58 40.8701 58.58 40.8701C58.58 40.8701 58.43 41.0201 58.32 40.9901C58.21 40.9701 58.12 40.8701 58.12 40.8701C58.12 40.8701 58 40.9801 57.9 40.9601C57.82 40.9501 57.69 40.8001 57.69 40.8001Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9399 40.02C57.9399 39.82 57.8299 39.66 57.6899 39.66C57.5499 39.66 57.4399 39.82 57.4399 40.02C57.4399 40.22 57.5499 40.38 57.6899 40.38C57.8199 40.39 57.9399 40.22 57.9399 40.02Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8001 40.0201C57.8001 39.8401 57.7501 39.6901 57.6801 39.6901C57.6201 39.6901 57.5601 39.8401 57.5601 40.0201C57.5601 40.2001 57.6101 40.3501 57.6801 40.3501C57.7501 40.3601 57.8001 40.2101 57.8001 40.0201Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.68 39.7701C57.7739 39.7701 57.85 39.6984 57.85 39.6101C57.85 39.5217 57.7739 39.4501 57.68 39.4501C57.5861 39.4501 57.51 39.5217 57.51 39.6101C57.51 39.6984 57.5861 39.7701 57.68 39.7701Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.73 39.4501C57.8 39.4701 57.85 39.5301 57.85 39.6001C57.85 39.6901 57.77 39.7601 57.68 39.7601C57.59 39.7601 57.51 39.6901 57.51 39.6001C57.51 39.5301 57.56 39.4601 57.64 39.4401L57.73 39.4501Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.92 39.5501V39.6601H57.46V39.5501H57.63V39.3101H57.52V39.2001H57.63V39.1001H57.74V39.2001H57.86V39.3101H57.74V39.5501H57.92Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.0485,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.38 41.53C56.34 41.42 56.28 41.33 56.28 41.33C56.64 41.22 57.14 41.16 57.7 41.16C58.26 41.16 58.76 41.23 59.12 41.33C59.12 41.33 59.08 41.4 59.02 41.5C58.99 41.56 58.95 41.65 58.95 41.65C58.63 41.55 58.21 41.5 57.69 41.5C57.17 41.5 56.68 41.57 56.42 41.66C56.42 41.65 56.4 41.59 56.38 41.53Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6901 41.9801C58.1401 41.9801 58.6301 41.9101 58.8201 41.8601C58.9401 41.8201 59.0101 41.7701 59.0001 41.7101C58.9901 41.6801 58.9701 41.6501 58.9301 41.6401C58.6601 41.5501 58.1801 41.4901 57.6901 41.4901C57.2001 41.4901 56.7201 41.5501 56.4501 41.6401C56.4201 41.6501 56.3901 41.6801 56.3801 41.7101C56.3701 41.7701 56.4401 41.8301 56.5601 41.8601C56.7401 41.9101 57.2401 41.9801 57.6901 41.9801Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.13 41.1201L59.02 41.0201C59.02 41.0201 58.91 41.0801 58.78 41.0601C58.65 41.0401 58.61 40.8801 58.61 40.8801C58.61 40.8801 58.46 41.0001 58.34 41.0001C58.22 40.9901 58.14 40.8801 58.14 40.8801C58.14 40.8801 58.01 40.9701 57.89 40.9701C57.78 40.9601 57.67 40.8201 57.67 40.8201C57.67 40.8201 57.55 40.9701 57.44 40.9801C57.33 40.9901 57.23 40.8801 57.23 40.8801C57.23 40.8801 57.18 40.9901 57.03 41.0101C56.88 41.0301 56.76 40.9001 56.76 40.9001C56.76 40.9001 56.68 41.0301 56.58 41.0701C56.48 41.1001 56.35 41.0201 56.35 41.0201C56.35 41.0201 56.33 41.0701 56.31 41.1001C56.3 41.1301 56.25 41.1401 56.25 41.1401L56.28 41.2301C56.64 41.1301 57.12 41.0601 57.67 41.0601C58.22 41.0601 58.72 41.1301 59.08 41.2301L59.13 41.1201Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6899 40.65L57.7399 40.66C57.7299 40.68 57.7299 40.7 57.7299 40.73C57.7299 40.84 57.8199 40.92 57.9399 40.92C58.0299 40.92 58.1099 40.86 58.1399 40.79C58.1399 40.79 58.1599 40.72 58.1699 40.72C58.1799 40.72 58.1799 40.8 58.1799 40.8C58.1899 40.9 58.2799 40.97 58.3799 40.97C58.4899 40.97 58.5799 40.88 58.5799 40.77C58.5799 40.76 58.5799 40.76 58.5799 40.75L58.6499 40.69L58.6799 40.77C58.6699 40.8 58.6599 40.82 58.6599 40.85C58.6599 40.95 58.7499 41.04 58.8599 41.04C58.9299 41.04 58.9899 41.01 59.0199 40.96L59.0599 40.91V40.98C59.0599 41.04 59.0899 41.1 59.1499 41.11C59.1499 41.11 59.2199 41.12 59.3199 41.04C59.4199 40.96 59.4699 40.9 59.4699 40.9L59.4799 40.98C59.4799 40.98 59.3899 41.14 59.2999 41.18C59.2499 41.21 59.1799 41.24 59.1199 41.23C59.0599 41.22 59.0199 41.17 58.9999 41.12C58.9599 41.15 58.9099 41.16 58.8499 41.16C58.7299 41.16 58.6299 41.09 58.5899 41C58.5399 41.06 58.4599 41.09 58.3799 41.09C58.2899 41.09 58.1999 41.05 58.1499 40.98C58.0999 41.03 58.0299 41.06 57.9499 41.06C57.8499 41.06 57.7599 41.01 57.6999 40.93C57.6499 41.01 57.5599 41.06 57.4499 41.06C57.3699 41.06 57.2999 41.03 57.2499 40.98C57.1999 41.04 57.1099 41.09 57.0199 41.09C56.9299 41.09 56.8599 41.05 56.7999 41C56.7599 41.09 56.6499 41.16 56.5399 41.16C56.4899 41.16 56.4399 41.15 56.3899 41.12C56.3699 41.17 56.3299 41.22 56.2599 41.23C56.1999 41.24 56.1299 41.21 56.0899 41.18C55.9999 41.13 55.8999 40.98 55.8999 40.98L55.9099 40.9C55.9099 40.9 55.9599 40.96 56.0599 41.04C56.1599 41.12 56.2299 41.11 56.2299 41.11C56.2899 41.1 56.3199 41.04 56.3199 40.98V40.91L56.3599 40.96C56.3999 41.01 56.4499 41.04 56.5199 41.04C56.6299 41.04 56.7199 40.96 56.7199 40.85C56.7199 40.82 56.7199 40.79 56.6999 40.77L56.7399 40.69L56.7999 40.75C56.7999 40.76 56.7999 40.76 56.7999 40.77C56.7999 40.88 56.8899 40.97 57.0099 40.97C57.1099 40.97 57.1999 40.9 57.2199 40.8C57.2199 40.8 57.2199 40.72 57.2299 40.72C57.2399 40.72 57.2599 40.79 57.2599 40.79C57.2899 40.87 57.3599 40.92 57.4599 40.92C57.5699 40.92 57.6699 40.83 57.6699 40.73C57.6699 40.7 57.6699 40.68 57.6599 40.66L57.6899 40.65Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6899 41.1501C57.1299 41.1501 56.6299 41.22 56.2699 41.32C56.2499 41.33 56.2199 41.3101 56.2099 41.2901C56.1999 41.2701 56.2199 41.24 56.2399 41.23C56.5999 41.12 57.1099 41.05 57.6899 41.05C58.2599 41.05 58.7799 41.12 59.1399 41.23C59.1599 41.24 59.1799 41.2601 59.1699 41.2901C59.1599 41.3101 59.1299 41.33 59.1099 41.32C58.7499 41.22 58.2399 41.1501 57.6899 41.1501Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8001 40.92C55.8001 40.92 55.7301 40.83 55.6801 40.78C55.6401 40.75 55.5601 40.72 55.5601 40.72C55.5601 40.7 55.6101 40.67 55.6701 40.67C55.7001 40.67 55.7301 40.68 55.7501 40.71L55.7601 40.67C55.7601 40.67 55.8001 40.68 55.8201 40.73C55.8401 40.78 55.8301 40.86 55.8301 40.86C55.8301 40.86 55.8101 40.91 55.8001 40.92Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1401 40.7801L56.1201 40.9001L55.8601 40.9301L55.8201 40.9101L55.8301 40.8701L56.0301 40.7101L56.1401 40.7801Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1401 40.7801L56.1201 40.9001L55.8601 40.9301L55.8201 40.9101L55.8301 40.8701L56.0301 40.7101L56.1401 40.7801Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8 40.88C55.82 40.86 55.87 40.86 55.9 40.89C55.93 40.92 55.95 40.96 55.92 40.98C55.9 41 55.85 41 55.82 40.97C55.79 40.94 55.78 40.9 55.8 40.88Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.27 40.9001C56.26 40.8701 56.27 40.8301 56.29 40.8201C56.32 40.8101 56.35 40.8401 56.36 40.8701C56.37 40.9001 56.36 40.9401 56.33 40.9501C56.32 40.9601 56.29 40.9401 56.27 40.9001Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3899 40.75L56.4799 40.84L56.7099 40.72L56.7299 40.68L56.6999 40.65L56.4399 40.63L56.3899 40.75Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3899 40.75L56.4799 40.84L56.7099 40.72L56.7299 40.68L56.6999 40.65L56.4399 40.63L56.3899 40.75Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.65 40.3301L56.53 40.4501L56.69 40.6601L56.73 40.6801L56.76 40.6501L56.81 40.4001L56.65 40.3301Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.65 40.3301L56.53 40.4501L56.69 40.6601L56.73 40.6801L56.76 40.6501L56.81 40.4001L56.65 40.3301Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.08 40.61L57.03 40.73L56.77 40.71L56.74 40.68L56.76 40.64L56.99 40.52L57.08 40.61Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.08 40.61L57.03 40.73L56.77 40.71L56.74 40.68L56.76 40.64L56.99 40.52L57.08 40.61Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8299 40.6801C56.8299 40.6301 56.7899 40.5901 56.7399 40.5901C56.6899 40.5901 56.6499 40.6301 56.6499 40.6801C56.6499 40.7301 56.6899 40.7701 56.7399 40.7701C56.7799 40.7601 56.8299 40.7201 56.8299 40.6801Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1701 40.73C57.1601 40.69 57.1801 40.66 57.2101 40.66C57.2401 40.66 57.2601 40.68 57.2701 40.72C57.2701 40.75 57.2601 40.79 57.2301 40.79C57.2001 40.79 57.1701 40.77 57.1701 40.73Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3401 40.6001L57.4101 40.7101L57.6601 40.6301L57.6901 40.6001L57.6601 40.5601L57.4101 40.4901L57.3401 40.6001Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3401 40.6001L57.4101 40.7101L57.6601 40.6301L57.6901 40.6001L57.6601 40.5601L57.4101 40.4901L57.3401 40.6001Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.69 40.2101L57.53 40.3101L57.65 40.5601L57.69 40.5901L57.73 40.5601L57.85 40.3101L57.69 40.2101Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0399 40.6001L57.9599 40.7101L57.7199 40.6301L57.6899 40.5901L57.7199 40.5601L57.9599 40.4801L58.0399 40.6001Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7801 40.59C57.7801 40.54 57.7401 40.5 57.6901 40.5C57.6401 40.5 57.6001 40.54 57.6001 40.59C57.6001 40.64 57.6401 40.68 57.6901 40.68C57.7401 40.68 57.7801 40.64 57.7801 40.59Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2101 40.73C58.2101 40.69 58.1901 40.66 58.1701 40.66C58.1401 40.66 58.1201 40.68 58.1101 40.72C58.1101 40.75 58.1201 40.79 58.1501 40.79C58.1801 40.79 58.2101 40.77 58.2101 40.73Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3 40.61L58.35 40.73L58.6101 40.71L58.64 40.68L58.62 40.64L58.39 40.52L58.3 40.61Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3 40.61L58.35 40.73L58.6101 40.71L58.64 40.68L58.62 40.64L58.39 40.52L58.3 40.61Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7201 40.3301L58.84 40.4501L58.68 40.6601L58.64 40.6801L58.6101 40.6501L58.55 40.4001L58.7201 40.3301Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7201 40.3301L58.84 40.4501L58.68 40.6601L58.64 40.6801L58.6101 40.6501L58.55 40.4001L58.7201 40.3301Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9801 40.75L58.8901 40.84L58.6601 40.72L58.6401 40.68L58.6801 40.65L58.9401 40.63L58.9801 40.75Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9801 40.75L58.8901 40.84L58.6601 40.72L58.6401 40.68L58.6801 40.65L58.9401 40.63L58.9801 40.75Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7401 40.6801C58.7401 40.6301 58.7001 40.5901 58.6501 40.5901C58.6001 40.5901 58.5601 40.6301 58.5601 40.6801C58.5601 40.7301 58.6001 40.7701 58.6501 40.7701C58.7001 40.7601 58.7401 40.7201 58.7401 40.6801Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1101 40.9001C59.1201 40.8701 59.1101 40.8301 59.0901 40.8201C59.0601 40.8101 59.0301 40.8401 59.0201 40.8701C59.0101 40.9001 59.0201 40.9401 59.0501 40.9501C59.0601 40.9601 59.0901 40.9401 59.1101 40.9001Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5501 40.92C59.5501 40.92 59.6201 40.83 59.6701 40.78C59.7101 40.75 59.7901 40.72 59.7901 40.72C59.7901 40.7 59.7401 40.67 59.6801 40.67C59.6501 40.67 59.6201 40.68 59.6001 40.71L59.5901 40.67C59.5901 40.67 59.5501 40.68 59.5201 40.73C59.5001 40.78 59.5101 40.86 59.5101 40.86C59.5101 40.86 59.5301 40.91 59.5501 40.92Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2 40.7801L59.22 40.9001L59.4799 40.9301L59.52 40.9101L59.5099 40.8701L59.32 40.7101L59.2 40.7801Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2 40.7801L59.22 40.9001L59.4799 40.9301L59.52 40.9101L59.5099 40.8701L59.32 40.7101L59.2 40.7801Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5501 40.88C59.5301 40.86 59.4901 40.86 59.4501 40.89C59.4201 40.92 59.4001 40.96 59.4301 40.98C59.4501 41 59.5001 41 59.5301 40.97C59.5601 40.94 59.5701 40.9 59.5501 40.88Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7599 40.7401C55.7499 40.7401 55.74 40.7301 55.74 40.7301C55.72 40.6801 55.7 40.6101 55.7 40.5201C55.7 40.2101 55.94 39.9701 56.24 39.9701C56.33 39.9701 56.4599 40.0001 56.5499 40.0801C56.5599 40.0901 56.5599 40.1001 56.5499 40.1101C56.5399 40.1201 56.53 40.1201 56.52 40.1101C56.45 40.0401 56.33 40.0101 56.24 40.0101C55.96 40.0101 55.74 40.2401 55.74 40.5201C55.74 40.6001 55.7599 40.6701 55.7799 40.7101C55.7799 40.7301 55.7799 40.7401 55.7599 40.7401Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.68 40.48C55.68 40.44 55.64 40.4 55.6 40.4C55.55 40.4 55.52 40.44 55.52 40.48C55.52 40.52 55.56 40.56 55.6 40.56C55.65 40.56 55.68 40.53 55.68 40.48Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7201 40.1901C55.7201 40.1501 55.6801 40.1101 55.6401 40.1101C55.5901 40.1101 55.5601 40.1401 55.5601 40.1901C55.5601 40.2301 55.6001 40.2701 55.6401 40.2701C55.6801 40.2701 55.7201 40.2301 55.7201 40.1901Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9 39.97C55.9 39.93 55.86 39.89 55.82 39.89C55.77 39.89 55.74 39.93 55.74 39.97C55.74 40.01 55.78 40.05 55.82 40.05C55.87 40.05 55.9 40.01 55.9 39.97Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.15 39.85C56.15 39.81 56.11 39.77 56.07 39.77C56.02 39.77 55.99 39.81 55.99 39.85C55.99 39.89 56.03 39.93 56.07 39.93C56.12 39.93 56.15 39.89 56.15 39.85Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.42 39.86C56.42 39.82 56.38 39.78 56.34 39.78C56.29 39.78 56.26 39.81 56.26 39.86C56.26 39.9 56.3 39.94 56.34 39.94C56.38 39.94 56.42 39.9 56.42 39.86Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5799 40.1901C56.5799 40.1501 56.5399 40.1101 56.4999 40.1101C56.4499 40.1101 56.4199 40.1401 56.4199 40.1901C56.4199 40.2301 56.4599 40.2701 56.4999 40.2701C56.5499 40.2701 56.5799 40.2301 56.5799 40.1901Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.63 39.9101C56.63 39.8701 56.59 39.8301 56.55 39.8301C56.5 39.8301 56.47 39.8701 56.47 39.9101C56.47 39.9501 56.51 39.9901 56.55 39.9901C56.59 39.9901 56.63 39.9501 56.63 39.9101Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8399 39.74C56.8399 39.7 56.7999 39.66 56.7599 39.66C56.7099 39.66 56.6799 39.7 56.6799 39.74C56.6799 39.78 56.7199 39.82 56.7599 39.82C56.7999 39.81 56.8399 39.78 56.8399 39.74Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0999 39.6501C57.0999 39.6101 57.0599 39.5701 57.0199 39.5701C56.9699 39.5701 56.9399 39.6101 56.9399 39.6501C56.9399 39.6901 56.9799 39.7301 57.0199 39.7301C57.0599 39.7301 57.0999 39.7001 57.0999 39.6501Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.37 39.6601C57.37 39.6201 57.33 39.5801 57.29 39.5801C57.24 39.5801 57.21 39.6201 57.21 39.6601C57.21 39.7001 57.25 39.7401 57.29 39.7401C57.33 39.7401 57.37 39.7101 57.37 39.6601Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.16 39.6601C58.16 39.6201 58.12 39.5801 58.08 39.5801C58.03 39.5801 58 39.6201 58 39.6601C58 39.7001 58.04 39.7401 58.08 39.7401C58.12 39.7401 58.16 39.7101 58.16 39.6601Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.43 39.6501C58.43 39.6101 58.39 39.5701 58.35 39.5701C58.3 39.5701 58.27 39.6101 58.27 39.6501C58.27 39.6901 58.31 39.7301 58.35 39.7301C58.39 39.7301 58.43 39.7001 58.43 39.6501Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.69 39.74C58.69 39.7 58.65 39.66 58.61 39.66C58.56 39.66 58.53 39.7 58.53 39.74C58.53 39.78 58.57 39.82 58.61 39.82C58.65 39.81 58.69 39.78 58.69 39.74Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.89 39.9101C58.89 39.8701 58.85 39.8301 58.81 39.8301C58.76 39.8301 58.73 39.8701 58.73 39.9101C58.73 39.9501 58.77 39.9901 58.81 39.9901C58.86 39.9901 58.89 39.9501 58.89 39.9101Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.94 40.1901C58.94 40.1501 58.9 40.1101 58.86 40.1101C58.81 40.1101 58.78 40.1401 58.78 40.1901C58.78 40.2301 58.82 40.2701 58.86 40.2701C58.9 40.2701 58.94 40.2301 58.94 40.1901Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0999 39.86C59.0999 39.82 59.0599 39.78 59.0199 39.78C58.9699 39.78 58.9399 39.81 58.9399 39.86C58.9399 39.9 58.9799 39.94 59.0199 39.94C59.0699 39.94 59.0999 39.9 59.0999 39.86Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.37 39.85C59.37 39.81 59.33 39.77 59.29 39.77C59.24 39.77 59.21 39.81 59.21 39.85C59.21 39.89 59.25 39.93 59.29 39.93C59.33 39.93 59.37 39.89 59.37 39.85Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.62 39.97C59.62 39.93 59.58 39.89 59.54 39.89C59.49 39.89 59.46 39.93 59.46 39.97C59.46 40.01 59.5 40.05 59.54 40.05C59.58 40.05 59.62 40.01 59.62 39.97Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8099 40.1901C59.8099 40.1501 59.7699 40.1101 59.7299 40.1101C59.6799 40.1101 59.6499 40.1401 59.6499 40.1901C59.6499 40.2301 59.6899 40.2701 59.7299 40.2701C59.7699 40.2701 59.8099 40.2301 59.8099 40.1901Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8399 40.48C59.8399 40.44 59.7999 40.4 59.7599 40.4C59.7099 40.4 59.6799 40.44 59.6799 40.48C59.6799 40.52 59.7199 40.56 59.7599 40.56C59.7999 40.56 59.8399 40.53 59.8399 40.48Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.28 41.5201L56.33 41.4301L56.45 41.4501L56.38 41.5601L56.28 41.5201Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7901 41.43L56.6601 41.4501C56.6301 41.4501 56.5901 41.4301 56.5901 41.4001C56.5901 41.3701 56.6101 41.34 56.6401 41.34L56.7701 41.32L56.9001 41.3C56.9301 41.3 56.9601 41.32 56.9701 41.35C56.9701 41.38 56.9501 41.41 56.9201 41.42L56.7901 41.43Z",
    fill: "#419846"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7901 41.43L56.6601 41.4501C56.6301 41.4501 56.5901 41.4301 56.5901 41.4001C56.5901 41.3701 56.6101 41.34 56.6401 41.34L56.7701 41.32L56.9001 41.3C56.9301 41.3 56.9601 41.32 56.9701 41.35C56.9701 41.38 56.9501 41.41 56.9201 41.42L56.7901 41.43Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3099 41.34C57.3099 41.3 57.2699 41.26 57.2299 41.26C57.1799 41.26 57.1499 41.29 57.1499 41.34C57.1499 41.38 57.1899 41.42 57.2299 41.42C57.2699 41.41 57.3099 41.38 57.3099 41.34Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6899 41.37H57.5099C57.4799 41.37 57.45 41.34 57.45 41.31C57.45 41.28 57.4799 41.25 57.5099 41.25H57.8699C57.8999 41.25 57.93 41.28 57.93 41.31C57.93 41.34 57.8999 41.37 57.8699 41.37H57.6899Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2301 41.34C58.2301 41.3 58.1901 41.26 58.1501 41.26C58.1101 41.26 58.0701 41.29 58.0701 41.34C58.0701 41.38 58.1101 41.42 58.1501 41.42C58.1901 41.41 58.2301 41.38 58.2301 41.34Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5799 41.43L58.7099 41.4501C58.7399 41.4501 58.7699 41.4301 58.7799 41.4001C58.7799 41.3701 58.7599 41.34 58.7299 41.34L58.5999 41.32L58.4699 41.3C58.4399 41.3 58.4099 41.32 58.3999 41.35C58.3899 41.38 58.4199 41.41 58.4499 41.42L58.5799 41.43Z",
    fill: "#419846"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5799 41.43L58.7099 41.4501C58.7399 41.4501 58.7699 41.4301 58.7799 41.4001C58.7799 41.3701 58.7599 41.34 58.7299 41.34L58.5999 41.32L58.4699 41.3C58.4399 41.3 58.4099 41.32 58.3999 41.35C58.3899 41.38 58.4199 41.41 58.4499 41.42L58.5799 41.43Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0799 41.5301L59.0299 41.4301L58.9099 41.4401L58.9699 41.5501L59.0799 41.5301Z",
    fill: "#BF1818"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0799 41.5301L59.0299 41.4301L58.9099 41.4401L58.9699 41.5501L59.0799 41.5301Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.68 41.8601C57.23 41.8601 56.82 41.8201 56.52 41.7401C56.83 41.6601 57.23 41.6101 57.68 41.6101C58.13 41.6101 58.54 41.6601 58.85 41.7401C58.54 41.8201 58.13 41.8601 57.68 41.8601Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.89 41.85V41.63M57.79 41.86V41.63M57.71 41.86V41.63",
    stroke: "#020203",
    strokeWidth: 0.001595,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6399 41.86V41.63",
    stroke: "#020203",
    strokeWidth: 0.003233,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5801 41.86V41.63",
    stroke: "#020203",
    strokeWidth: 0.004829,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.52 41.86V41.63",
    stroke: "#020203",
    strokeWidth: 0.006467,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.46 41.86V41.63",
    stroke: "#020203",
    strokeWidth: 0.006467,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4099 41.86V41.63",
    stroke: "#020203",
    strokeWidth: 0.008062,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3 41.85V41.64M57.35 41.85V41.63",
    stroke: "#020203",
    strokeWidth: 0.009722,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.21 41.84V41.64M57.26 41.85V41.64",
    stroke: "#020203",
    strokeWidth: 0.0113,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0801 41.83V41.66M57.1301 41.83V41.65M57.1701 41.84V41.65",
    stroke: "#020203",
    strokeWidth: 0.013,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.04 41.83V41.66",
    stroke: "#020203",
    strokeWidth: 0.0145,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 41.82V41.66",
    stroke: "#020203",
    strokeWidth: 0.0162,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.96 41.82V41.67",
    stroke: "#020203",
    strokeWidth: 0.0178,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8701 41.8001V41.6901M56.9101 41.8101V41.6801",
    stroke: "#020203",
    strokeWidth: 0.0194,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8201 41.7901V41.6901",
    stroke: "#020203",
    strokeWidth: 0.0194,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.78 41.7801V41.7001",
    stroke: "#020203",
    strokeWidth: 0.021,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.73 41.7701V41.7001",
    stroke: "#020203",
    strokeWidth: 0.0226,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6799 41.7701V41.7201",
    stroke: "#020203",
    strokeWidth: 0.0242,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6399 41.7601V41.7401",
    stroke: "#020203",
    strokeWidth: 0.0291,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5701 61.1801C60.2901 61.1801 60.0301 61.1201 59.8401 61.0201C59.6601 60.9301 59.4001 60.8701 59.1301 60.8701C58.8501 60.8701 58.5901 60.9301 58.4101 61.0201C58.2201 61.1201 57.9701 61.1801 57.6901 61.1801C57.4101 61.1801 57.1501 61.1101 56.9601 61.0101C56.7801 60.9201 56.5301 60.8601 56.2601 60.8601C55.9801 60.8601 55.7301 60.9101 55.5501 61.0101C55.3601 61.1101 55.1001 61.1701 54.8201 61.1701V61.6201C55.1001 61.6201 55.3601 61.5501 55.5501 61.4601C55.7301 61.3601 55.9801 61.3101 56.2601 61.3101C56.5301 61.3101 56.7801 61.3701 56.9601 61.4601C57.1501 61.5601 57.4001 61.6301 57.6901 61.6301C57.9701 61.6301 58.2301 61.5701 58.4101 61.4701C58.6001 61.3701 58.8501 61.3101 59.1301 61.3101C59.4101 61.3101 59.6601 61.3701 59.8401 61.4601C60.0301 61.5601 60.2801 61.6201 60.5601 61.6201L60.5701 61.1801Z",
    fill: "#3955A2",
    stroke: "#020203",
    strokeWidth: 0.0986,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5701 61.6301C60.2901 61.6301 60.0301 61.5701 59.8401 61.4701C59.6601 61.3801 59.4001 61.3201 59.1301 61.3201C58.8501 61.3201 58.5901 61.3801 58.4101 61.4701C58.2201 61.5701 57.9701 61.6301 57.6901 61.6301C57.4101 61.6301 57.1501 61.5601 56.9601 61.4601C56.7801 61.3701 56.5301 61.3101 56.2601 61.3101C55.9801 61.3101 55.7301 61.3601 55.5501 61.4601C55.3601 61.5601 55.1001 61.6201 54.8201 61.6201V62.0701C55.1001 62.0701 55.3601 62.0001 55.5501 61.9101C55.7301 61.8101 55.9801 61.7601 56.2601 61.7601C56.5301 61.7601 56.7801 61.8201 56.9601 61.9101C57.1501 62.0101 57.4001 62.0801 57.6901 62.0801C57.9701 62.0801 58.2301 62.0201 58.4101 61.9201C58.6001 61.8201 58.8501 61.7701 59.1301 61.7701C59.4101 61.7701 59.6601 61.8301 59.8401 61.9201C60.0301 62.0201 60.2801 62.0801 60.5601 62.0801L60.5701 61.6301Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5701 62.08C60.2901 62.08 60.0301 62.02 59.8401 61.92C59.6601 61.82 59.4001 61.77 59.1301 61.77C58.8501 61.77 58.5901 61.83 58.4101 61.92C58.2201 62.02 57.9701 62.08 57.6901 62.08C57.4101 62.08 57.1501 62.01 56.9601 61.91C56.7801 61.82 56.5301 61.76 56.2601 61.76C55.9801 61.76 55.7301 61.81 55.5501 61.91C55.3601 62.01 55.1001 62.07 54.8201 62.07V62.51C55.1001 62.51 55.3601 62.45 55.5501 62.35C55.7301 62.26 55.9801 62.2 56.2601 62.2C56.5301 62.2 56.7801 62.26 56.9601 62.35C57.1501 62.45 57.4001 62.52 57.6901 62.52C57.9701 62.52 58.2301 62.46 58.4101 62.36C58.6001 62.26 58.8501 62.21 59.1301 62.21C59.4101 62.21 59.6601 62.27 59.8401 62.36C60.0301 62.46 60.2801 62.52 60.5601 62.52L60.5701 62.08Z",
    fill: "#3955A2",
    stroke: "#020203",
    strokeWidth: 0.0986,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5701 62.9701C60.2901 62.9701 60.0401 62.9101 59.8501 62.8101C59.6701 62.7201 59.4101 62.6601 59.1401 62.6601C58.8601 62.6601 58.6001 62.7201 58.4201 62.8101C58.2301 62.9101 57.9801 62.9701 57.7001 62.9701C57.4201 62.9701 57.1601 62.9001 56.9701 62.8001C56.7901 62.7101 56.5401 62.6501 56.2701 62.6501C55.9901 62.6501 55.7401 62.7001 55.5601 62.8001C55.3701 62.9001 55.1101 62.9601 54.8301 62.9601V62.5201C55.1101 62.5201 55.3701 62.4501 55.5601 62.3501C55.7401 62.2601 55.9901 62.2001 56.2701 62.2001C56.5401 62.2001 56.7901 62.2601 56.9701 62.3501C57.1601 62.4501 57.4101 62.5201 57.7001 62.5201C57.9801 62.5201 58.2401 62.4601 58.4201 62.3601C58.6101 62.2601 58.8601 62.2101 59.1401 62.2101C59.4201 62.2101 59.6701 62.2701 59.8501 62.3601C60.0401 62.4601 60.2901 62.5201 60.5801 62.5201L60.5701 62.9701Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5701 62.9701C60.2901 62.9701 60.0401 62.9101 59.8501 62.8101C59.6701 62.7201 59.4101 62.6601 59.1401 62.6601C58.8601 62.6601 58.6001 62.7201 58.4201 62.8101C58.2301 62.9101 57.9801 62.9701 57.7001 62.9701C57.4201 62.9701 57.1601 62.9001 56.9701 62.8001C56.7901 62.7101 56.5401 62.6501 56.2701 62.6501C55.9901 62.6501 55.7401 62.7001 55.5601 62.8001C55.3701 62.9001 55.1101 62.9601 54.8301 62.9601V62.5201C55.1101 62.5201 55.3701 62.4501 55.5601 62.3501C55.7401 62.2601 55.9901 62.2001 56.2701 62.2001C56.5401 62.2001 56.7901 62.2601 56.9701 62.3501C57.1601 62.4501 57.4101 62.5201 57.7001 62.5201C57.9801 62.5201 58.2401 62.4601 58.4201 62.3601C58.6101 62.2601 58.8601 62.2101 59.1401 62.2101C59.4201 62.2101 59.6701 62.2701 59.8501 62.3601C60.0401 62.4601 60.2901 62.5201 60.5801 62.5201L60.5701 62.9701Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5701 63.41C60.2901 63.41 60.0401 63.35 59.8501 63.25C59.6701 63.15 59.4101 63.1 59.1401 63.1C58.8601 63.1 58.6001 63.16 58.4201 63.25C58.2301 63.35 57.9801 63.41 57.7001 63.41C57.4201 63.41 57.1601 63.34 56.9701 63.24C56.7901 63.15 56.5401 63.09 56.2701 63.09C55.9901 63.09 55.7401 63.15 55.5601 63.24C55.3701 63.34 55.1101 63.4 54.8301 63.4V62.96C55.1101 62.96 55.3701 62.89 55.5601 62.79C55.7401 62.69 55.9901 62.64 56.2701 62.64C56.5401 62.64 56.7901 62.7 56.9701 62.79C57.1601 62.89 57.4101 62.96 57.7001 62.96C57.9801 62.96 58.2401 62.9 58.4201 62.8C58.6101 62.7 58.8601 62.65 59.1401 62.65C59.4201 62.65 59.6701 62.71 59.8501 62.8C60.0401 62.9 60.2901 62.96 60.5801 62.96L60.5701 63.41Z",
    fill: "#3955A2",
    stroke: "#020203",
    strokeWidth: 0.0986,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0701 59.3501C56.0801 59.3901 56.1001 59.4201 56.1001 59.4701C56.1001 59.7401 55.8601 59.9601 55.5801 59.9601H59.8201C59.5301 59.9601 59.3001 59.7401 59.3001 59.4701C59.3001 59.4301 59.3101 59.3901 59.3201 59.3501C59.3001 59.3601 59.2701 59.3601 59.2401 59.3601H56.1601C56.1201 59.3701 56.0901 59.3601 56.0701 59.3501Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1399 59.0801H59.22C59.33 59.0801 59.41 59.1401 59.41 59.2201C59.41 59.3001 59.33 59.3701 59.22 59.3701H56.1399C56.0399 59.3701 55.95 59.3001 55.95 59.2201C55.96 59.1401 56.0399 59.0801 56.1399 59.0801Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8101 59.9601H55.5801V61.0401H59.8101V59.9601Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1799 44.1801H56.1799V58.9001H59.1799V44.1801Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3201 44.2001V58.8901M58.6601 44.2001V58.8901",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.13 55.26C60.55 55.5 60.83 55.75 60.79 55.87C60.77 55.98 60.6299 56.07 60.4399 56.19C60.1399 56.4 59.9599 56.77 60.0999 56.94C59.8499 56.74 59.7 56.44 59.7 56.11C59.7 55.77 59.87 55.46 60.13 55.26Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1201 49.6901C53.7701 49.4201 54.8901 49.2201 56.1701 49.1801C56.6101 49.1801 57.1001 49.2301 57.6101 49.3101C59.4101 49.6101 60.7801 50.3301 60.6701 50.9101C60.6701 50.9201 60.6601 50.9501 60.6601 50.9601C60.6601 50.9601 61.3301 49.4401 61.3401 49.3901C61.4601 48.7401 59.9401 47.9401 57.9501 47.6101C57.3201 47.5001 56.7101 47.4601 56.1801 47.4701C54.9001 47.4701 53.7901 47.6301 53.1201 47.8801V49.6901Z",
    fill: "#BF1818"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1201 49.6901C53.7701 49.4201 54.8901 49.2201 56.1701 49.1801C56.6101 49.1801 57.1001 49.2301 57.6101 49.3101C59.4101 49.6101 60.7801 50.3301 60.6701 50.9101C60.6701 50.9201 60.6601 50.9501 60.6601 50.9601C60.6601 50.9601 61.3301 49.4401 61.3401 49.3901C61.4601 48.7401 59.9401 47.9401 57.9501 47.6101C57.3201 47.5001 56.7101 47.4601 56.1801 47.4701C54.9001 47.4701 53.7901 47.6301 53.1201 47.8801V49.6901Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1999 51.53C60.0299 51.47 60.5999 51.25 60.6699 50.9C60.7199 50.62 60.4399 50.31 59.9299 50.04C59.7099 50.07 59.4499 50.1 59.1899 50.1L59.1999 51.53Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.19 50.41C55.67 50.49 55.28 50.62 55.08 50.78L55.06 50.81C54.97 51 55.42 51.41 56.19 51.86V50.41Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.07 54.38C61.15 54.14 60.34 53.66 59.19 53.24C58.67 53.05 58.23 52.86 57.7 52.62C56.1 51.91 54.93 51.11 55.07 50.81L55.09 50.78C55.01 50.85 54.87 52.3 54.87 52.3C54.73 52.57 55.8 53.37 57.27 54.07C57.74 54.3 58.73 54.66 59.2 54.83C60.04 55.12 60.87 55.67 60.79 55.87L61.07 54.38Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4001 48.9801C28.7701 48.8501 29.0101 48.6901 28.8901 48.4001C28.8101 48.2101 28.6301 48.1801 28.3401 48.2801L27.8401 48.4601L28.2901 49.5701C28.3401 49.5501 28.3901 49.5301 28.4401 49.5101C28.4901 49.4901 28.5501 49.4801 28.6001 49.4601L28.4001 48.9801ZM28.1801 48.4401L28.3101 48.3901C28.4201 48.3501 28.5301 48.4101 28.5901 48.5401C28.6301 48.6401 28.6201 48.7501 28.5001 48.8301C28.4601 48.8501 28.4101 48.8701 28.3701 48.8901L28.1801 48.4401Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.58 47.9801C29.53 48.0001 29.47 48.0101 29.42 48.0201C29.37 48.0301 29.31 48.0401 29.26 48.0401L29.52 49.2001L30.33 49.0401C30.32 49.0201 30.31 48.9901 30.3 48.9701C30.29 48.9401 30.29 48.9201 30.29 48.8901C30.15 48.9301 29.99 48.9801 29.81 49.0101L29.58 47.9801Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2001 48.98C31.3501 48.56 31.5401 48.16 31.7201 47.75C31.6901 47.76 31.6501 47.76 31.6201 47.76C31.5901 47.76 31.5501 47.76 31.5201 47.76C31.4201 48.06 31.3001 48.35 31.1701 48.65C31.0201 48.37 30.8501 48.1 30.7201 47.82C30.6601 47.83 30.5901 47.84 30.5301 47.84C30.4701 47.84 30.4001 47.84 30.3401 47.84C30.5701 48.22 30.8001 48.6 31.0101 48.99C31.0401 48.98 31.0701 48.98 31.1001 48.97C31.1401 48.97 31.1701 48.97 31.2001 48.98Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.89 48.0801C32.92 48.0201 32.95 47.9701 32.98 47.9201C32.94 47.8801 32.8 47.8201 32.65 47.8001C32.32 47.7701 32.13 47.9101 32.11 48.1101C32.06 48.5301 32.72 48.4901 32.69 48.7701C32.68 48.8901 32.55 48.9401 32.42 48.9201C32.27 48.9101 32.16 48.8201 32.14 48.7001H32.1C32.08 48.7701 32.05 48.8401 32.01 48.9101C32.11 48.9701 32.23 49.0101 32.35 49.0201C32.69 49.0601 32.95 48.9201 32.97 48.7001C33.01 48.3001 32.35 48.2801 32.37 48.0501C32.38 47.9501 32.46 47.8901 32.63 47.9001C32.75 47.9101 32.83 47.9801 32.86 48.0801H32.89Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 49.04C55.11 48.61 55.26 48.19 55.4 47.77C55.37 47.78 55.34 47.79 55.3 47.79C55.27 47.8 55.23 47.8 55.2 47.8C55.13 48.1 55.04 48.41 54.94 48.71C54.76 48.44 54.57 48.19 54.42 47.92C54.36 47.93 54.29 47.95 54.23 47.96C54.17 47.97 54.1 47.97 54.04 47.98C54.31 48.34 54.57 48.7 54.82 49.07C54.85 49.06 54.88 49.05 54.91 49.05C54.94 49.04 54.97 49.04 55 49.04Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.14 47.78C56.09 47.78 56.03 47.79 55.98 47.79C55.92 47.79 55.87 47.78 55.82 47.78L55.8 48.96L56.6301 48.98C56.6301 48.96 56.62 48.93 56.62 48.9C56.62 48.88 56.6301 48.85 56.6301 48.83C56.4801 48.84 56.3201 48.85 56.1301 48.84L56.14 47.78Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.44 47.97C57.57 47.98 57.7 48 57.83 48.03C57.83 48.01 57.82 47.98 57.83 47.95C57.83 47.93 57.84 47.9 57.85 47.88L56.73 47.79C56.73 47.82 56.74 47.84 56.73 47.86C56.73 47.89 56.72 47.91 56.71 47.93C56.82 47.93 56.96 47.93 57.12 47.94L57.02 49.01C57.07 49.01 57.13 49.01 57.18 49.02C57.24 49.02 57.29 49.03 57.34 49.04L57.44 47.97Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8999 49.1401C57.9499 49.1501 58.0099 49.1601 58.0599 49.1701C58.1099 49.1801 58.1599 49.2001 58.2199 49.2101L58.3499 48.6701H58.3599C58.3899 48.7501 58.4299 48.8401 58.4499 48.8901L58.6199 49.3001C58.6899 49.3101 58.7499 49.3201 58.8099 49.3301C58.8799 49.3501 58.9399 49.3601 58.9999 49.3801L58.9399 49.2601C58.8499 49.0801 58.7599 48.8901 58.6799 48.7001C58.8899 48.7101 59.0499 48.6301 59.0899 48.4701C59.1199 48.3601 59.0699 48.2601 58.9599 48.1901C58.8799 48.1301 58.7199 48.1001 58.6199 48.0801L58.1699 47.9801L57.8999 49.1401ZM58.4799 48.1401C58.6099 48.1701 58.7699 48.1901 58.7699 48.3401C58.7699 48.3801 58.7599 48.4101 58.7599 48.4301C58.7199 48.6001 58.5899 48.6601 58.3699 48.6001L58.4799 48.1401Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0401 49.5C60.0301 49.63 60.0101 49.75 59.9801 49.89C60.0401 49.92 60.0901 49.94 60.1501 49.97C60.2001 50 60.2501 50.03 60.3101 50.07L60.4201 48.73C60.3901 48.72 60.3701 48.71 60.3401 48.7C60.3201 48.69 60.2901 48.67 60.2701 48.66L59.0901 49.41C59.1201 49.42 59.1501 49.44 59.1801 49.46C59.2101 49.48 59.2401 49.49 59.2701 49.51C59.3701 49.43 59.4701 49.36 59.5901 49.27L60.0401 49.5ZM59.7001 49.19L60.0901 48.94L60.0401 49.38L59.7001 49.19Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7901 33.8301C45.0201 33.8301 46.1101 34.0101 46.8201 34.2901C47.2301 34.4701 47.7701 34.6101 48.3701 34.6901C48.8301 34.7501 49.2601 34.7601 49.6401 34.7301C50.1401 34.7201 50.8701 34.8701 51.6001 35.1901C52.2001 35.4601 52.7101 35.7801 53.0401 36.1001L52.7501 36.3601L52.6701 37.0901L51.8701 38.0001L51.4701 38.3401L50.5301 39.0901L50.0501 39.1301L49.9001 39.5401L43.8201 38.8301L37.7201 39.5401L37.5701 39.1301L37.0901 39.0901L36.1501 38.3401L35.7501 38.0001L34.9601 37.0901L34.8801 36.3601L34.5901 36.1001C34.9301 35.7901 35.4301 35.4601 36.0301 35.1901C36.7601 34.8701 37.4901 34.7201 37.9901 34.7301C38.3701 34.7601 38.8001 34.7501 39.2601 34.6901C39.8601 34.6101 40.4101 34.4701 40.8101 34.2901C41.5301 34.0201 42.5601 33.8301 43.7901 33.8301Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2899 35.44L39.5499 35.65L39.9299 35.02C39.5099 34.76 39.2299 34.32 39.2299 33.82C39.2299 33.76 39.2299 33.71 39.2399 33.65C39.2799 32.85 40.2599 32.19 41.4899 32.19C42.1299 32.19 42.7199 32.37 43.1199 32.65C43.1299 32.53 43.1399 32.42 43.1599 32.31C42.7099 32.05 42.1299 31.89 41.4899 31.89C40.0699 31.89 38.9499 32.7 38.8999 33.66C38.8899 33.72 38.8899 33.77 38.8899 33.83C38.8899 34.34 39.1199 34.8 39.4899 35.12L39.2899 35.44Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.31 35.45C38.82 35.09 38.52 34.59 38.52 34.05C38.52 33.43 38.93 32.87 39.55 32.5C39.17 32.81 38.93 33.21 38.9 33.65C38.89 33.71 38.89 33.76 38.89 33.82C38.89 34.33 39.12 34.79 39.49 35.11L39.31 35.45Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.31 35.45C38.82 35.09 38.52 34.59 38.52 34.05C38.52 33.43 38.93 32.87 39.55 32.5C39.17 32.81 38.93 33.21 38.9 33.65C38.89 33.71 38.89 33.76 38.89 33.82C38.89 34.33 39.12 34.79 39.49 35.11L39.31 35.45Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0201 36.0801C34.7501 35.7801 34.5801 35.3801 34.5801 34.9501C34.5801 34.6901 34.6401 34.4401 34.7501 34.2201C35.1401 33.4101 36.3801 32.8201 37.8501 32.8201C38.2501 32.8201 38.6301 32.8601 38.9801 32.9401C38.9001 33.0301 38.8401 33.1201 38.7801 33.2101C38.4901 33.1501 38.1701 33.1201 37.8501 33.1201C36.5101 33.1201 35.3801 33.6401 35.0601 34.3501C34.9701 34.5301 34.9201 34.7301 34.9201 34.9401C34.9201 35.3701 35.1201 35.7501 35.4401 36.0201L34.9501 36.8201L34.6901 36.6101L35.0201 36.0801Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.52 33.42C35.17 33.64 34.9 33.92 34.75 34.22C34.64 34.44 34.58 34.69 34.58 34.95C34.58 35.38 34.75 35.78 35.02 36.08L34.72 36.56C34.44 36.2 34.27 35.77 34.27 35.32C34.27 34.55 34.77 33.87 35.52 33.42Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8601 31.7201C44.1901 31.7201 44.4701 31.9301 44.5301 32.2201C44.5701 32.4801 44.6001 32.7601 44.6101 33.0701C44.6101 33.1001 44.6101 33.1301 44.6101 33.1701C44.6101 33.2101 44.6201 33.2501 44.6201 33.2801C44.6301 33.9301 44.7201 34.5001 44.8501 34.8601L43.8601 35.8101L42.8601 34.8601C42.9901 34.5101 43.0901 33.9401 43.1001 33.2801C43.1001 33.2401 43.1101 33.2001 43.1101 33.1701C43.1101 33.1401 43.1101 33.1101 43.1101 33.0701C43.1101 32.7601 43.1401 32.4701 43.1801 32.2201C43.2401 31.9301 43.5301 31.7201 43.8601 31.7201Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.86 32.03C44.03 32.03 44.17 32.14 44.21 32.29C44.25 32.53 44.28 32.81 44.28 33.1C44.28 33.13 44.28 33.16 44.28 33.19C44.28 33.23 44.29 33.26 44.29 33.3C44.3 33.91 44.39 34.46 44.51 34.79L43.86 35.41L43.21 34.79C43.33 34.46 43.42 33.92 43.43 33.3C43.43 33.26 43.44 33.23 43.44 33.19C43.44 33.16 43.44 33.13 43.44 33.1C43.45 32.81 43.47 32.53 43.51 32.29C43.54 32.13 43.69 32.03 43.86 32.03Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.42 35.44L48.16 35.65L47.78 35.02C48.2 34.76 48.48 34.32 48.48 33.82C48.48 33.76 48.48 33.71 48.47 33.65C48.43 32.85 47.45 32.19 46.21 32.19C45.57 32.19 44.99 32.37 44.58 32.65C44.57 32.53 44.56 32.42 44.54 32.31C44.99 32.05 45.57 31.89 46.21 31.89C47.64 31.89 48.75 32.7 48.8 33.66C48.81 33.72 48.81 33.77 48.81 33.83C48.81 34.34 48.57 34.8 48.21 35.12L48.42 35.44Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3999 35.45C48.8899 35.09 49.1899 34.59 49.1899 34.05C49.1899 33.43 48.7799 32.87 48.1599 32.5C48.5399 32.81 48.7799 33.21 48.8099 33.65C48.8199 33.71 48.8199 33.76 48.8199 33.82C48.8199 34.33 48.5799 34.79 48.2199 35.11L48.3999 35.45Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3999 35.45C48.8899 35.09 49.1899 34.59 49.1899 34.05C49.1899 33.43 48.7799 32.87 48.1599 32.5C48.5399 32.81 48.7799 33.21 48.8099 33.65C48.8199 33.71 48.8199 33.76 48.8199 33.82C48.8199 34.33 48.5799 34.79 48.2199 35.11L48.3999 35.45Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.69 36.0801C52.96 35.7801 53.13 35.3801 53.13 34.9501C53.13 34.6901 53.07 34.4401 52.96 34.2201C52.56 33.4101 51.33 32.8201 49.86 32.8201C49.46 32.8201 49.08 32.8601 48.72 32.9401C48.8 33.0301 48.86 33.1201 48.92 33.2101C49.21 33.1501 49.53 33.1201 49.86 33.1201C51.2 33.1201 52.33 33.6401 52.65 34.3501C52.74 34.5301 52.78 34.7301 52.78 34.9401C52.78 35.3701 52.58 35.7501 52.26 36.0201L52.75 36.8201L53.01 36.6101L52.69 36.0801Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2 33.42C52.55 33.64 52.82 33.92 52.97 34.22C53.08 34.44 53.1399 34.69 53.1399 34.95C53.1399 35.38 52.97 35.78 52.7 36.08L53 36.56C53.28 36.2 53.45 35.77 53.45 35.32C53.43 34.55 52.94 33.87 52.2 33.42Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.68 30.9901C44.68 30.5601 44.31 30.2101 43.86 30.2101C43.41 30.2101 43.04 30.5601 43.04 30.9901C43.04 31.4201 43.41 31.7701 43.86 31.7701C44.31 31.7601 44.68 31.4101 44.68 30.9901Z",
    fill: "#3955A2",
    stroke: "#020203",
    strokeWidth: 0.0986,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6501 28.8101V29.2301H43.2001V29.6501H43.6501V30.2301V30.8701H43.09C43.09 30.9101 43.05 30.9401 43.05 30.9801C43.05 31.0901 43.0701 31.1901 43.1101 31.2801H44.6101C44.6101 31.2801 44.61 31.2801 44.62 31.2801C44.66 31.1901 44.68 31.0801 44.68 30.9801C44.68 30.9401 44.64 30.9101 44.64 30.8701H44.1V30.2401V29.6501H44.55V29.2301H44.1V28.8101H43.6501Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.21 34.99C44.21 34.81 44.05 34.66 43.86 34.66C43.67 34.66 43.51 34.81 43.51 34.99C43.51 35.17 43.67 35.32 43.86 35.32C44.05 35.32 44.21 35.17 44.21 34.99Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.21 34.33C44.21 34.15 44.05 34 43.86 34C43.67 34 43.51 34.15 43.51 34.33C43.51 34.51 43.67 34.66 43.86 34.66C44.05 34.66 44.21 34.51 44.21 34.33Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1401 33.6301C44.1401 33.4801 44.0101 33.3601 43.8601 33.3601C43.7101 33.3601 43.5801 33.4801 43.5801 33.6301C43.5801 33.7801 43.7101 33.9001 43.8601 33.9001C44.0101 33.8901 44.1401 33.7801 44.1401 33.6301Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0599 33.0001C44.0599 32.8901 43.9699 32.8101 43.8599 32.8101C43.7499 32.8101 43.6599 32.9001 43.6599 33.0001C43.6599 33.1101 43.7499 33.1901 43.8599 33.1901C43.9699 33.1901 44.0599 33.1001 44.0599 33.0001Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.02 32.44C44.02 32.36 43.95 32.29 43.86 32.29C43.77 32.29 43.7 32.36 43.7 32.44C43.7 32.52 43.77 32.59 43.86 32.59C43.95 32.59 44.02 32.53 44.02 32.44Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.62 36.7801C34.62 36.6701 34.53 36.5901 34.42 36.5901C34.31 36.5901 34.22 36.6801 34.22 36.7801C34.22 36.8901 34.31 36.9701 34.42 36.9701C34.53 36.9801 34.62 36.8901 34.62 36.7801Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3399 36.2901C34.3399 36.1801 34.2499 36.1001 34.1399 36.1001C34.0299 36.1001 33.9399 36.1901 33.9399 36.2901C33.9399 36.4001 34.0299 36.4801 34.1399 36.4801C34.2499 36.4901 34.3399 36.4001 34.3399 36.2901Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.15 35.72C34.15 35.61 34.06 35.53 33.95 35.53C33.84 35.53 33.75 35.62 33.75 35.72C33.75 35.83 33.84 35.91 33.95 35.91C34.06 35.92 34.15 35.83 34.15 35.72Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.13 35.11C34.13 35 34.04 34.92 33.93 34.92C33.82 34.92 33.73 35.01 33.73 35.11C33.73 35.22 33.82 35.3 33.93 35.3C34.04 35.31 34.13 35.22 34.13 35.11Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2801 34.5101C34.2801 34.4001 34.1901 34.3201 34.0801 34.3201C33.9701 34.3201 33.8801 34.4101 33.8801 34.5101C33.8801 34.6201 33.9701 34.7001 34.0801 34.7001C34.1901 34.7001 34.2801 34.6201 34.2801 34.5101Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5899 33.97C34.5899 33.86 34.4999 33.78 34.3899 33.78C34.2799 33.78 34.1899 33.87 34.1899 33.97C34.1899 34.08 34.2799 34.16 34.3899 34.16C34.4999 34.16 34.5899 34.08 34.5899 33.97Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0101 33.5201C35.0101 33.4101 34.9201 33.3301 34.8101 33.3301C34.7001 33.3301 34.6101 33.4201 34.6101 33.5201C34.6101 33.6301 34.7001 33.7101 34.8101 33.7101C34.9201 33.7101 35.0101 33.6301 35.0101 33.5201Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4901 33.1501C35.4901 33.0401 35.4001 32.9601 35.2901 32.9601C35.1801 32.9601 35.0901 33.0501 35.0901 33.1501C35.0901 33.2601 35.1801 33.3401 35.2901 33.3401C35.4001 33.3401 35.4901 33.2601 35.4901 33.1501Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0699 32.84C36.0699 32.73 35.9799 32.65 35.8699 32.65C35.7599 32.65 35.6699 32.74 35.6699 32.84C35.6699 32.95 35.7599 33.03 35.8699 33.03C35.9799 33.04 36.0699 32.95 36.0699 32.84Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.67 32.6301C36.67 32.5201 36.58 32.4401 36.47 32.4401C36.36 32.4401 36.27 32.5301 36.27 32.6301C36.27 32.7401 36.36 32.8201 36.47 32.8201C36.58 32.8201 36.67 32.7301 36.67 32.6301Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3399 32.5101C37.3399 32.4001 37.2499 32.3201 37.1399 32.3201C37.0299 32.3201 36.9399 32.4101 36.9399 32.5101C36.9399 32.6201 37.0299 32.7001 37.1399 32.7001C37.2499 32.7001 37.3399 32.6101 37.3399 32.5101Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9701 32.47C37.9701 32.36 37.8801 32.28 37.7701 32.28C37.6601 32.28 37.5701 32.37 37.5701 32.47C37.5701 32.58 37.6601 32.66 37.7701 32.66C37.8801 32.67 37.9701 32.58 37.9701 32.47Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5999 32.5001C38.5999 32.3901 38.51 32.3101 38.4 32.3101C38.29 32.3101 38.2 32.4001 38.2 32.5001C38.2 32.6101 38.29 32.6901 38.4 32.6901C38.5 32.6901 38.5999 32.6001 38.5999 32.5001Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2899 35.2401C39.2899 35.1301 39.1999 35.05 39.0899 35.05C38.9799 35.05 38.8899 35.1401 38.8899 35.2401C38.8899 35.3501 38.9799 35.43 39.0899 35.43C39.1999 35.43 39.2899 35.3501 39.2899 35.2401Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.94 34.7501C38.94 34.6401 38.85 34.5601 38.74 34.5601C38.63 34.5601 38.54 34.6501 38.54 34.7501C38.54 34.8601 38.63 34.9401 38.74 34.9401C38.85 34.9401 38.94 34.8501 38.94 34.7501Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7601 34.21C38.7601 34.1 38.6701 34.02 38.5601 34.02C38.4501 34.02 38.3601 34.11 38.3601 34.21C38.3601 34.31 38.4501 34.4 38.5601 34.4C38.6701 34.4 38.7601 34.32 38.7601 34.21Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7801 33.6201C38.7801 33.5101 38.6901 33.4301 38.5801 33.4301C38.4701 33.4301 38.3801 33.5201 38.3801 33.6201C38.3801 33.7301 38.4701 33.8101 38.5801 33.8101C38.6901 33.8101 38.7801 33.7301 38.7801 33.6201Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.91 33.0301C38.91 32.9201 38.82 32.8401 38.71 32.8401C38.6 32.8401 38.51 32.9301 38.51 33.0301C38.51 33.1401 38.6 33.2201 38.71 33.2201C38.82 33.2201 38.91 33.1401 38.91 33.0301Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2201 32.5001C39.2201 32.3901 39.1301 32.3101 39.0201 32.3101C38.9101 32.3101 38.8201 32.4001 38.8201 32.5001C38.8201 32.6101 38.9101 32.6901 39.0201 32.6901C39.1301 32.6901 39.2201 32.6001 39.2201 32.5001Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.69 32.1301C39.69 32.0201 39.6 31.9401 39.49 31.9401C39.38 31.9401 39.29 32.0301 39.29 32.1301C39.29 32.2401 39.38 32.3201 39.49 32.3201C39.6 32.3201 39.69 32.2301 39.69 32.1301Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2501 31.82C40.2501 31.71 40.1601 31.63 40.0501 31.63C39.9401 31.63 39.8501 31.72 39.8501 31.82C39.8501 31.93 39.9401 32.01 40.0501 32.01C40.1601 32.01 40.2501 31.92 40.2501 31.82Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.86 31.6401C40.86 31.5301 40.77 31.4501 40.66 31.4501C40.55 31.4501 40.46 31.5401 40.46 31.6401C40.46 31.7501 40.55 31.8301 40.66 31.8301C40.77 31.8301 40.86 31.7401 40.86 31.6401Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2901 31.7201C41.4005 31.7201 41.4901 31.635 41.4901 31.5301C41.4901 31.4252 41.4005 31.3401 41.2901 31.3401C41.1796 31.3401 41.0901 31.4252 41.0901 31.5301C41.0901 31.635 41.1796 31.7201 41.2901 31.7201Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.11 31.5401C42.11 31.4301 42.02 31.3501 41.91 31.3501C41.8 31.3501 41.71 31.4401 41.71 31.5401C41.71 31.6401 41.8 31.7301 41.91 31.7301C42.02 31.7301 42.11 31.6401 42.11 31.5401Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7601 31.6401C42.7601 31.5301 42.6701 31.4501 42.5601 31.4501C42.4501 31.4501 42.3601 31.5401 42.3601 31.6401C42.3601 31.7401 42.4501 31.8301 42.5601 31.8301C42.6701 31.8301 42.7601 31.7501 42.7601 31.6401Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.36 31.85C43.36 31.74 43.27 31.66 43.16 31.66C43.05 31.66 42.96 31.75 42.96 31.85C42.96 31.96 43.05 32.04 43.16 32.04C43.27 32.04 43.36 31.96 43.36 31.85Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7601 31.85C44.7601 31.74 44.6701 31.66 44.5601 31.66C44.4501 31.66 44.3601 31.75 44.3601 31.85C44.3601 31.96 44.4501 32.04 44.5601 32.04C44.6701 32.04 44.7601 31.96 44.7601 31.85Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.36 31.6401C45.36 31.5301 45.27 31.4501 45.16 31.4501C45.05 31.4501 44.96 31.5401 44.96 31.6401C44.96 31.7401 45.05 31.8301 45.16 31.8301C45.26 31.8401 45.36 31.7501 45.36 31.6401Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0001 31.5401C46.0001 31.4301 45.9101 31.3501 45.8001 31.3501C45.6901 31.3501 45.6001 31.4401 45.6001 31.5401C45.6001 31.6401 45.6901 31.7301 45.8001 31.7301C45.9101 31.7301 46.0001 31.6401 46.0001 31.5401Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.62 31.5301C46.62 31.4201 46.53 31.3401 46.42 31.3401C46.31 31.3401 46.22 31.4301 46.22 31.5301C46.22 31.6401 46.31 31.7201 46.42 31.7201C46.53 31.7201 46.62 31.6301 46.62 31.5301Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2601 31.6401C47.2601 31.5301 47.1701 31.4501 47.0601 31.4501C46.9501 31.4501 46.8601 31.5401 46.8601 31.6401C46.8601 31.7501 46.9501 31.8301 47.0601 31.8301C47.1701 31.8301 47.2601 31.7401 47.2601 31.6401Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.87 31.82C47.87 31.71 47.78 31.63 47.67 31.63C47.56 31.63 47.47 31.72 47.47 31.82C47.47 31.93 47.56 32.01 47.67 32.01C47.78 32.01 47.87 31.92 47.87 31.82Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.42 32.1301C48.42 32.0201 48.33 31.9401 48.22 31.9401C48.11 31.9401 48.02 32.0301 48.02 32.1301C48.02 32.2401 48.11 32.3201 48.22 32.3201C48.33 32.3201 48.42 32.2301 48.42 32.1301Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9 32.5001C48.9 32.3901 48.81 32.3101 48.7 32.3101C48.59 32.3101 48.5 32.4001 48.5 32.5001C48.5 32.6101 48.59 32.6901 48.7 32.6901C48.8 32.6901 48.9 32.6001 48.9 32.5001Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2101 33.0301C49.2101 32.9201 49.1201 32.8401 49.0101 32.8401C48.9001 32.8401 48.8101 32.9301 48.8101 33.0301C48.8101 33.1401 48.9001 33.2201 49.0101 33.2201C49.1201 33.2201 49.2101 33.1401 49.2101 33.0301Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3399 33.6201C49.3399 33.5101 49.2499 33.4301 49.1399 33.4301C49.0299 33.4301 48.9399 33.5201 48.9399 33.6201C48.9399 33.7301 49.0299 33.8101 49.1399 33.8101C49.2399 33.8101 49.3399 33.7301 49.3399 33.6201Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.36 34.21C49.36 34.1 49.27 34.02 49.16 34.02C49.05 34.02 48.96 34.11 48.96 34.21C48.96 34.31 49.05 34.4 49.16 34.4C49.27 34.4 49.36 34.32 49.36 34.21Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.17 34.7501C49.17 34.6401 49.08 34.5601 48.97 34.5601C48.86 34.5601 48.77 34.6501 48.77 34.7501C48.77 34.8601 48.86 34.9401 48.97 34.9401C49.08 34.9401 49.17 34.8501 49.17 34.7501Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8299 35.2401C48.8299 35.1301 48.7399 35.05 48.6299 35.05C48.5199 35.05 48.4299 35.1401 48.4299 35.2401C48.4299 35.3501 48.5199 35.43 48.6299 35.43C48.7399 35.43 48.8299 35.3501 48.8299 35.2401Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3201 32.6901C49.4306 32.6901 49.5201 32.605 49.5201 32.5001C49.5201 32.3951 49.4306 32.3101 49.3201 32.3101C49.2097 32.3101 49.1201 32.3951 49.1201 32.5001C49.1201 32.605 49.2097 32.6901 49.3201 32.6901Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.14 32.47C50.14 32.36 50.05 32.28 49.94 32.28C49.83 32.28 49.74 32.37 49.74 32.47C49.74 32.58 49.83 32.66 49.94 32.66C50.05 32.67 50.14 32.58 50.14 32.47Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7801 32.5101C50.7801 32.4001 50.6901 32.3201 50.5801 32.3201C50.4701 32.3201 50.3801 32.4101 50.3801 32.5101C50.3801 32.6201 50.4701 32.7001 50.5801 32.7001C50.6901 32.7001 50.7801 32.6101 50.7801 32.5101Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4501 32.6301C51.4501 32.5201 51.36 32.4401 51.25 32.4401C51.14 32.4401 51.05 32.5301 51.05 32.6301C51.05 32.7401 51.14 32.8201 51.25 32.8201C51.36 32.8201 51.4501 32.7301 51.4501 32.6301Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0499 32.84C52.0499 32.73 51.9599 32.65 51.8499 32.65C51.7399 32.65 51.6499 32.74 51.6499 32.84C51.6499 32.95 51.7399 33.03 51.8499 33.03C51.9599 33.04 52.0499 32.95 52.0499 32.84Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.62 33.1501C52.62 33.0401 52.53 32.9601 52.42 32.9601C52.31 32.9601 52.22 33.0501 52.22 33.1501C52.22 33.2601 52.31 33.3401 52.42 33.3401C52.53 33.3401 52.62 33.2601 52.62 33.1501Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.11 33.5201C53.11 33.4101 53.02 33.3301 52.91 33.3301C52.8 33.3301 52.71 33.4201 52.71 33.5201C52.71 33.6301 52.8 33.7101 52.91 33.7101C53.02 33.7101 53.11 33.6301 53.11 33.5201Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5201 33.97C53.5201 33.86 53.4301 33.78 53.3201 33.78C53.2101 33.78 53.1201 33.87 53.1201 33.97C53.1201 34.08 53.2101 34.16 53.3201 34.16C53.4301 34.16 53.5201 34.08 53.5201 33.97Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8299 34.5101C53.8299 34.4001 53.7399 34.3201 53.6299 34.3201C53.5199 34.3201 53.4299 34.4101 53.4299 34.5101C53.4299 34.6201 53.5199 34.7001 53.6299 34.7001C53.7399 34.7101 53.8299 34.6201 53.8299 34.5101Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9901 35.11C53.9901 35 53.9001 34.92 53.7901 34.92C53.6801 34.92 53.5901 35.01 53.5901 35.11C53.5901 35.22 53.6801 35.3 53.7901 35.3C53.9001 35.3 53.9901 35.22 53.9901 35.11Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9601 35.72C53.9601 35.61 53.8701 35.53 53.7601 35.53C53.6501 35.53 53.5601 35.62 53.5601 35.72C53.5601 35.83 53.6501 35.91 53.7601 35.91C53.8701 35.92 53.9601 35.83 53.9601 35.72Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7801 36.2901C53.7801 36.1801 53.6901 36.1001 53.5801 36.1001C53.4701 36.1001 53.3801 36.1901 53.3801 36.2901C53.3801 36.4001 53.4701 36.4801 53.5801 36.4801C53.6901 36.4901 53.7801 36.4001 53.7801 36.2901Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5001 36.7801C53.5001 36.6701 53.4101 36.5901 53.3001 36.5901C53.1901 36.5901 53.1001 36.6801 53.1001 36.7801C53.1001 36.8901 53.1901 36.9701 53.3001 36.9701C53.4101 36.9801 53.5001 36.8901 53.5001 36.7801Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8801 41.87C41.6101 41.87 39.5801 41.6 38.1301 41.16C38.0301 41.13 37.9701 41.03 37.9801 40.93C37.9801 40.83 38.0301 40.75 38.1301 40.71C39.5801 40.27 41.6101 40.01 43.8801 40C46.1501 40 48.1801 40.27 49.6301 40.71C49.7301 40.74 49.7901 40.83 49.7801 40.93C49.7901 41.03 49.7301 41.13 49.6301 41.16C48.1801 41.6 46.1501 41.86 43.8801 41.87Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8601 40.0001C41.5701 40.0101 39.5101 40.2901 38.0601 40.7401C38.1801 40.6801 38.1701 40.5301 38.0201 40.1501C37.8401 39.6801 37.5601 39.7001 37.5601 39.7001C39.1601 39.2301 41.3901 38.9301 43.8701 38.9301C46.3601 38.9301 48.6001 39.2301 50.2001 39.7001C50.2001 39.7001 49.9201 39.6801 49.7401 40.1501C49.5901 40.5301 49.5801 40.6801 49.7001 40.7401C48.2601 40.3001 46.1601 40.0101 43.8601 40.0001Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.87 38.93C41.39 38.93 39.16 39.23 37.56 39.7C37.45 39.73 37.34 39.69 37.31 39.59C37.27 39.49 37.33 39.37 37.44 39.34C39.05 38.85 41.34 38.54 43.88 38.53C46.43 38.54 48.72 38.85 50.33 39.34C50.44 39.37 50.49 39.49 50.46 39.59C50.42 39.69 50.31 39.73 50.2 39.7C48.6 39.23 46.36 38.94 43.87 38.93Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.87 38.93C41.39 38.93 39.16 39.23 37.56 39.7C37.45 39.73 37.34 39.69 37.31 39.59C37.27 39.49 37.33 39.37 37.44 39.34C39.05 38.85 41.34 38.54 43.88 38.53C46.43 38.54 48.72 38.85 50.33 39.34C50.44 39.37 50.49 39.49 50.46 39.59C50.42 39.69 50.31 39.73 50.2 39.7C48.6 39.23 46.36 38.94 43.87 38.93Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.89 36.9901L44.12 37.0301C44.08 37.1201 44.08 37.2201 44.08 37.3301C44.08 37.8001 44.49 38.1901 44.99 38.1901C45.39 38.1901 45.74 37.9401 45.85 37.6001C45.87 37.6101 45.94 37.2901 45.98 37.2901C46.01 37.2901 46.01 37.6201 46.02 37.6201C46.08 38.0501 46.48 38.3501 46.92 38.3501C47.42 38.3501 47.83 37.9601 47.83 37.4901C47.83 37.4601 47.83 37.4201 47.82 37.3801L48.11 37.1001L48.26 37.4601C48.2 37.5701 48.18 37.7001 48.18 37.8401C48.18 38.2901 48.57 38.6601 49.05 38.6601C49.35 38.6601 49.62 38.5201 49.77 38.3001L49.95 38.0701V38.3501C49.95 38.6401 50.07 38.8901 50.35 38.9401C50.35 38.9401 50.67 38.9601 51.09 38.6301C51.51 38.3001 51.75 38.0201 51.75 38.0201L51.79 38.3501C51.79 38.3501 51.44 38.9001 51.06 39.1201C50.85 39.2401 50.53 39.3701 50.28 39.3301C50.01 39.2901 49.82 39.0701 49.72 38.8201C49.53 38.9301 49.3 39.0001 49.06 39.0001C48.54 39.0001 48.08 38.7201 47.89 38.2901C47.65 38.5501 47.32 38.7001 46.93 38.7001C46.52 38.7001 46.14 38.5101 45.9 38.2301C45.67 38.4401 45.35 38.5801 45 38.5801C44.54 38.5801 44.13 38.3501 43.9 38.0201C43.67 38.3601 43.26 38.5801 42.8 38.5801C42.45 38.5801 42.13 38.4501 41.9 38.2301C41.66 38.5201 41.28 38.7001 40.87 38.7001C40.48 38.7001 40.15 38.5401 39.91 38.2901C39.73 38.7201 39.26 39.0001 38.74 39.0001C38.5 39.0001 38.28 38.9301 38.08 38.8201C37.98 39.0701 37.79 39.2801 37.52 39.3301C37.27 39.3701 36.95 39.2401 36.74 39.1201C36.36 38.9001 36 38.3501 36 38.3501L36.04 38.0201C36.04 38.0201 36.27 38.3001 36.7 38.6301C37.12 38.9601 37.44 38.9401 37.44 38.9401C37.72 38.8901 37.84 38.6401 37.84 38.3501V38.0701L38.02 38.3001C38.18 38.5201 38.44 38.6601 38.74 38.6601C39.22 38.6601 39.61 38.2901 39.61 37.8401C39.61 37.7001 39.59 37.5801 39.53 37.4601L39.68 37.1001L39.96 37.3801C39.96 37.4201 39.95 37.4501 39.95 37.4901C39.95 37.9601 40.36 38.3501 40.86 38.3501C41.31 38.3501 41.7 38.0601 41.76 37.6201C41.77 37.6301 41.77 37.3001 41.8 37.2901C41.84 37.2901 41.91 37.6101 41.92 37.6001C42.04 37.9401 42.38 38.1901 42.79 38.1901C43.29 38.1901 43.7 37.8001 43.7 37.3301C43.7 37.2201 43.69 37.1201 43.66 37.0301L43.89 36.9901Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.89 36.9901L44.12 37.0301C44.08 37.1201 44.08 37.2201 44.08 37.3301C44.08 37.8001 44.49 38.1901 44.99 38.1901C45.39 38.1901 45.74 37.9401 45.85 37.6001C45.87 37.6101 45.94 37.2901 45.98 37.2901C46.01 37.2901 46.01 37.6201 46.02 37.6201C46.08 38.0501 46.48 38.3501 46.92 38.3501C47.42 38.3501 47.83 37.9601 47.83 37.4901C47.83 37.4601 47.83 37.4201 47.82 37.3801L48.11 37.1001L48.26 37.4601C48.2 37.5701 48.18 37.7001 48.18 37.8401C48.18 38.2901 48.57 38.6601 49.05 38.6601C49.35 38.6601 49.62 38.5201 49.77 38.3001L49.95 38.0701V38.3501C49.95 38.6401 50.07 38.8901 50.35 38.9401C50.35 38.9401 50.67 38.9601 51.09 38.6301C51.51 38.3001 51.75 38.0201 51.75 38.0201L51.79 38.3501C51.79 38.3501 51.44 38.9001 51.06 39.1201C50.85 39.2401 50.53 39.3701 50.28 39.3301C50.01 39.2901 49.82 39.0701 49.72 38.8201C49.53 38.9301 49.3 39.0001 49.06 39.0001C48.54 39.0001 48.08 38.7201 47.89 38.2901C47.65 38.5501 47.32 38.7001 46.93 38.7001C46.52 38.7001 46.14 38.5101 45.9 38.2301C45.67 38.4401 45.35 38.5801 45 38.5801C44.54 38.5801 44.13 38.3501 43.9 38.0201C43.67 38.3601 43.26 38.5801 42.8 38.5801C42.45 38.5801 42.13 38.4501 41.9 38.2301C41.66 38.5201 41.28 38.7001 40.87 38.7001C40.48 38.7001 40.15 38.5401 39.91 38.2901C39.73 38.7201 39.26 39.0001 38.74 39.0001C38.5 39.0001 38.28 38.9301 38.08 38.8201C37.98 39.0701 37.79 39.2801 37.52 39.3301C37.27 39.3701 36.95 39.2401 36.74 39.1201C36.36 38.9001 36 38.3501 36 38.3501L36.04 38.0201C36.04 38.0201 36.27 38.3001 36.7 38.6301C37.12 38.9601 37.44 38.9401 37.44 38.9401C37.72 38.8901 37.84 38.6401 37.84 38.3501V38.0701L38.02 38.3001C38.18 38.5201 38.44 38.6601 38.74 38.6601C39.22 38.6601 39.61 38.2901 39.61 37.8401C39.61 37.7001 39.59 37.5801 39.53 37.4601L39.68 37.1001L39.96 37.3801C39.96 37.4201 39.95 37.4501 39.95 37.4901C39.95 37.9601 40.36 38.3501 40.86 38.3501C41.31 38.3501 41.7 38.0601 41.76 37.6201C41.77 37.6301 41.77 37.3001 41.8 37.2901C41.84 37.2901 41.91 37.6101 41.92 37.6001C42.04 37.9401 42.38 38.1901 42.79 38.1901C43.29 38.1901 43.7 37.8001 43.7 37.3301C43.7 37.2201 43.69 37.1201 43.66 37.0301L43.89 36.9901Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.16 38.2001C36.14 38.1301 36.09 38.0601 36.03 38.0001C35.88 37.8701 35.69 37.8501 35.59 37.9501C35.58 37.9601 35.57 37.9801 35.56 38.0001C35.56 38.0001 35.35 37.6201 35.11 37.4901C34.87 37.3601 34.46 37.3901 34.46 37.3901C34.46 37.0901 34.7 36.8601 35.01 36.8601C35.19 36.8601 35.37 36.9401 35.47 37.0701L35.51 36.8701C35.51 36.8701 35.76 36.9201 35.88 37.2101C35.99 37.5001 35.87 37.9101 35.87 37.9101C35.87 37.9101 35.93 37.7301 36.03 37.6101C36.12 37.4901 36.36 37.3601 36.49 37.3001C36.61 37.2401 36.74 37.1501 36.74 37.1501C36.74 37.1501 36.75 37.1801 36.75 37.2601C36.75 37.3501 36.75 37.4101 36.75 37.4101C36.98 37.3801 37.25 37.4201 37.46 37.5001C37.37 37.6801 37.2 37.8401 36.98 37.9301C36.98 37.9301 37.06 38.0001 37.13 38.0701C37.19 38.1301 37.21 38.1601 37.21 38.1601C37.21 38.1601 37.05 38.1801 36.98 38.1901C36.9 38.2001 36.64 38.2401 36.48 38.2301C36.36 38.2301 36.23 38.2101 36.16 38.2001Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.16 38.2001C36.14 38.1301 36.09 38.0601 36.03 38.0001C35.88 37.8701 35.69 37.8501 35.59 37.9501C35.58 37.9601 35.57 37.9801 35.56 38.0001C35.56 38.0001 35.35 37.6201 35.11 37.4901C34.87 37.3601 34.46 37.3901 34.46 37.3901C34.46 37.0901 34.7 36.8601 35.01 36.8601C35.19 36.8601 35.37 36.9401 35.47 37.0701L35.51 36.8701C35.51 36.8701 35.76 36.9201 35.88 37.2101C35.99 37.5001 35.87 37.9101 35.87 37.9101C35.87 37.9101 35.93 37.7301 36.03 37.6101C36.12 37.4901 36.36 37.3601 36.49 37.3001C36.61 37.2401 36.74 37.1501 36.74 37.1501C36.74 37.1501 36.75 37.1801 36.75 37.2601C36.75 37.3501 36.75 37.4101 36.75 37.4101C36.98 37.3801 37.25 37.4201 37.46 37.5001C37.37 37.6801 37.2 37.8401 36.98 37.9301C36.98 37.9301 37.06 38.0001 37.13 38.0701C37.19 38.1301 37.21 38.1601 37.21 38.1601C37.21 38.1601 37.05 38.1801 36.98 38.1901C36.9 38.2001 36.64 38.2401 36.48 38.2301C36.36 38.2301 36.23 38.2101 36.16 38.2001Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5901 37.9601C35.6901 37.8601 35.8801 37.8801 36.0301 38.0101C36.1801 38.1301 36.2201 38.3201 36.1201 38.4101C36.0301 38.5101 35.8301 38.4901 35.6801 38.3601C35.5401 38.2301 35.4901 38.0501 35.5901 37.9601Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6399 38.12C37.5899 37.97 37.6299 37.82 37.7499 37.78C37.8599 37.75 37.9899 37.84 38.0499 38C38.0999 38.15 38.0499 38.3 37.9399 38.34C37.8199 38.37 37.6899 38.28 37.6399 38.12Z",
    fill: "#E9E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6399 38.12C37.5899 37.97 37.6299 37.82 37.7499 37.78C37.8599 37.75 37.9899 37.84 38.0499 38C38.0999 38.15 38.0499 38.3 37.9399 38.34C37.8199 38.37 37.6899 38.28 37.6399 38.12Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4399 37.37C39.3799 37.32 39.33 37.25 39.32 37.17C39.3 37.09 39.32 37.01 39.36 36.94C39.36 36.94 39.2 36.86 39.02 36.81C38.89 36.78 38.65 36.77 38.58 36.77C38.51 36.77 38.3699 36.76 38.3699 36.76C38.3699 36.76 38.3799 36.79 38.4199 36.86C38.4699 36.94 38.5099 37 38.5099 37C38.2699 37.05 38.08 37.21 37.95 37.39C38.13 37.52 38.38 37.59 38.61 37.57C38.61 37.57 38.59 37.63 38.57 37.73C38.56 37.81 38.56 37.84 38.56 37.84C38.56 37.84 38.6899 37.79 38.7599 37.77C38.8199 37.75 39.04 37.67 39.16 37.59C39.31 37.5 39.4399 37.37 39.4399 37.37Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4399 37.37C39.3799 37.32 39.33 37.25 39.32 37.17C39.3 37.09 39.32 37.01 39.36 36.94C39.36 36.94 39.2 36.86 39.02 36.81C38.89 36.78 38.65 36.77 38.58 36.77C38.51 36.77 38.3699 36.76 38.3699 36.76C38.3699 36.76 38.3799 36.79 38.4199 36.86C38.4699 36.94 38.5099 37 38.5099 37C38.2699 37.05 38.08 37.21 37.95 37.39C38.13 37.52 38.38 37.59 38.61 37.57C38.61 37.57 38.59 37.63 38.57 37.73C38.56 37.81 38.56 37.84 38.56 37.84C38.56 37.84 38.6899 37.79 38.7599 37.77C38.8199 37.75 39.04 37.67 39.16 37.59C39.31 37.5 39.4399 37.37 39.4399 37.37Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3601 35.4901C39.5601 35.6101 39.7301 35.8201 39.7901 36.0501C39.7901 36.0501 39.81 36.0001 39.92 35.9401C40.03 35.8801 40.12 35.8801 40.12 35.8801C40.12 35.8801 40.09 36.0601 40.07 36.1201C40.05 36.1801 40.05 36.3801 40.01 36.5501C39.97 36.7201 39.89 36.8601 39.89 36.8601C39.81 36.8001 39.71 36.7701 39.6 36.7801C39.49 36.8001 39.4001 36.8601 39.3601 36.9501C39.3601 36.9501 39.24 36.8401 39.14 36.6901C39.04 36.5401 38.97 36.3601 38.93 36.3101C38.89 36.2501 38.8 36.1001 38.8 36.1001C38.8 36.1001 38.89 36.0701 39.01 36.0901C39.13 36.1101 39.17 36.1501 39.17 36.1501C39.14 35.9101 39.2201 35.6701 39.3601 35.4901Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9599 37.29C39.9999 37.23 40.0199 37.14 40.0099 37.06C39.9899 36.98 39.9499 36.91 39.8899 36.86C39.8899 36.86 40.0099 36.73 40.1599 36.63C40.2699 36.55 40.4899 36.48 40.5599 36.45C40.6299 36.43 40.7599 36.38 40.7599 36.38C40.7599 36.38 40.7599 36.41 40.7499 36.49C40.7299 36.59 40.7099 36.65 40.7099 36.65C40.9499 36.62 41.1899 36.7 41.3799 36.83C41.2499 37.01 41.0499 37.16 40.8199 37.22C40.8199 37.22 40.8599 37.27 40.9099 37.36C40.9499 37.43 40.9599 37.46 40.9599 37.46C40.9599 37.46 40.8199 37.46 40.7499 37.45C40.6799 37.45 40.4399 37.45 40.3099 37.41C40.1299 37.37 39.9599 37.29 39.9599 37.29Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9599 37.29C39.9999 37.23 40.0199 37.14 40.0099 37.06C39.9899 36.98 39.9499 36.91 39.8899 36.86C39.8899 36.86 40.0099 36.73 40.1599 36.63C40.2699 36.55 40.4899 36.48 40.5599 36.45C40.6299 36.43 40.7599 36.38 40.7599 36.38C40.7599 36.38 40.7599 36.41 40.7499 36.49C40.7299 36.59 40.7099 36.65 40.7099 36.65C40.9499 36.62 41.1899 36.7 41.3799 36.83C41.2499 37.01 41.0499 37.16 40.8199 37.22C40.8199 37.22 40.8599 37.27 40.9099 37.36C40.9499 37.43 40.9599 37.46 40.9599 37.46C40.9599 37.46 40.8199 37.46 40.7499 37.45C40.6799 37.45 40.4399 37.45 40.3099 37.41C40.1299 37.37 39.9599 37.29 39.9599 37.29Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.07 37.1101C40.07 36.9001 39.89 36.7301 39.67 36.7301C39.45 36.7301 39.27 36.9001 39.27 37.1101C39.27 37.3201 39.45 37.4901 39.67 37.4901C39.89 37.4901 40.07 37.3201 40.07 37.1101Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.59 37.36C41.57 37.2 41.65 37.06 41.76 37.05C41.88 37.04 41.99 37.16 42.01 37.32C42.03 37.48 41.96 37.62 41.84 37.63C41.72 37.64 41.61 37.52 41.59 37.36Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5699 37C43.5099 36.93 43.4699 36.85 43.4699 36.75C43.4699 36.66 43.5099 36.57 43.5599 36.51C43.5599 36.51 43.3999 36.39 43.2099 36.3C43.0699 36.24 42.8099 36.19 42.7299 36.18C42.6599 36.16 42.4999 36.13 42.4999 36.13C42.4999 36.13 42.5099 36.17 42.5399 36.25C42.5799 36.35 42.6099 36.42 42.6099 36.42C42.3399 36.44 42.0799 36.57 41.9099 36.75C42.0899 36.92 42.3399 37.06 42.6099 37.07C42.6099 37.07 42.5699 37.14 42.5399 37.24C42.5099 37.33 42.4999 37.37 42.4999 37.37C42.4999 37.37 42.6599 37.34 42.7399 37.32C42.8199 37.31 43.0799 37.26 43.2199 37.2C43.4099 37.12 43.5699 37 43.5699 37Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5699 37C43.5099 36.93 43.4699 36.85 43.4699 36.75C43.4699 36.66 43.5099 36.57 43.5599 36.51C43.5599 36.51 43.3999 36.39 43.2099 36.3C43.0699 36.24 42.8099 36.19 42.7299 36.18C42.6599 36.16 42.4999 36.13 42.4999 36.13C42.4999 36.13 42.5099 36.17 42.5399 36.25C42.5799 36.35 42.6099 36.42 42.6099 36.42C42.3399 36.44 42.0799 36.57 41.9099 36.75C42.0899 36.92 42.3399 37.06 42.6099 37.07C42.6099 37.07 42.5699 37.14 42.5399 37.24C42.5099 37.33 42.4999 37.37 42.4999 37.37C42.4999 37.37 42.6599 37.34 42.7399 37.32C42.8199 37.31 43.0799 37.26 43.2199 37.2C43.4099 37.12 43.5699 37 43.5699 37Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8701 34.88C44.0601 35.06 44.2101 35.32 44.2301 35.59C44.2301 35.59 44.2601 35.54 44.4001 35.49C44.5401 35.44 44.6401 35.46 44.6401 35.46C44.6401 35.46 44.5701 35.65 44.5401 35.72C44.5001 35.79 44.4601 36 44.3801 36.19C44.3001 36.37 44.1901 36.51 44.1901 36.51C44.1201 36.43 44.0001 36.37 43.8801 36.37C43.7501 36.37 43.6501 36.42 43.5701 36.51C43.5701 36.51 43.4601 36.37 43.3801 36.19C43.3001 36 43.2601 35.79 43.2301 35.72C43.2001 35.65 43.1301 35.46 43.1301 35.46C43.1301 35.46 43.2301 35.44 43.3701 35.49C43.5001 35.54 43.5401 35.59 43.5401 35.59C43.5401 35.31 43.6801 35.05 43.8701 34.88Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8701 34.88C44.0601 35.06 44.2101 35.32 44.2301 35.59C44.2301 35.59 44.2601 35.54 44.4001 35.49C44.5401 35.44 44.6401 35.46 44.6401 35.46C44.6401 35.46 44.5701 35.65 44.5401 35.72C44.5001 35.79 44.4601 36 44.3801 36.19C44.3001 36.37 44.1901 36.51 44.1901 36.51C44.1201 36.43 44.0001 36.37 43.8801 36.37C43.7501 36.37 43.6501 36.42 43.5701 36.51C43.5701 36.51 43.4601 36.37 43.3801 36.19C43.3001 36 43.2601 35.79 43.2301 35.72C43.2001 35.65 43.1301 35.46 43.1301 35.46C43.1301 35.46 43.2301 35.44 43.3701 35.49C43.5001 35.54 43.5401 35.59 43.5401 35.59C43.5401 35.31 43.6801 35.05 43.8701 34.88Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1799 37C44.2399 36.93 44.2799 36.85 44.2799 36.75C44.2799 36.66 44.2399 36.57 44.1899 36.51C44.1899 36.51 44.3599 36.39 44.5399 36.3C44.6799 36.24 44.9399 36.19 45.0199 36.18C45.0999 36.16 45.2499 36.14 45.2499 36.14C45.2499 36.14 45.2499 36.18 45.2199 36.26C45.1799 36.36 45.1499 36.43 45.1499 36.43C45.4199 36.45 45.6799 36.58 45.8499 36.76C45.6699 36.93 45.4199 37.07 45.1499 37.08C45.1499 37.08 45.1899 37.15 45.2199 37.25C45.2499 37.33 45.2499 37.37 45.2499 37.37L45.0199 37.32C44.9399 37.31 44.6799 37.26 44.5399 37.2C44.3499 37.12 44.1799 37 44.1799 37Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1799 37C44.2399 36.93 44.2799 36.85 44.2799 36.75C44.2799 36.66 44.2399 36.57 44.1899 36.51C44.1899 36.51 44.3599 36.39 44.5399 36.3C44.6799 36.24 44.9399 36.19 45.0199 36.18C45.0999 36.16 45.2499 36.14 45.2499 36.14C45.2499 36.14 45.2499 36.18 45.2199 36.26C45.1799 36.36 45.1499 36.43 45.1499 36.43C45.4199 36.45 45.6799 36.58 45.8499 36.76C45.6699 36.93 45.4199 37.07 45.1499 37.08C45.1499 37.08 45.1899 37.15 45.2199 37.25C45.2499 37.33 45.2499 37.37 45.2499 37.37L45.0199 37.32C44.9399 37.31 44.6799 37.26 44.5399 37.2C44.3499 37.12 44.1799 37 44.1799 37Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.28 36.7501C44.28 36.5401 44.1 36.3701 43.88 36.3701C43.66 36.3701 43.48 36.5401 43.48 36.7501C43.48 36.9601 43.66 37.1301 43.88 37.1301C44.1 37.1301 44.28 36.9601 44.28 36.7501Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1799 37.36C46.1999 37.2 46.1199 37.06 46.0099 37.05C45.8899 37.04 45.7799 37.16 45.7599 37.32C45.7399 37.48 45.8199 37.62 45.9299 37.63C46.0499 37.64 46.1599 37.52 46.1799 37.36Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7999 37.29C47.7599 37.23 47.7399 37.14 47.7599 37.06C47.7799 36.98 47.8199 36.91 47.8799 36.86C47.8799 36.86 47.7599 36.73 47.6099 36.63C47.4999 36.55 47.2799 36.48 47.2099 36.45C47.1499 36.43 47.0099 36.38 47.0099 36.38C47.0099 36.38 47.0099 36.41 47.0199 36.49C47.0299 36.59 47.0499 36.65 47.0499 36.65C46.8099 36.62 46.5699 36.7 46.3899 36.83C46.5099 37.01 46.7199 37.16 46.9499 37.22C46.9499 37.22 46.9099 37.27 46.8599 37.36C46.8199 37.43 46.8099 37.46 46.8099 37.46L47.0199 37.45C47.0899 37.45 47.3299 37.45 47.4599 37.41C47.6399 37.37 47.7999 37.29 47.7999 37.29Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7999 37.29C47.7599 37.23 47.7399 37.14 47.7599 37.06C47.7799 36.98 47.8199 36.91 47.8799 36.86C47.8799 36.86 47.7599 36.73 47.6099 36.63C47.4999 36.55 47.2799 36.48 47.2099 36.45C47.1499 36.43 47.0099 36.38 47.0099 36.38C47.0099 36.38 47.0099 36.41 47.0199 36.49C47.0299 36.59 47.0499 36.65 47.0499 36.65C46.8099 36.62 46.5699 36.7 46.3899 36.83C46.5099 37.01 46.7199 37.16 46.9499 37.22C46.9499 37.22 46.9099 37.27 46.8599 37.36C46.8199 37.43 46.8099 37.46 46.8099 37.46L47.0199 37.45C47.0899 37.45 47.3299 37.45 47.4599 37.41C47.6399 37.37 47.7999 37.29 47.7999 37.29Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4099 35.4901C48.2099 35.6101 48.0399 35.8201 47.9799 36.0501C47.9799 36.0501 47.9599 36.0001 47.8499 35.9401C47.7399 35.8801 47.6499 35.8801 47.6499 35.8801C47.6499 35.8801 47.6799 36.0601 47.6999 36.1201C47.7199 36.1801 47.7199 36.3801 47.7599 36.5501C47.7999 36.7201 47.8799 36.8601 47.8799 36.8601C47.9599 36.8001 48.0599 36.7701 48.1699 36.7801C48.2799 36.8001 48.3699 36.8601 48.4199 36.9501C48.4199 36.9501 48.5399 36.8401 48.6399 36.6901C48.7399 36.5401 48.8099 36.3601 48.8499 36.3101C48.8899 36.2501 48.9799 36.1001 48.9799 36.1001C48.9799 36.1001 48.8899 36.0701 48.7699 36.0901C48.6499 36.1101 48.6099 36.1501 48.6099 36.1501C48.6299 35.9101 48.5499 35.6701 48.4099 35.4901Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4099 35.4901C48.2099 35.6101 48.0399 35.8201 47.9799 36.0501C47.9799 36.0501 47.9599 36.0001 47.8499 35.9401C47.7399 35.8801 47.6499 35.8801 47.6499 35.8801C47.6499 35.8801 47.6799 36.0601 47.6999 36.1201C47.7199 36.1801 47.7199 36.3801 47.7599 36.5501C47.7999 36.7201 47.8799 36.8601 47.8799 36.8601C47.9599 36.8001 48.0599 36.7701 48.1699 36.7801C48.2799 36.8001 48.3699 36.8601 48.4199 36.9501C48.4199 36.9501 48.5399 36.8401 48.6399 36.6901C48.7399 36.5401 48.8099 36.3601 48.8499 36.3101C48.8899 36.2501 48.9799 36.1001 48.9799 36.1001C48.9799 36.1001 48.8899 36.0701 48.7699 36.0901C48.6499 36.1101 48.6099 36.1501 48.6099 36.1501C48.6299 35.9101 48.5499 35.6701 48.4099 35.4901Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3301 37.37C48.3901 37.32 48.4401 37.25 48.4501 37.17C48.4701 37.09 48.4501 37.01 48.4101 36.94C48.4101 36.94 48.5701 36.86 48.7501 36.81C48.8801 36.78 49.1201 36.77 49.1901 36.77C49.2601 36.77 49.4001 36.76 49.4001 36.76C49.4001 36.76 49.3901 36.79 49.3501 36.86C49.3001 36.94 49.2601 37 49.2601 37C49.4901 37.05 49.6901 37.21 49.8201 37.39C49.6401 37.52 49.3901 37.59 49.1501 37.57C49.1501 37.57 49.1701 37.63 49.1901 37.73C49.2001 37.81 49.2001 37.84 49.2001 37.84C49.2001 37.84 49.0701 37.79 49.0001 37.77C48.9301 37.75 48.7101 37.67 48.6001 37.59C48.4601 37.5 48.3301 37.37 48.3301 37.37Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3301 37.37C48.3901 37.32 48.4401 37.25 48.4501 37.17C48.4701 37.09 48.4501 37.01 48.4101 36.94C48.4101 36.94 48.5701 36.86 48.7501 36.81C48.8801 36.78 49.1201 36.77 49.1901 36.77C49.2601 36.77 49.4001 36.76 49.4001 36.76C49.4001 36.76 49.3901 36.79 49.3501 36.86C49.3001 36.94 49.2601 37 49.2601 37C49.4901 37.05 49.6901 37.21 49.8201 37.39C49.6401 37.52 49.3901 37.59 49.1501 37.57C49.1501 37.57 49.1701 37.63 49.1901 37.73C49.2001 37.81 49.2001 37.84 49.2001 37.84C49.2001 37.84 49.0701 37.79 49.0001 37.77C48.9301 37.75 48.7101 37.67 48.6001 37.59C48.4601 37.5 48.3301 37.37 48.3301 37.37Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5 37.1101C48.5 36.9001 48.3199 36.7301 48.0999 36.7301C47.8799 36.7301 47.7 36.9001 47.7 37.1101C47.7 37.3201 47.8799 37.4901 48.0999 37.4901C48.3199 37.4901 48.5 37.3201 48.5 37.1101Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.13 38.12C50.18 37.97 50.14 37.82 50.02 37.78C49.91 37.75 49.78 37.84 49.72 38C49.67 38.15 49.71 38.3 49.83 38.34C49.94 38.37 50.08 38.28 50.13 38.12Z",
    fill: "#E9E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.13 38.12C50.18 37.97 50.14 37.82 50.02 37.78C49.91 37.75 49.78 37.84 49.72 38C49.67 38.15 49.71 38.3 49.83 38.34C49.94 38.37 50.08 38.28 50.13 38.12Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6101 38.2001C51.6301 38.1301 51.6801 38.0601 51.7401 38.0001C51.8901 37.8701 52.08 37.8501 52.18 37.9501C52.19 37.9601 52.21 37.9801 52.21 38.0001C52.21 38.0001 52.4101 37.6201 52.6501 37.4901C52.8901 37.3601 53.3 37.3901 53.3 37.3901C53.3 37.0901 53.06 36.8601 52.75 36.8601C52.57 36.8601 52.4001 36.9401 52.2901 37.0701L52.25 36.8701C52.25 36.8701 52.0001 36.9201 51.8801 37.2101C51.7701 37.5001 51.89 37.9101 51.89 37.9101C51.89 37.9101 51.83 37.7301 51.73 37.6101C51.64 37.4901 51.4001 37.3601 51.2701 37.3001C51.1401 37.2401 51.0201 37.1501 51.0201 37.1501C51.0201 37.1501 51.01 37.1801 51.01 37.2601C51.01 37.3501 51.01 37.4101 51.01 37.4101C50.78 37.3801 50.51 37.4201 50.3 37.5001C50.39 37.6801 50.56 37.8401 50.78 37.9301C50.78 37.9301 50.7001 38.0001 50.6301 38.0701C50.5701 38.1301 50.55 38.1601 50.55 38.1601C50.55 38.1601 50.71 38.1801 50.78 38.1901C50.86 38.2001 51.12 38.2401 51.28 38.2301C51.4 38.2301 51.5301 38.2101 51.6101 38.2001Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6101 38.2001C51.6301 38.1301 51.6801 38.0601 51.7401 38.0001C51.8901 37.8701 52.08 37.8501 52.18 37.9501C52.19 37.9601 52.21 37.9801 52.21 38.0001C52.21 38.0001 52.4101 37.6201 52.6501 37.4901C52.8901 37.3601 53.3 37.3901 53.3 37.3901C53.3 37.0901 53.06 36.8601 52.75 36.8601C52.57 36.8601 52.4001 36.9401 52.2901 37.0701L52.25 36.8701C52.25 36.8701 52.0001 36.9201 51.8801 37.2101C51.7701 37.5001 51.89 37.9101 51.89 37.9101C51.89 37.9101 51.83 37.7301 51.73 37.6101C51.64 37.4901 51.4001 37.3601 51.2701 37.3001C51.1401 37.2401 51.0201 37.1501 51.0201 37.1501C51.0201 37.1501 51.01 37.1801 51.01 37.2601C51.01 37.3501 51.01 37.4101 51.01 37.4101C50.78 37.3801 50.51 37.4201 50.3 37.5001C50.39 37.6801 50.56 37.8401 50.78 37.9301C50.78 37.9301 50.7001 38.0001 50.6301 38.0701C50.5701 38.1301 50.55 38.1601 50.55 38.1601C50.55 38.1601 50.71 38.1801 50.78 38.1901C50.86 38.2001 51.12 38.2401 51.28 38.2301C51.4 38.2301 51.5301 38.2101 51.6101 38.2001Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.18 37.9601C52.09 37.8601 51.89 37.8801 51.74 38.0101C51.59 38.1301 51.55 38.3201 51.65 38.4101C51.74 38.5101 51.94 38.4901 52.09 38.3601C52.23 38.2301 52.27 38.0501 52.18 37.9601Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8701 41.57C41.8301 41.57 39.9701 41.33 38.5701 40.97C39.9801 40.61 41.8301 40.38 43.8701 40.38C45.9201 40.38 47.7801 40.61 49.1801 40.97C47.7801 41.33 45.9201 41.57 43.8701 41.57Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3401 41.5201V40.4101M44.7801 41.5501L44.7901 40.3701M44.3701 41.5701V40.3701",
    stroke: "#020203",
    strokeWidth: 0.008062,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.03 41.5801V40.3701",
    stroke: "#020203",
    strokeWidth: 0.0145,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7 41.5801V40.3701",
    stroke: "#020203",
    strokeWidth: 0.0226,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3899 41.5801V40.3701",
    stroke: "#020203",
    strokeWidth: 0.0291,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0801 41.5801V40.3701",
    stroke: "#020203",
    strokeWidth: 0.0372,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8 41.5801V40.3701",
    stroke: "#020203",
    strokeWidth: 0.0453,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.28 41.5201L42.27 40.4201M42.53 41.5301V40.3701",
    stroke: "#020203",
    strokeWidth: 0.0533,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.79 41.47V40.45M42.04 41.5L42.03 40.42",
    stroke: "#020203",
    strokeWidth: 0.0598,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1399 41.4101V40.5101M41.3599 41.4301V40.4901M41.5799 41.4501V40.4701",
    stroke: "#020203",
    strokeWidth: 0.0679,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9199 41.4V40.54",
    stroke: "#020203",
    strokeWidth: 0.0744,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7 41.3601V40.55",
    stroke: "#020203",
    strokeWidth: 0.0824,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.48 41.3401V40.5901",
    stroke: "#020203",
    strokeWidth: 0.0906,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.01 41.27L40 40.68M40.25 41.3V40.63",
    stroke: "#020203",
    strokeWidth: 0.097,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.77 41.2201V40.7001",
    stroke: "#020203",
    strokeWidth: 0.1018,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.55 41.1801V40.7401",
    stroke: "#020203",
    strokeWidth: 0.1099,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3101 41.12V40.78",
    stroke: "#020203",
    strokeWidth: 0.118,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0701 41.0901V40.8301",
    stroke: "#020203",
    strokeWidth: 0.1245,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8101 41.03V40.91",
    stroke: "#020203",
    strokeWidth: 0.1471,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7 40.2L37.9199 39.91L38.5499 39.99L38.0499 40.35L37.7 40.2Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.05 39.85C39.05 39.74 39.14 39.66 39.25 39.66C39.36 39.66 39.4501 39.74 39.4501 39.85C39.4501 39.96 39.36 40.04 39.25 40.04C39.14 40.05 39.05 39.96 39.05 39.85Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8301 39.8101L40.3901 39.8601C40.2801 39.8701 40.1701 39.8001 40.1601 39.6901C40.1501 39.5901 40.2201 39.4901 40.3401 39.4801L40.7801 39.4301L41.2301 39.3801C41.3401 39.3701 41.4401 39.4401 41.4601 39.5501C41.4701 39.6601 41.3901 39.7501 41.2801 39.7601L40.8301 39.8101Z",
    fill: "#419846"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8301 39.8101L40.3901 39.8601C40.2801 39.8701 40.1701 39.8001 40.1601 39.6901C40.1501 39.5901 40.2201 39.4901 40.3401 39.4801L40.7801 39.4301L41.2301 39.3801C41.3401 39.3701 41.4401 39.4401 41.4601 39.5501C41.4701 39.6601 41.3901 39.7501 41.2801 39.7601L40.8301 39.8101Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1001 39.5001C42.1001 39.3901 42.1901 39.3101 42.3001 39.3101C42.4101 39.3101 42.5001 39.4001 42.5001 39.5001C42.5001 39.6101 42.4101 39.6901 42.3001 39.6901C42.1901 39.6901 42.1001 39.6001 42.1001 39.5001Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8801 39.65H43.2701C43.1601 39.65 43.0601 39.57 43.0601 39.46C43.0601 39.35 43.1501 39.27 43.2601 39.27H44.5001C44.6101 39.27 44.7001 39.36 44.7001 39.46C44.7001 39.57 44.6101 39.65 44.5001 39.65H43.8801Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.25 39.5001C45.25 39.3901 45.34 39.3101 45.45 39.3101C45.56 39.3101 45.65 39.4001 45.65 39.5001C45.65 39.6101 45.56 39.6901 45.45 39.6901C45.34 39.6901 45.25 39.6001 45.25 39.5001Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9299 39.8101L47.3699 39.8601C47.4799 39.8701 47.5899 39.8001 47.5999 39.6901C47.6099 39.5901 47.5299 39.4901 47.4199 39.4801L46.9799 39.4301L46.5299 39.3801C46.4199 39.3701 46.3199 39.4401 46.2999 39.5501C46.2899 39.6601 46.3699 39.7501 46.4799 39.7601L46.9299 39.8101Z",
    fill: "#419846"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9299 39.8101L47.3699 39.8601C47.4799 39.8701 47.5899 39.8001 47.5999 39.6901C47.6099 39.5901 47.5299 39.4901 47.4199 39.4801L46.9799 39.4301L46.5299 39.3801C46.4199 39.3701 46.3199 39.4401 46.2999 39.5501C46.2899 39.6601 46.3699 39.7501 46.4799 39.7601L46.9299 39.8101Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3 39.85C48.3 39.74 48.39 39.66 48.5 39.66C48.61 39.66 48.7001 39.74 48.7001 39.85C48.7001 39.96 48.61 40.04 48.5 40.04C48.39 40.05 48.3 39.96 48.3 39.85Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.06 40.2L49.84 39.91L49.22 39.99L49.72 40.35L50.06 40.2Z",
    fill: "#BF1818"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.06 40.2L49.84 39.91L49.22 39.99L49.72 40.35L50.06 40.2Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9399 63.7101C41.5199 63.7101 39.1199 63.1201 37.1099 62.1301C35.6299 61.3901 34.6399 59.9101 34.6399 58.2101V52.0601H53.1999V58.2101C53.1999 59.9101 52.2199 61.3901 50.7299 62.1301C48.7199 63.1201 46.3599 63.7101 43.9399 63.7101Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.39 60.98C44.78 61.1 44.97 61.38 44.97 61.72C44.97 62.16 44.54 62.49 43.99 62.49C43.44 62.49 42.99 62.16 42.99 61.72C42.99 61.39 43.17 61.02 43.56 60.99C43.56 60.99 43.55 60.95 43.51 60.9C43.47 60.86 43.39 60.78 43.39 60.78C43.39 60.78 43.54 60.75 43.62 60.78C43.7 60.81 43.76 60.87 43.76 60.87C43.76 60.87 43.8 60.79 43.86 60.73C43.92 60.67 43.99 60.63 43.99 60.63C43.99 60.63 44.07 60.7 44.1 60.75C44.13 60.8 44.15 60.86 44.15 60.86C44.15 60.86 44.23 60.8 44.3 60.77C44.37 60.74 44.45 60.72 44.45 60.72C44.45 60.72 44.43 60.8 44.41 60.85C44.4 60.89 44.39 60.98 44.39 60.98Z",
    fill: "#F4D795"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.39 60.98C44.78 61.1 44.97 61.38 44.97 61.72C44.97 62.16 44.54 62.49 43.99 62.49C43.44 62.49 42.99 62.16 42.99 61.72C42.99 61.39 43.17 61.02 43.56 60.99C43.56 60.99 43.55 60.95 43.51 60.9C43.47 60.86 43.39 60.78 43.39 60.78C43.39 60.78 43.54 60.75 43.62 60.78C43.7 60.81 43.76 60.87 43.76 60.87C43.76 60.87 43.8 60.79 43.86 60.73C43.92 60.67 43.99 60.63 43.99 60.63C43.99 60.63 44.07 60.7 44.1 60.75C44.13 60.8 44.15 60.86 44.15 60.86C44.15 60.86 44.23 60.8 44.3 60.77C44.37 60.74 44.45 60.72 44.45 60.72C44.45 60.72 44.43 60.8 44.41 60.85C44.4 60.89 44.39 60.98 44.39 60.98Z",
    stroke: "#020203",
    strokeWidth: 0.0841,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.91 62.9701C43.91 62.9701 43.17 62.4701 42.86 62.4101C42.45 62.3201 41.99 62.3901 41.79 62.3801C41.8 62.3901 42.03 62.5501 42.13 62.6501C42.23 62.7501 42.57 62.9601 42.76 63.0001C43.36 63.1501 43.91 62.9701 43.91 62.9701Z",
    fill: "#419846",
    stroke: "#020203",
    strokeWidth: 0.0539,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.91 62.9701C43.91 62.9701 43.17 62.4701 42.86 62.4101C42.45 62.3201 41.99 62.3901 41.79 62.3801C41.8 62.3901 42.03 62.5501 42.13 62.6501C42.23 62.7501 42.57 62.9601 42.76 63.0001C43.36 63.1501 43.91 62.9701 43.91 62.9701Z",
    stroke: "#020203",
    strokeWidth: 0.0841,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1201 63.0101C44.1201 63.0101 44.5901 62.5201 45.0801 62.4501C45.6601 62.3701 46.0401 62.5001 46.2701 62.5601C46.2801 62.5601 46.0801 62.6501 45.9801 62.7201C45.8801 62.7901 45.6201 63.0101 45.2201 63.0101C44.8201 63.0201 44.3701 62.9701 44.3001 62.9801C44.2301 62.9901 44.1201 63.0101 44.1201 63.0101Z",
    fill: "#419846",
    stroke: "#020203",
    strokeWidth: 0.0539,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1201 63.0101C44.1201 63.0101 44.5901 62.5201 45.0801 62.4501C45.6601 62.3701 46.0401 62.5001 46.2701 62.5601C46.2801 62.5601 46.0801 62.6501 45.9801 62.7201C45.8801 62.7901 45.6201 63.0101 45.2201 63.0101C44.8201 63.0201 44.3701 62.9701 44.3001 62.9801C44.2301 62.9901 44.1201 63.0101 44.1201 63.0101Z",
    stroke: "#020203",
    strokeWidth: 0.0841,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9799 62.41C43.7999 62.24 43.6799 61.99 43.6799 61.72C43.6799 61.45 43.7999 61.21 43.9799 61.03C44.1599 61.2 44.2799 61.45 44.2799 61.72C44.2799 61.99 44.1599 62.23 43.9799 62.41Z",
    fill: "#BF1818"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9799 62.41C43.7999 62.24 43.6799 61.99 43.6799 61.72C43.6799 61.45 43.7999 61.21 43.9799 61.03C44.1599 61.2 44.2799 61.45 44.2799 61.72C44.2799 61.99 44.1599 62.23 43.9799 62.41Z",
    stroke: "#020203",
    strokeWidth: 0.0841,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9901 63.41C43.9901 63.41 43.9401 63.27 43.9401 63.01C43.9401 62.57 43.8801 62.49 43.8801 62.49L43.9801 62.41L44.0601 62.49C44.0601 62.49 44.0801 62.75 44.1101 62.93C44.1501 63.13 44.1901 63.35 44.2201 63.48L43.9901 63.41Z",
    fill: "#419846",
    stroke: "#020203",
    strokeWidth: 0.0539,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9901 63.41C43.9901 63.41 43.9401 63.27 43.9401 63.01C43.9401 62.57 43.8801 62.49 43.8801 62.49L43.9801 62.41L44.0601 62.49C44.0601 62.49 44.0801 62.75 44.1101 62.93C44.1501 63.13 44.1901 63.35 44.2201 63.48L43.9901 63.41Z",
    stroke: "#020203",
    strokeWidth: 0.0841,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9101 58.21C43.9101 60.64 41.8501 62.6101 39.2801 62.6101C36.7101 62.6101 34.6301 60.64 34.6301 58.21V52.05H43.9101V58.21Z",
    fill: "#BF1818"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9101 58.21C43.9101 60.64 41.8501 62.6101 39.2801 62.6101C36.7101 62.6101 34.6301 60.64 34.6301 58.21V52.05H43.9101V58.21Z",
    stroke: "#020203",
    strokeWidth: 0.0841,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6101 58.12C34.6401 59.42 35.1601 60.38 35.6701 61.02V51.88H34.6201L34.6101 58.12Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.0841,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6599 61.8401C36.9499 61.9901 37.3499 62.2501 37.7699 62.3501L37.7399 51.8201H36.6499V61.8401H36.6599Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.0841,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.73 62.5801C39.16 62.6201 39.47 62.6201 39.81 62.5801V51.8201H38.73V62.5801Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.0841,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.77 62.3501C41.19 62.2701 41.68 62.0001 41.88 61.8601V51.8201H40.8L40.77 62.3501Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.0841,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8901 60.9201C43.3401 60.5201 43.7701 59.6001 43.9201 58.5601L43.9501 51.8201H42.8601L42.8901 60.9201Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.0841,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2099 52.04V58.2C53.2099 60.63 51.1299 62.6 48.5599 62.6C45.9899 62.6 43.9099 60.63 43.9099 58.2V52.04H53.2099Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7699 57.25C51.9699 57.19 52.1199 57.01 52.1199 56.79C52.1199 56.58 51.9699 56.39 51.7599 56.33V55.58L52.0899 55.49V54.67L51.7599 54.58V53.83C51.9599 53.77 52.0999 53.59 52.0999 53.38C52.0999 53.12 51.8699 52.9 51.5899 52.9C51.3599 52.9 51.1699 53.04 51.1099 53.23H50.5399L50.4499 52.92H49.5799L49.4899 53.23H48.9899C48.9199 53.04 48.7399 52.9 48.5199 52.9H48.5099C48.2899 52.9 48.0999 53.04 48.0399 53.23H47.5399L47.4499 52.92H46.5799L46.4899 53.23H45.9199C45.8499 53.04 45.6599 52.9 45.4399 52.9C45.1599 52.9 44.9299 53.11 44.9299 53.38C44.9299 53.59 45.0699 53.77 45.2699 53.83V54.58L44.9499 54.67V55.49L45.2699 55.58V56.33C45.0699 56.39 44.9199 56.58 44.9199 56.79C44.9199 57 45.0699 57.19 45.2699 57.25V57.74L44.9499 57.85L44.9999 58.67L45.1899 58.72C45.2699 58.73 45.3099 58.73 45.3399 58.73C45.3799 58.96 45.4399 59.19 45.5299 59.4L45.4999 59.43C45.3199 59.63 45.3399 59.93 45.5599 60.1C45.6999 60.21 45.8799 60.24 46.0399 60.19C46.1699 60.34 46.3399 60.46 46.4999 60.58L46.4299 60.91C46.6699 61.08 46.9399 61.22 47.2199 61.33L47.4699 61.09C47.6599 61.15 47.8499 61.22 48.0499 61.25C48.0999 61.46 48.2899 61.61 48.5199 61.62H48.5399C48.7699 61.61 48.9599 61.45 49.0099 61.25C49.2299 61.22 49.4399 61.15 49.6499 61.07C49.6399 61.08 49.6199 61.08 49.6099 61.09L49.8599 61.33C50.1399 61.22 50.3999 61.08 50.6399 60.92L50.5699 60.58C50.7299 60.46 50.8999 60.34 51.0299 60.19C51.1899 60.24 51.3699 60.21 51.5099 60.1C51.7199 59.93 51.7499 59.63 51.5599 59.43L51.5399 59.4C51.6399 59.18 51.6899 58.95 51.7399 58.71L52.0699 58.67L52.1199 57.85L51.7999 57.74V57.25H51.7699ZM51.8299 56.79C51.8299 56.9 51.7299 56.99 51.6099 56.99C51.4899 56.99 51.3899 56.9 51.3899 56.79C51.3899 56.68 51.4899 56.59 51.6099 56.59C51.7299 56.59 51.8299 56.68 51.8299 56.79ZM51.7699 54.83V55.31H51.4599V54.83H51.7699ZM51.3999 53.83C51.4099 53.83 51.4399 53.83 51.4499 53.84V54.58L51.1299 54.67V55.49L51.4499 55.58V56.33C51.2999 56.38 51.1799 56.49 51.1299 56.64H50.5399L50.4499 56.33H49.5799L49.4899 56.64H48.9899C48.9799 56.62 48.9699 56.59 48.9499 56.57L49.7399 55.69L50.0499 55.82L50.6199 55.19L50.4299 54.92L51.3999 53.83ZM50.2899 56.65V56.95H49.7599V56.65H50.2899ZM49.6699 55.3L49.9999 54.94L50.2399 55.13L49.9099 55.5L49.6699 55.3ZM49.7599 53.23H50.2699V53.53H49.7599V53.23ZM48.6599 53.84C48.8199 53.79 48.9399 53.68 48.9899 53.53H49.4899L49.5799 53.84H50.4499L50.5399 53.53H51.1099C51.1199 53.57 51.1399 53.61 51.1599 53.64L50.1699 54.74L49.8599 54.61L49.2899 55.24L49.4799 55.51L48.7099 56.37C48.6899 56.36 48.6799 56.35 48.6599 56.35V55.2L48.9899 55.11V54.28L48.6599 54.19V53.84ZM48.5199 54.45H48.6599V54.93H48.5099H48.4999H48.3499V54.45H48.4899H48.5199ZM46.7599 53.23H47.2699V53.53H46.7599V53.23ZM45.9099 53.53H46.4799L46.5699 53.84H47.4399L47.5299 53.53H48.0299C48.0799 53.68 48.1999 53.79 48.3599 53.84V54.19L48.0299 54.28V55.11L48.3599 55.2V56.35C48.3399 56.36 48.3299 56.37 48.3099 56.37L47.5399 55.51L47.7199 55.24L47.1499 54.61L46.8399 54.74L45.8499 53.64C45.8799 53.6 45.8899 53.57 45.9099 53.53ZM47.3499 55.3L47.1099 55.49L46.7799 55.12L47.0199 54.93L47.3499 55.3ZM45.6199 53.83L46.6099 54.94L46.4299 55.21L46.9899 55.84L47.2999 55.71L48.0899 56.59C48.0799 56.61 48.0599 56.64 48.0599 56.66H47.5499L47.4599 56.35H46.5899L46.4999 56.66H45.9099C45.8599 56.51 45.7399 56.4 45.5899 56.35L45.5999 55.6L45.9199 55.51V54.69L45.5999 54.6L45.5899 53.86C45.5799 53.83 45.6099 53.83 45.6199 53.83ZM47.2599 56.65V56.95H46.7299V56.65H47.2599ZM45.2599 55.32V54.84H45.5699V55.32H45.2599ZM45.1899 56.79C45.1899 56.68 45.2899 56.59 45.4099 56.59C45.5299 56.59 45.6199 56.68 45.6199 56.79C45.6199 56.9 45.5199 56.99 45.4099 56.99C45.2899 56.99 45.1899 56.9 45.1899 56.79ZM45.3199 58.47C45.3099 58.39 45.2499 58.29 45.2499 58.21V57.99H45.5399V58.21C45.5399 58.3 45.5499 58.39 45.5599 58.48L45.3199 58.47ZM45.7799 59.26C45.7099 59.09 45.6599 58.9 45.6199 58.72H45.6099C45.6099 58.72 45.6099 58.72 45.6099 58.71L45.9399 58.61C45.9399 58.61 45.9099 58.25 45.8999 58.19C45.8999 58.15 45.8899 57.79 45.8899 57.79L45.5699 57.72V57.24C45.7199 57.19 45.8299 57.08 45.8799 56.94H46.4799L46.5699 57.25H47.4399L47.5299 56.94H48.0399C48.0499 56.97 48.0599 57 48.0799 57.02L47.3399 57.84L47.0299 57.71L46.4599 58.34L46.6399 58.61L46.0299 59.29C45.9699 59.26 45.8699 59.25 45.7799 59.26ZM47.4099 58.24L47.0799 58.61L46.8399 58.42L47.1699 58.05L47.4099 58.24ZM47.1899 60.97C47.0399 60.9 46.8899 60.82 46.7499 60.73L46.8699 60.52C47.0099 60.61 47.1499 60.7 47.3099 60.77L47.1899 60.97ZM48.3699 60.7C48.2399 60.74 48.1399 60.84 48.0799 60.96C47.9099 60.94 47.7499 60.88 47.5899 60.83L47.6499 60.57C47.3599 60.47 47.0899 60.33 46.8599 60.15L46.6599 60.34C46.5299 60.24 46.3899 60.14 46.2799 60.02C46.3999 59.86 46.4099 59.65 46.2999 59.49L46.9099 58.81L47.2199 58.94L47.7899 58.31L47.6099 58.04L48.3399 57.22C48.3499 57.23 48.3599 57.23 48.3799 57.24V58.65L48.0499 58.74V59.56L48.3799 59.65L48.3699 60.7ZM48.5099 59.4H48.3699V58.92H48.5099H48.6499V59.4H48.5099ZM49.8399 60.98L49.7199 60.77C49.8699 60.7 50.0199 60.62 50.1599 60.53L50.2899 60.75C50.1399 60.83 49.9899 60.91 49.8399 60.98ZM50.3799 60.33L50.1799 60.15C49.9399 60.33 49.6699 60.47 49.3799 60.56L49.4399 60.82C49.2799 60.87 49.1199 60.93 48.9499 60.95C48.8899 60.83 48.7899 60.74 48.6599 60.69V59.65L48.9899 59.56V58.74L48.6599 58.65V57.24C48.6699 57.24 48.6899 57.23 48.6999 57.22L49.4399 58.04L49.2499 58.31L49.8199 58.94L50.1299 58.81L50.7399 59.49C50.6399 59.65 50.6399 59.86 50.7599 60.02C50.6399 60.13 50.4999 60.23 50.3799 60.33ZM49.6099 58.24L49.8499 58.05L50.1799 58.42L49.9399 58.61L49.6099 58.24ZM51.3999 58.72C51.3599 58.91 51.3199 59.09 51.2399 59.26C51.1499 59.25 51.0599 59.26 50.9699 59.29L50.3599 58.61L50.5499 58.34L49.9799 57.71L49.6699 57.84L48.9299 57.02C48.9499 56.99 48.9599 56.97 48.9699 56.94H49.4799L49.5699 57.25H50.4399L50.5299 56.94H51.1299C51.1799 57.08 51.2999 57.19 51.4399 57.24V57.72L51.1199 57.79C51.1199 57.79 51.1099 58.15 51.1099 58.19C51.0999 58.25 51.0699 58.61 51.0699 58.61L51.3999 58.72C51.4099 58.72 51.4099 58.72 51.3999 58.72ZM51.7699 58.21C51.7699 58.3 51.7499 58.39 51.7499 58.47H51.4599C51.4699 58.38 51.4799 58.29 51.4799 58.2V57.98H51.7699V58.21Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3999 58.72C51.3599 58.91 51.3199 59.09 51.2399 59.26C51.1499 59.25 51.0599 59.26 50.9699 59.29L50.3599 58.61L50.5499 58.34L49.9799 57.71L49.6699 57.84L48.9299 57.02C48.9499 56.99 48.9599 56.97 48.9699 56.94H49.4799L49.5699 57.25H50.4399L50.5299 56.94H51.1299C51.1799 57.08 51.2999 57.19 51.4399 57.24V57.72L51.1199 57.79C51.1199 57.79 51.1099 58.15 51.1099 58.19C51.0999 58.25 51.0699 58.61 51.0699 58.61L51.3999 58.72ZM51.3999 58.72C51.4099 58.72 51.4099 58.72 51.3999 58.72ZM51.7699 57.25C51.9699 57.19 52.1199 57.01 52.1199 56.79C52.1199 56.58 51.9699 56.39 51.7599 56.33V55.58L52.0899 55.49V54.67L51.7599 54.58V53.83C51.9599 53.77 52.0999 53.59 52.0999 53.38C52.0999 53.12 51.8699 52.9 51.5899 52.9C51.3599 52.9 51.1699 53.04 51.1099 53.23H50.5399L50.4499 52.92H49.5799L49.4899 53.23H48.9899C48.9199 53.04 48.7399 52.9 48.5199 52.9H48.5099C48.2899 52.9 48.0999 53.04 48.0399 53.23H47.5399L47.4499 52.92H46.5799L46.4899 53.23H45.9199C45.8499 53.04 45.6599 52.9 45.4399 52.9C45.1599 52.9 44.9299 53.11 44.9299 53.38C44.9299 53.59 45.0699 53.77 45.2699 53.83V54.58L44.9499 54.67V55.49L45.2699 55.58V56.33C45.0699 56.39 44.9199 56.58 44.9199 56.79C44.9199 57 45.0699 57.19 45.2699 57.25V57.74L44.9499 57.85L44.9999 58.67L45.1899 58.72C45.2699 58.73 45.3099 58.73 45.3399 58.73C45.3799 58.96 45.4399 59.19 45.5299 59.4L45.4999 59.43C45.3199 59.63 45.3399 59.93 45.5599 60.1C45.6999 60.21 45.8799 60.24 46.0399 60.19C46.1699 60.34 46.3399 60.46 46.4999 60.58L46.4299 60.91C46.6699 61.08 46.9399 61.22 47.2199 61.33L47.4699 61.09C47.6599 61.15 47.8499 61.22 48.0499 61.25C48.0999 61.46 48.2899 61.61 48.5199 61.62H48.5399C48.7699 61.61 48.9599 61.45 49.0099 61.25C49.2299 61.22 49.4399 61.15 49.6499 61.07C49.6399 61.08 49.6199 61.08 49.6099 61.09L49.8599 61.33C50.1399 61.22 50.3999 61.08 50.6399 60.92L50.5699 60.58C50.7299 60.46 50.8999 60.34 51.0299 60.19C51.1899 60.24 51.3699 60.21 51.5099 60.1C51.7199 59.93 51.7499 59.63 51.5599 59.43L51.5399 59.4C51.6399 59.18 51.6899 58.95 51.7399 58.71L52.0699 58.67L52.1199 57.85L51.7999 57.74V57.25H51.7699ZM51.8299 56.79C51.8299 56.9 51.7299 56.99 51.6099 56.99C51.4899 56.99 51.3899 56.9 51.3899 56.79C51.3899 56.68 51.4899 56.59 51.6099 56.59C51.7299 56.59 51.8299 56.68 51.8299 56.79ZM51.7699 54.83V55.31H51.4599V54.83H51.7699ZM51.3999 53.83C51.4099 53.83 51.4399 53.83 51.4499 53.84V54.58L51.1299 54.67V55.49L51.4499 55.58V56.33C51.2999 56.38 51.1799 56.49 51.1299 56.64H50.5399L50.4499 56.33H49.5799L49.4899 56.64H48.9899C48.9799 56.62 48.9699 56.59 48.9499 56.57L49.7399 55.69L50.0499 55.82L50.6199 55.19L50.4299 54.92L51.3999 53.83ZM50.2899 56.65V56.95H49.7599V56.65H50.2899ZM49.6699 55.3L49.9999 54.94L50.2399 55.13L49.9099 55.5L49.6699 55.3ZM49.7599 53.23H50.2699V53.53H49.7599V53.23ZM48.6599 53.84C48.8199 53.79 48.9399 53.68 48.9899 53.53H49.4899L49.5799 53.84H50.4499L50.5399 53.53H51.1099C51.1199 53.57 51.1399 53.61 51.1599 53.64L50.1699 54.74L49.8599 54.61L49.2899 55.24L49.4799 55.51L48.7099 56.37C48.6899 56.36 48.6799 56.35 48.6599 56.35V55.2L48.9899 55.11V54.28L48.6599 54.19V53.84ZM48.5199 54.45H48.6599V54.93H48.5099H48.4999H48.3499V54.45H48.4899H48.5199ZM46.7599 53.23H47.2699V53.53H46.7599V53.23ZM45.9099 53.53H46.4799L46.5699 53.84H47.4399L47.5299 53.53H48.0299C48.0799 53.68 48.1999 53.79 48.3599 53.84V54.19L48.0299 54.28V55.11L48.3599 55.2V56.35C48.3399 56.36 48.3299 56.37 48.3099 56.37L47.5399 55.51L47.7199 55.24L47.1499 54.61L46.8399 54.74L45.8499 53.64C45.8799 53.6 45.8899 53.57 45.9099 53.53ZM47.3499 55.3L47.1099 55.49L46.7799 55.12L47.0199 54.93L47.3499 55.3ZM45.6199 53.83L46.6099 54.94L46.4299 55.21L46.9899 55.84L47.2999 55.71L48.0899 56.59C48.0799 56.61 48.0599 56.64 48.0599 56.66H47.5499L47.4599 56.35H46.5899L46.4999 56.66H45.9099C45.8599 56.51 45.7399 56.4 45.5899 56.35L45.5999 55.6L45.9199 55.51V54.69L45.5999 54.6L45.5899 53.86C45.5799 53.83 45.6099 53.83 45.6199 53.83ZM47.2599 56.65V56.95H46.7299V56.65H47.2599ZM45.2599 55.32V54.84H45.5699V55.32H45.2599ZM45.1899 56.79C45.1899 56.68 45.2899 56.59 45.4099 56.59C45.5299 56.59 45.6199 56.68 45.6199 56.79C45.6199 56.9 45.5199 56.99 45.4099 56.99C45.2899 56.99 45.1899 56.9 45.1899 56.79ZM45.3199 58.47C45.3099 58.39 45.2499 58.29 45.2499 58.21V57.99H45.5399V58.21C45.5399 58.3 45.5499 58.39 45.5599 58.48L45.3199 58.47ZM45.7799 59.26C45.7099 59.09 45.6599 58.9 45.6199 58.72H45.6099C45.6099 58.72 45.6099 58.72 45.6099 58.71L45.9399 58.61C45.9399 58.61 45.9099 58.25 45.8999 58.19C45.8999 58.15 45.8899 57.79 45.8899 57.79L45.5699 57.72V57.24C45.7199 57.19 45.8299 57.08 45.8799 56.94H46.4799L46.5699 57.25H47.4399L47.5299 56.94H48.0399C48.0499 56.97 48.0599 57 48.0799 57.02L47.3399 57.84L47.0299 57.71L46.4599 58.34L46.6399 58.61L46.0299 59.29C45.9699 59.26 45.8699 59.25 45.7799 59.26ZM47.4099 58.24L47.0799 58.61L46.8399 58.42L47.1699 58.05L47.4099 58.24ZM47.1899 60.97C47.0399 60.9 46.8899 60.82 46.7499 60.73L46.8699 60.52C47.0099 60.61 47.1499 60.7 47.3099 60.77L47.1899 60.97ZM48.3699 60.7C48.2399 60.74 48.1399 60.84 48.0799 60.96C47.9099 60.94 47.7499 60.88 47.5899 60.83L47.6499 60.57C47.3599 60.47 47.0899 60.33 46.8599 60.15L46.6599 60.34C46.5299 60.24 46.3899 60.14 46.2799 60.02C46.3999 59.86 46.4099 59.65 46.2999 59.49L46.9099 58.81L47.2199 58.94L47.7899 58.31L47.6099 58.04L48.3399 57.22C48.3499 57.23 48.3599 57.23 48.3799 57.24V58.65L48.0499 58.74V59.56L48.3799 59.65L48.3699 60.7ZM48.5099 59.4H48.3699V58.92H48.5099H48.6499V59.4H48.5099ZM49.8399 60.98L49.7199 60.77C49.8699 60.7 50.0199 60.62 50.1599 60.53L50.2899 60.75C50.1399 60.83 49.9899 60.91 49.8399 60.98ZM50.3799 60.33L50.1799 60.15C49.9399 60.33 49.6699 60.47 49.3799 60.56L49.4399 60.82C49.2799 60.87 49.1199 60.93 48.9499 60.95C48.8899 60.83 48.7899 60.74 48.6599 60.69V59.65L48.9899 59.56V58.74L48.6599 58.65V57.24C48.6699 57.24 48.6899 57.23 48.6999 57.22L49.4399 58.04L49.2499 58.31L49.8199 58.94L50.1299 58.81L50.7399 59.49C50.6399 59.65 50.6399 59.86 50.7599 60.02C50.6399 60.13 50.4999 60.23 50.3799 60.33ZM49.6099 58.24L49.8499 58.05L50.1799 58.42L49.9399 58.61L49.6099 58.24ZM51.7699 58.21C51.7699 58.3 51.7499 58.39 51.7499 58.47H51.4599C51.4699 58.38 51.4799 58.29 51.4799 58.2V57.98H51.7699V58.21Z",
    stroke: "#020203",
    strokeWidth: 0.0596,
    strokeMiterlimit: 22.9256,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.03 56.8001C48.03 56.5301 48.26 56.3201 48.54 56.3201C48.82 56.3201 49.05 56.5301 49.05 56.8001C49.05 57.0601 48.82 57.2801 48.54 57.2801C48.25 57.2701 48.03 57.0601 48.03 56.8001Z",
    fill: "#4BAA7C",
    stroke: "#020203",
    strokeWidth: 0.0543,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9101 41.75H34.6301V52.05H43.9101V41.75Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8099 44.1301H37.6399V43.9601H37.3399V44.6401H37.6399V45.1101H36.9999V46.4801H37.3399V49.2101H36.6599V50.6201H41.9099V49.2101H41.2299V46.4801H41.5699V45.1101H40.9299V44.6401H41.2299V43.9601H40.9299V44.1301H40.7599V43.9601H40.4599V44.1301H40.2499V43.9601H39.9499V44.6401H40.2499V45.1101H39.6099V43.6101H39.9499V42.9301H39.6099V43.1001H39.4399V42.9301H39.1399V43.1001H38.9699V42.9301H38.6299V43.6101H38.9699V45.1101H38.3299V44.6401H38.6299V43.9601H38.3299V44.1301H38.1599V43.9601H37.8199V44.1301H37.8099Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6399 44.6401H37.3399V43.9601H37.6399V44.1301H37.8099H37.8199V43.9601H38.1599V44.1301H38.3299V43.9601H38.6299V44.6401H38.3299V45.1101H38.9699V43.6101H38.6299V42.9301H38.9699V43.1001H39.1399V42.9301H39.4399V43.1001H39.6099V42.9301H39.9499V43.6101H39.6099V45.1101H40.2499V44.6401M37.6399 44.6401V45.1101M37.6399 44.6401H38.3199M37.6399 45.1101H36.9999V46.4801M37.6399 45.1101H40.9299M36.9999 46.4801H37.3399M36.9999 46.4801H41.5699M37.3399 46.4801V49.2101H36.6599M37.3399 46.4801V46.1401M36.6599 49.2101V50.6201H41.9099V49.2101M36.6599 49.2101H41.9099M41.9099 49.2101H41.2299V46.4801M41.2299 46.4801H41.5699M41.2299 46.4801V46.1401M41.5699 46.4801V45.1101H40.9299M40.9299 45.1101V44.6401M40.9299 44.6401H41.2299V43.9601H40.9299V44.1301H40.7599V43.9601H40.4599V44.1301H40.2499V43.9601H39.9499V44.6401H40.2499M40.9299 44.6401H40.2499M36.6599 50.2801H41.9099M36.6599 49.9401H41.9099M36.6599 49.6001H41.9099M37.3399 48.9101H41.2299M37.3399 48.5701H41.2299M37.3399 48.1901H41.2299M37.3399 47.8501H41.2299M37.3399 47.5001H41.2299M37.3399 47.1601H41.2299M37.3399 46.8201H41.2299M36.9999 46.1401H41.5699M36.9999 45.7901H41.5699M36.9999 45.4501H41.5699M38.9699 44.7701H39.6099M38.9699 44.4301H39.6099M38.9699 44.0901H39.6099M38.9699 43.7401H39.6099M38.6299 43.3201H39.9499M37.6399 44.7701H38.3199M37.3399 44.3401H38.6199M37.3399 50.6201V50.2801M37.3399 49.9401V49.6001M36.9999 49.9401V50.2801M37.6399 50.2801V49.9401M37.9799 50.6201V50.2801M37.9799 49.9401V49.6001M37.9799 49.2101V48.9101M37.9799 48.5701V48.1901M37.6399 49.6001V49.2201M36.9999 49.6001V49.2201M38.3299 49.2101V49.5901M38.6299 49.2101V48.9101M37.6399 48.5701V48.9101M38.3299 48.5701V48.9101M38.9699 48.5701V48.9101M38.6299 48.5701V48.1901M38.9699 47.8501V48.1901M38.9699 47.1601V47.5001M38.6299 46.8201V47.1601M38.9699 46.4801V46.8201M38.3299 46.4801V46.8201M37.6399 46.4801V46.8201M37.9799 46.1401V46.4801M38.6299 46.1401V46.4801M38.9699 45.7901V46.1301M38.3299 45.7901V46.1301M37.6399 45.7901V46.1301M37.3399 45.4501V45.7901M38.6299 45.4501V45.7901M37.9799 44.7701V45.1101M40.9299 44.7701H40.2499M41.2299 44.3401H39.9499M41.2299 50.6201V50.2801M41.2299 49.9401V49.6001M41.5699 49.9401V50.2801M40.9299 50.2801V49.9401M40.5899 50.6201V50.2801M40.5899 49.9401V49.6001M40.5899 49.2101V48.9101M40.5899 48.5701V48.1901M40.9299 49.6001V49.2201M41.5699 49.6001V49.2201M40.2499 49.2101V49.5901M39.9499 49.2101V48.9101M40.9299 48.5701V48.9101M40.2499 48.5701V48.9101M39.6099 48.5701V48.9101M39.9499 48.5701V48.1901M39.6099 47.8501V48.1901M39.6099 47.1601V47.5001M39.9499 46.8201V47.1601M39.6099 46.4801V46.8201M40.2499 46.4801V46.8201M40.9299 46.4801V46.8201M40.5899 46.1401V46.4801M39.9499 46.1401V46.4801M39.6099 45.7901V46.1301M40.2499 45.7901V46.1301M40.9299 45.7901V46.1301M41.2299 45.4501V45.7901M39.9499 45.4501V45.7901M40.5899 44.7701V45.1101M39.2699 48.5701V48.1901M39.2699 47.1601V46.8201M39.2699 47.8501V47.5001M39.2699 46.4801V46.1401M39.2699 45.7901V45.4501M39.2699 44.7701V44.4301M39.2699 44.0901V43.7501M38.9699 43.6201H39.6099",
    stroke: "#020203",
    strokeWidth: 0.0744,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1599 50.62V49.72C40.1599 49.55 40.0799 49.04 39.2599 49.04C38.4899 49.04 38.4099 49.55 38.4099 49.72V50.62H40.1599Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.0744,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.71 49.7701L38.28 49.7301C38.28 49.5601 38.32 49.3001 38.45 49.2201L38.83 49.5201C38.8 49.5501 38.71 49.6801 38.71 49.7701Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.0744,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4399 49.34L39.6499 48.96C39.5699 48.92 39.3899 48.88 39.2699 48.88C39.1899 48.88 39.0099 48.92 38.9299 48.96L39.1399 49.34H39.4399Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.0744,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.86 49.7701L40.29 49.7301C40.29 49.5601 40.25 49.3001 40.12 49.2201L39.74 49.5201C39.78 49.5501 39.86 49.6801 39.86 49.7701Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.0744,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6299 48.2701V47.3301C38.6299 47.0701 38.4599 46.8601 38.1599 46.8601C37.8599 46.8601 37.6899 47.0701 37.6899 47.3301V48.2701H38.6299Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.0744,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.95 48.2701V47.3301C39.95 47.0701 40.1199 46.8601 40.4199 46.8601C40.7199 46.8601 40.8899 47.0701 40.8899 47.3301V48.2701H39.95Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.0744,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3301 45.9701L38.3701 45.1101H37.5601L37.6401 45.9701H38.3301Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.0744,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6101 45.9701L39.6901 45.1101H38.8801L38.9301 45.9701H39.6101Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.0744,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2499 45.9701L40.1599 45.1101H41.0199L40.9299 45.9701H40.2499Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.0744,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.86 50.6201V49.8501C39.86 49.7201 39.7799 49.3401 39.2599 49.3401C38.7899 49.3401 38.7 49.7201 38.7 49.8501V50.6201H39.86Z",
    fill: "#419846",
    stroke: "#020203",
    strokeWidth: 0.0539,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.54 48.1901V47.3801C38.54 47.1701 38.41 46.9501 38.15 46.9501C37.89 46.9501 37.77 47.1601 37.77 47.3801V48.1901H38.54Z",
    fill: "#419846"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.04 48.1901V47.3801C40.04 47.1701 40.17 46.9501 40.43 46.9501C40.68 46.9501 40.81 47.1601 40.81 47.3801V48.1901H40.04Z",
    fill: "#419846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1999 41.75H43.8999V52.05H53.1999V41.75Z",
    fill: "#E9E8E8",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.64 44.2901L48.65 44.1801L48.67 44.1201C48.67 44.1201 48.37 44.1401 48.22 44.1001C48.06 44.0601 47.92 43.9901 47.78 43.8701C47.63 43.7401 47.58 43.6701 47.47 43.6501C47.22 43.6101 47.03 43.7201 47.03 43.7201C47.03 43.7201 47.22 43.7901 47.36 43.9601C47.5 44.1301 47.65 44.2201 47.72 44.2401C47.83 44.2701 48.21 44.2501 48.32 44.2501C48.41 44.2601 48.64 44.2901 48.64 44.2901Z",
    fill: "#C14A46",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0399 43.8701C50.0399 43.8701 50.0399 44.0001 50.0599 44.1301C50.0699 44.2501 50.0199 44.3601 50.0399 44.4301C50.0599 44.5001 50.0699 44.5501 50.0899 44.6001C50.1099 44.6501 50.1299 44.7701 50.1299 44.7701C50.1299 44.7701 50.0599 44.7201 49.9899 44.6701C49.9299 44.6201 49.8799 44.5901 49.8799 44.5901C49.8799 44.5901 49.8899 44.7201 49.8999 44.7801C49.9099 44.8401 49.9399 44.9501 49.9899 45.0101C50.0399 45.0701 50.1499 45.1801 50.1799 45.2601C50.2099 45.3401 50.2099 45.5301 50.2099 45.5301C50.2099 45.5301 50.1199 45.3901 50.0499 45.3701C49.9799 45.3501 49.8199 45.2601 49.8199 45.2601C49.8199 45.2601 49.9699 45.4101 49.9699 45.5501C49.9699 45.6901 49.9099 45.8501 49.9099 45.8501C49.9099 45.8501 49.8399 45.7301 49.7599 45.6401C49.6699 45.5601 49.5499 45.4701 49.5499 45.4701C49.5499 45.4701 49.6499 45.6901 49.6499 45.8301C49.6499 45.9801 49.6199 46.2901 49.6199 46.2901C49.6199 46.2901 49.5499 46.1701 49.4699 46.1101C49.3999 46.0501 49.3099 46.0001 49.2799 45.9701C49.2499 45.9301 49.3699 46.0901 49.3799 46.1801C49.3899 46.2701 49.4399 46.6101 49.7399 47.0501C49.9099 47.3001 50.1799 47.7501 50.7599 47.6001C51.3299 47.4601 51.1199 46.6801 50.9999 46.3201C50.8799 45.9601 50.8199 45.5601 50.8299 45.4201C50.8399 45.2801 50.9399 44.8701 50.9199 44.7901C50.9099 44.7101 50.8699 44.4201 50.9399 44.1801C51.0099 43.9301 51.0799 43.8401 51.1199 43.7401C51.1599 43.6401 51.1899 43.5801 51.1999 43.4901C51.2099 43.4001 51.2099 43.2401 51.2099 43.2401C51.2099 43.2401 51.3199 43.4401 51.3399 43.5101C51.3699 43.5801 51.3699 43.7901 51.3699 43.7901C51.3699 43.7901 51.3899 43.5801 51.5499 43.4801C51.7099 43.3801 51.8999 43.2701 51.9399 43.2101C51.9899 43.1501 51.9999 43.1201 51.9999 43.1201C51.9999 43.1201 51.9899 43.4801 51.8899 43.6101C51.8199 43.7001 51.5599 44.0001 51.5599 44.0001C51.5599 44.0001 51.6999 43.9501 51.7899 43.9401C51.8799 43.9301 51.9499 43.9401 51.9499 43.9401C51.9499 43.9401 51.8399 44.0301 51.6899 44.2401C51.5399 44.4601 51.5999 44.4701 51.4999 44.6501C51.3899 44.8301 51.3099 44.8301 51.1699 44.9401C50.9699 45.1001 51.0799 45.7401 51.0999 45.8401C51.1299 45.9301 51.4699 46.7201 51.4799 46.9101C51.4899 47.1001 51.5199 47.5301 51.1799 47.8001C50.9699 47.9801 50.6099 47.9801 50.5299 48.0301C50.4499 48.0801 50.2899 48.2401 50.2899 48.5701C50.2899 48.9001 50.4099 48.9501 50.4999 49.0301C50.5999 49.1101 50.7099 49.0701 50.7399 49.1301C50.7699 49.1901 50.7799 49.2301 50.8199 49.2701C50.8599 49.3101 50.8899 49.3501 50.8699 49.4201C50.8599 49.4901 50.6999 49.6501 50.6499 49.7601C50.6099 49.8601 50.4999 50.1601 50.4999 50.2001C50.4999 50.2401 50.4899 50.3801 50.5299 50.4501C50.5299 50.4501 50.6999 50.6501 50.5799 50.6801C50.5099 50.7101 50.4399 50.6301 50.3999 50.6401C50.2999 50.6701 50.2499 50.7301 50.2199 50.7201C50.1499 50.7101 50.1499 50.6701 50.1399 50.5801C50.1399 50.4901 50.1399 50.4501 50.1099 50.4501C50.0699 50.4501 50.0499 50.4801 50.0399 50.5301C50.0299 50.5801 50.0299 50.7001 49.9899 50.7001C49.9399 50.7001 49.8799 50.6201 49.8399 50.6001C49.7999 50.5801 49.6899 50.5601 49.6799 50.5101C49.6699 50.4601 49.7499 50.3501 49.8199 50.3301C49.8899 50.3101 49.9599 50.2701 49.9099 50.2401C49.8599 50.2001 49.8199 50.2001 49.7699 50.2401C49.7199 50.2801 49.6199 50.2501 49.6299 50.1901C49.6399 50.1301 49.6499 50.0601 49.6399 50.0301C49.6399 50.0001 49.5499 49.9401 49.6599 49.8801C49.7699 49.8201 49.8199 49.9301 49.9199 49.9101C50.0299 49.8901 50.0799 49.8501 50.1199 49.7901C50.1599 49.7301 50.1499 49.5901 50.0799 49.5101C50.0099 49.4301 49.9299 49.4101 49.9099 49.3601C49.8799 49.3101 49.8399 49.1901 49.8399 49.1901C49.8399 49.1901 49.8599 49.4101 49.8499 49.4401C49.8399 49.4701 49.8399 49.6001 49.8399 49.6001C49.8399 49.6001 49.7699 49.5201 49.7099 49.4601C49.6499 49.4001 49.5899 49.2101 49.5899 49.2101C49.5899 49.2101 49.5799 49.3901 49.5799 49.4601C49.5799 49.5301 49.6599 49.5901 49.6299 49.6201C49.5999 49.6401 49.4799 49.4901 49.4399 49.4601C49.4099 49.4301 49.2999 49.3501 49.2499 49.2601C49.1999 49.1701 49.1699 49.0501 49.1599 49.0001C49.1499 48.9601 49.1299 48.7601 49.1499 48.7101C49.1799 48.6401 49.2399 48.5001 49.2399 48.5001H48.9799C48.8399 48.5001 48.7399 48.4601 48.6899 48.5501C48.6399 48.6401 48.6599 48.8301 48.7299 49.0801C48.7999 49.3301 48.8399 49.4501 48.8199 49.4901C48.7999 49.5301 48.7099 49.6401 48.6799 49.6601C48.6499 49.6801 48.5499 49.6701 48.5099 49.6501C48.4699 49.6301 48.3999 49.6001 48.2799 49.6001C48.1499 49.6001 48.0699 49.6001 48.0299 49.5901C47.9799 49.5801 47.8699 49.5201 47.8099 49.5301C47.7599 49.5401 47.6599 49.5901 47.6899 49.6601C47.7299 49.7701 47.6499 49.8001 47.5999 49.7901C47.5499 49.7801 47.4999 49.7601 47.4299 49.7501C47.3599 49.7301 47.2599 49.7501 47.2799 49.6701C47.2899 49.5901 47.3199 49.5901 47.3499 49.5301C47.3799 49.4701 47.3999 49.4301 47.3599 49.4301C47.3099 49.4301 47.2699 49.4201 47.2299 49.4501C47.1899 49.4801 47.1399 49.5501 47.0899 49.5201C47.0399 49.4901 47.0099 49.4401 47.0099 49.3201C47.0099 49.2001 46.8799 49.1001 46.9999 49.1001C47.1199 49.1101 47.2599 49.1901 47.2899 49.1201C47.3199 49.0601 47.2999 49.0301 47.2399 48.9801C47.1799 48.9301 47.0999 48.9001 47.1799 48.8401C47.2599 48.7801 47.2799 48.7801 47.3199 48.7401C47.3499 48.7101 47.3999 48.5901 47.4499 48.6201C47.5599 48.6701 47.4499 48.7501 47.5699 48.8801C47.6799 49.0101 47.7599 49.0501 47.9499 49.0301C48.1399 49.0101 48.1999 48.9901 48.1999 48.9301C48.1999 48.8801 48.1799 48.7801 48.1799 48.7401C48.1799 48.7001 48.2099 48.5601 48.2099 48.5601C48.2099 48.5601 48.1199 48.6201 48.0899 48.6701C48.0699 48.7201 48.0099 48.8201 48.0099 48.8201C48.0099 48.8201 47.9899 48.7101 47.9999 48.6201C47.9999 48.5701 48.0199 48.4701 48.0199 48.4601C48.0199 48.4101 47.9799 48.2901 47.9799 48.2901C47.9799 48.2901 47.9499 48.4301 47.9299 48.4601C47.9099 48.5001 47.8999 48.6601 47.8999 48.6601C47.8999 48.6601 47.7799 48.5501 47.8099 48.3701C47.8299 48.2301 47.7899 48.0501 47.8299 47.9901C47.8699 47.9301 47.9699 47.6901 48.2099 47.6801C48.4499 47.6701 48.6399 47.6901 48.7199 47.6901C48.7999 47.6801 49.0999 47.6301 49.0999 47.6301C49.0999 47.6301 48.5499 47.3501 48.4299 47.2601C48.2999 47.1801 48.1099 46.9601 48.0499 46.8601C47.9899 46.7601 47.9299 46.5701 47.9299 46.5701C47.9299 46.5701 47.8299 46.5701 47.7399 46.6201C47.6499 46.6701 47.5599 46.7401 47.5099 46.8001C47.4599 46.8601 47.3799 46.9901 47.3799 46.9901C47.3799 46.9901 47.3899 46.8201 47.3899 46.7601C47.3899 46.7101 47.3799 46.6001 47.3799 46.6001C47.3799 46.6001 47.3199 46.8401 47.1899 46.9201C47.0599 47.0101 46.9199 47.1301 46.9199 47.1301C46.9199 47.1301 46.9399 47.0001 46.9399 46.9701C46.9399 46.9401 46.9699 46.7901 46.9699 46.7901C46.9699 46.7901 46.8799 46.9201 46.7499 46.9501C46.6099 46.9701 46.4199 46.9701 46.3999 47.0501C46.3899 47.1301 46.4399 47.2501 46.4099 47.3101C46.3799 47.3701 46.3099 47.4101 46.3099 47.4101C46.3099 47.4101 46.2299 47.3501 46.1599 47.3401C46.0899 47.3301 46.0299 47.3701 46.0299 47.3701C46.0299 47.3701 45.9699 47.3001 45.9999 47.2501C46.0199 47.2001 46.1199 47.1301 46.0999 47.1001C46.0699 47.0701 45.9899 47.1101 45.9399 47.1301C45.8899 47.1601 45.7799 47.1801 45.7899 47.1001C45.7999 47.0201 45.8299 46.9701 45.7999 46.9101C45.7699 46.8501 45.7899 46.8101 45.8299 46.8001C45.8699 46.7801 46.0399 46.8001 46.0499 46.7601C46.0599 46.7201 46.0099 46.6701 45.8999 46.6501C45.7899 46.6201 45.7399 46.5601 45.7899 46.5101C45.8499 46.4501 45.8599 46.4401 45.8899 46.3901C45.9199 46.3401 45.9299 46.2501 46.0299 46.3001C46.1299 46.3401 46.1099 46.4501 46.2099 46.4901C46.3099 46.5201 46.5599 46.4801 46.6099 46.4501C46.6599 46.4201 46.8299 46.3001 46.8899 46.2701C46.9499 46.2401 47.1899 46.0601 47.1899 46.0601C47.1899 46.0601 47.0499 45.9601 46.9999 45.9101C46.9499 45.8601 46.8599 45.7401 46.8099 45.7201C46.7599 45.7001 46.5299 45.6101 46.4599 45.6001C46.3799 45.6001 46.1399 45.5101 46.1399 45.5101C46.1399 45.5101 46.2499 45.4801 46.2899 45.4501C46.3299 45.4201 46.4099 45.3501 46.4499 45.3501C46.4899 45.3501 46.4999 45.3501 46.4999 45.3501C46.4999 45.3501 46.2799 45.3401 46.2299 45.3301C46.1799 45.3201 46.0499 45.2301 45.9899 45.2301C45.9399 45.2301 45.8299 45.2501 45.8299 45.2501C45.8299 45.2501 45.9699 45.1601 46.0899 45.1401C46.1999 45.1201 46.2899 45.1301 46.2899 45.1301C46.2899 45.1301 46.1099 45.0801 46.0699 45.0201C46.0299 44.9601 45.9899 44.8701 45.9599 44.8301C45.9299 44.7901 45.9099 44.7301 45.8499 44.7201C45.7899 44.7101 45.6899 44.7901 45.6399 44.7901C45.5799 44.7801 45.5399 44.7501 45.5299 44.6701C45.5299 44.5901 45.5299 44.6101 45.5099 44.5701C45.4899 44.5301 45.3999 44.4201 45.4799 44.4001C45.5599 44.3801 45.7299 44.4201 45.7399 44.3901C45.7499 44.3601 45.6499 44.2701 45.5799 44.2401C45.5099 44.2101 45.3999 44.1501 45.4599 44.1001C45.5199 44.0501 45.5699 44.0301 45.6099 43.9901C45.6399 43.9501 45.6799 43.8201 45.7499 43.8601C45.8199 43.9001 45.9099 44.0901 45.9599 44.0801C46.0099 44.0701 46.0199 43.9301 46.0099 43.8701C45.9999 43.8101 46.0099 43.7101 46.0599 43.7201C46.1099 43.7301 46.1499 43.8001 46.2399 43.8001C46.3199 43.8001 46.4499 43.7801 46.4399 43.8401C46.4299 43.9001 46.3799 43.9701 46.3299 44.0401C46.2699 44.1101 46.2499 44.2301 46.2799 44.3201C46.3199 44.4101 46.4099 44.5401 46.4899 44.5901C46.5699 44.6401 46.7299 44.6801 46.8299 44.7501C46.9299 44.8201 47.1599 45.0001 47.2399 45.0201C47.3199 45.0401 47.3999 45.0801 47.3999 45.0801C47.3999 45.0801 47.4899 45.0401 47.6099 45.0401C47.7299 45.0401 48.0099 45.0601 48.1099 45.0101C48.2099 44.9601 48.3499 44.8901 48.3099 44.8001C48.2699 44.7101 48.0399 44.6201 48.0599 44.5501C48.0799 44.4801 48.1699 44.4701 48.3099 44.4701C48.4499 44.4701 48.6399 44.5001 48.6799 44.3001C48.7199 44.1001 48.7299 43.9901 48.5299 43.9401C48.3299 43.9001 48.1799 43.8901 48.1499 43.7501C48.1099 43.6101 48.0799 43.5701 48.1199 43.5301C48.1599 43.4901 48.2299 43.4701 48.3799 43.4601C48.5299 43.4501 48.6899 43.4501 48.7399 43.4101C48.7899 43.3801 48.7999 43.2801 48.8499 43.2401C48.9099 43.2001 49.1299 43.1701 49.1299 43.1701C49.1299 43.1701 49.3999 43.3001 49.6499 43.4901C49.8299 43.6201 50.0399 43.8701 50.0399 43.8701Z",
    fill: "#CF70A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0399 43.8701C50.0399 43.8701 50.0399 44.0001 50.0599 44.1301C50.0699 44.2501 50.0199 44.3601 50.0399 44.4301C50.0599 44.5001 50.0699 44.5501 50.0899 44.6001C50.1099 44.6501 50.1299 44.7701 50.1299 44.7701C50.1299 44.7701 50.0599 44.7201 49.9899 44.6701C49.9299 44.6201 49.8799 44.5901 49.8799 44.5901C49.8799 44.5901 49.8899 44.7201 49.8999 44.7801C49.9099 44.8401 49.9399 44.9501 49.9899 45.0101C50.0399 45.0701 50.1499 45.1801 50.1799 45.2601C50.2099 45.3401 50.2099 45.5301 50.2099 45.5301C50.2099 45.5301 50.1199 45.3901 50.0499 45.3701C49.9799 45.3501 49.8199 45.2601 49.8199 45.2601C49.8199 45.2601 49.9699 45.4101 49.9699 45.5501C49.9699 45.6901 49.9099 45.8501 49.9099 45.8501C49.9099 45.8501 49.8399 45.7301 49.7599 45.6401C49.6699 45.5601 49.5499 45.4701 49.5499 45.4701C49.5499 45.4701 49.6499 45.6901 49.6499 45.8301C49.6499 45.9801 49.6199 46.2901 49.6199 46.2901C49.6199 46.2901 49.5499 46.1701 49.4699 46.1101C49.3999 46.0501 49.3099 46.0001 49.2799 45.9701C49.2499 45.9301 49.3699 46.0901 49.3799 46.1801C49.3899 46.2701 49.4399 46.6101 49.7399 47.0501C49.9099 47.3001 50.1799 47.7501 50.7599 47.6001C51.3299 47.4601 51.1199 46.6801 50.9999 46.3201C50.8799 45.9601 50.8199 45.5601 50.8299 45.4201C50.8399 45.2801 50.9399 44.8701 50.9199 44.7901C50.9099 44.7101 50.8699 44.4201 50.9399 44.1801C51.0099 43.9301 51.0799 43.8401 51.1199 43.7401C51.1599 43.6401 51.1899 43.5801 51.1999 43.4901C51.2099 43.4001 51.2099 43.2401 51.2099 43.2401C51.2099 43.2401 51.3199 43.4401 51.3399 43.5101C51.3699 43.5801 51.3699 43.7901 51.3699 43.7901C51.3699 43.7901 51.4699 43.5401 51.5499 43.4801C51.7099 43.3801 51.8999 43.2701 51.9399 43.2101C51.9899 43.1501 51.9999 43.1201 51.9999 43.1201C51.9999 43.1201 51.9899 43.4801 51.8899 43.6101C51.8199 43.7001 51.5599 44.0001 51.5599 44.0001C51.5599 44.0001 51.6999 43.9501 51.7899 43.9401C51.8799 43.9301 51.9499 43.9401 51.9499 43.9401C51.9499 43.9401 51.8399 44.0301 51.6899 44.2401C51.5399 44.4601 51.5999 44.4701 51.4999 44.6501C51.3899 44.8301 51.3099 44.8301 51.1699 44.9401C50.9699 45.1001 51.0799 45.7401 51.0999 45.8401C51.1299 45.9301 51.4699 46.7201 51.4799 46.9101C51.4899 47.1001 51.5199 47.5301 51.1799 47.8001C50.9699 47.9801 50.6099 47.9801 50.5299 48.0301C50.4499 48.0801 50.2899 48.2401 50.2899 48.5701C50.2899 48.9001 50.4099 48.9501 50.4999 49.0301C50.5999 49.1101 50.7099 49.0701 50.7399 49.1301C50.7699 49.1901 50.7799 49.2301 50.8199 49.2701C50.8599 49.3101 50.8899 49.3501 50.8699 49.4201C50.8599 49.4901 50.6999 49.6501 50.6499 49.7601C50.6099 49.8601 50.4999 50.1601 50.4999 50.2001C50.4999 50.2401 50.4899 50.3801 50.5299 50.4501C50.5299 50.4501 50.6999 50.6501 50.5799 50.6801C50.5099 50.7101 50.4399 50.6301 50.3999 50.6401C50.2999 50.6701 50.2499 50.7301 50.2199 50.7201C50.1499 50.7101 50.1499 50.6701 50.1399 50.5801C50.1399 50.4901 50.1399 50.4501 50.1099 50.4501C50.0699 50.4501 50.0499 50.4801 50.0399 50.5301C50.0299 50.5801 50.0299 50.7001 49.9899 50.7001C49.9399 50.7001 49.8799 50.6201 49.8399 50.6001C49.7999 50.5801 49.6899 50.5601 49.6799 50.5101C49.6699 50.4601 49.7499 50.3501 49.8199 50.3301C49.8899 50.3101 49.9599 50.2701 49.9099 50.2401C49.8599 50.2001 49.8199 50.2001 49.7699 50.2401C49.7199 50.2801 49.6199 50.2501 49.6299 50.1901C49.6399 50.1301 49.6499 50.0601 49.6399 50.0301C49.6399 50.0001 49.5499 49.9401 49.6599 49.8801C49.7699 49.8201 49.8199 49.9301 49.9199 49.9101C50.0299 49.8901 50.0799 49.8501 50.1199 49.7901C50.1599 49.7301 50.1499 49.5901 50.0799 49.5101C50.0099 49.4301 49.9299 49.4101 49.9099 49.3601C49.8799 49.3101 49.8399 49.1901 49.8399 49.1901C49.8399 49.1901 49.8599 49.4101 49.8499 49.4401C49.8399 49.4701 49.8399 49.6001 49.8399 49.6001C49.8399 49.6001 49.7699 49.5201 49.7099 49.4601C49.6499 49.4001 49.5899 49.2101 49.5899 49.2101C49.5899 49.2101 49.5799 49.3901 49.5799 49.4601C49.5799 49.5301 49.6599 49.5901 49.6299 49.6201C49.5999 49.6401 49.4799 49.4901 49.4399 49.4601C49.4099 49.4301 49.2999 49.3501 49.2499 49.2601C49.1999 49.1701 49.1699 49.0501 49.1599 49.0001C49.1499 48.9601 49.1299 48.7601 49.1499 48.7101C49.1799 48.6401 49.2399 48.5001 49.2399 48.5001H48.9799C48.8399 48.5001 48.7399 48.4601 48.6899 48.5501C48.6399 48.6401 48.6599 48.8301 48.7299 49.0801C48.7999 49.3301 48.8399 49.4501 48.8199 49.4901C48.7999 49.5301 48.7099 49.6401 48.6799 49.6601C48.6499 49.6801 48.5499 49.6701 48.5099 49.6501C48.4699 49.6301 48.3999 49.6001 48.2799 49.6001C48.1499 49.6001 48.0699 49.6001 48.0299 49.5901C47.9799 49.5801 47.8699 49.5201 47.8099 49.5301C47.7599 49.5401 47.6599 49.5901 47.6899 49.6601C47.7299 49.7701 47.6499 49.8001 47.5999 49.7901C47.5499 49.7801 47.4999 49.7601 47.4299 49.7501C47.3599 49.7301 47.2599 49.7501 47.2799 49.6701C47.2899 49.5901 47.3199 49.5901 47.3499 49.5301C47.3799 49.4701 47.3999 49.4301 47.3599 49.4301C47.3099 49.4301 47.2699 49.4201 47.2299 49.4501C47.1899 49.4801 47.1399 49.5501 47.0899 49.5201C47.0399 49.4901 47.0099 49.4401 47.0099 49.3201C47.0099 49.2001 46.8799 49.1001 46.9999 49.1001C47.1199 49.1101 47.2599 49.1901 47.2899 49.1201C47.3199 49.0601 47.2999 49.0301 47.2399 48.9801C47.1799 48.9301 47.0999 48.9001 47.1799 48.8401C47.2599 48.7801 47.2799 48.7801 47.3199 48.7401C47.3499 48.7101 47.3999 48.5901 47.4499 48.6201C47.5599 48.6701 47.4499 48.7501 47.5699 48.8801C47.6799 49.0101 47.7599 49.0501 47.9499 49.0301C48.1399 49.0101 48.1999 48.9901 48.1999 48.9301C48.1999 48.8801 48.1799 48.7801 48.1799 48.7401C48.1799 48.7001 48.2099 48.5601 48.2099 48.5601C48.2099 48.5601 48.1199 48.6201 48.0899 48.6701C48.0699 48.7201 48.0099 48.8201 48.0099 48.8201C48.0099 48.8201 47.9899 48.7101 47.9999 48.6201C47.9999 48.5701 48.0199 48.4701 48.0199 48.4601C48.0199 48.4101 47.9799 48.2901 47.9799 48.2901C47.9799 48.2901 47.9499 48.4301 47.9299 48.4601C47.9099 48.5001 47.8999 48.6601 47.8999 48.6601C47.8999 48.6601 47.7799 48.5501 47.8099 48.3701C47.8299 48.2301 47.7899 48.0501 47.8299 47.9901C47.8699 47.9301 47.9699 47.6901 48.2099 47.6801C48.4499 47.6701 48.6399 47.6901 48.7199 47.6901C48.7999 47.6801 49.0999 47.6301 49.0999 47.6301C49.0999 47.6301 48.5499 47.3501 48.4299 47.2601C48.2999 47.1801 48.1099 46.9601 48.0499 46.8601C47.9899 46.7601 47.9299 46.5701 47.9299 46.5701C47.9299 46.5701 47.8299 46.5701 47.7399 46.6201C47.6499 46.6701 47.5599 46.7401 47.5099 46.8001C47.4599 46.8601 47.3799 46.9901 47.3799 46.9901C47.3799 46.9901 47.3899 46.8201 47.3899 46.7601C47.3899 46.7101 47.3799 46.6001 47.3799 46.6001C47.3799 46.6001 47.3199 46.8401 47.1899 46.9201C47.0599 47.0101 46.9199 47.1301 46.9199 47.1301C46.9199 47.1301 46.9399 47.0001 46.9399 46.9701C46.9399 46.9401 46.9699 46.7901 46.9699 46.7901C46.9699 46.7901 46.8799 46.9201 46.7499 46.9501C46.6099 46.9701 46.4199 46.9701 46.3999 47.0501C46.3899 47.1301 46.4399 47.2501 46.4099 47.3101C46.3799 47.3701 46.3099 47.4101 46.3099 47.4101C46.3099 47.4101 46.2299 47.3501 46.1599 47.3401C46.0899 47.3301 46.0299 47.3701 46.0299 47.3701C46.0299 47.3701 45.9699 47.3001 45.9999 47.2501C46.0199 47.2001 46.1199 47.1301 46.0999 47.1001C46.0699 47.0701 45.9899 47.1101 45.9399 47.1301C45.8899 47.1601 45.7799 47.1801 45.7899 47.1001C45.7999 47.0201 45.8299 46.9701 45.7999 46.9101C45.7699 46.8501 45.7899 46.8101 45.8299 46.8001C45.8699 46.7801 46.0399 46.8001 46.0499 46.7601C46.0599 46.7201 46.0099 46.6701 45.8999 46.6501C45.7899 46.6201 45.7399 46.5601 45.7899 46.5101C45.8499 46.4501 45.8599 46.4401 45.8899 46.3901C45.9199 46.3401 45.9299 46.2501 46.0299 46.3001C46.1299 46.3401 46.1099 46.4501 46.2099 46.4901C46.3099 46.5201 46.5599 46.4801 46.6099 46.4501C46.6599 46.4201 46.8299 46.3001 46.8899 46.2701C46.9499 46.2401 47.1899 46.0601 47.1899 46.0601C47.1899 46.0601 47.0499 45.9601 46.9999 45.9101C46.9499 45.8601 46.8599 45.7401 46.8099 45.7201C46.7599 45.7001 46.5299 45.6101 46.4599 45.6001C46.3799 45.6001 46.1399 45.5101 46.1399 45.5101C46.1399 45.5101 46.2499 45.4801 46.2899 45.4501C46.3299 45.4201 46.4099 45.3501 46.4499 45.3501C46.4899 45.3501 46.4999 45.3501 46.4999 45.3501C46.4999 45.3501 46.2799 45.3401 46.2299 45.3301C46.1799 45.3201 46.0499 45.2301 45.9899 45.2301C45.9399 45.2301 45.8299 45.2501 45.8299 45.2501C45.8299 45.2501 45.9699 45.1601 46.0899 45.1401C46.1999 45.1201 46.2899 45.1301 46.2899 45.1301C46.2899 45.1301 46.1099 45.0801 46.0699 45.0201C46.0299 44.9601 45.9899 44.8701 45.9599 44.8301C45.9299 44.7901 45.9099 44.7301 45.8499 44.7201C45.7899 44.7101 45.6899 44.7901 45.6399 44.7901C45.5799 44.7801 45.5399 44.7501 45.5299 44.6701C45.5299 44.5901 45.5299 44.6101 45.5099 44.5701C45.4899 44.5301 45.3999 44.4201 45.4799 44.4001C45.5599 44.3801 45.7299 44.4201 45.7399 44.3901C45.7499 44.3601 45.6499 44.2701 45.5799 44.2401C45.5099 44.2101 45.3999 44.1501 45.4599 44.1001C45.5199 44.0501 45.5699 44.0301 45.6099 43.9901C45.6399 43.9501 45.6799 43.8201 45.7499 43.8601C45.8199 43.9001 45.9099 44.0901 45.9599 44.0801C46.0099 44.0701 46.0199 43.9301 46.0099 43.8701C45.9999 43.8101 46.0099 43.7101 46.0599 43.7201C46.1099 43.7301 46.1499 43.8001 46.2399 43.8001C46.3199 43.8001 46.4499 43.7801 46.4399 43.8401C46.4299 43.9001 46.3799 43.9701 46.3299 44.0401C46.2699 44.1101 46.2499 44.2301 46.2799 44.3201C46.3199 44.4101 46.4099 44.5401 46.4899 44.5901C46.5699 44.6401 46.7299 44.6801 46.8299 44.7501C46.9299 44.8201 47.1599 45.0001 47.2399 45.0201C47.3199 45.0401 47.3999 45.0801 47.3999 45.0801C47.3999 45.0801 47.4899 45.0401 47.6099 45.0401C47.7299 45.0401 48.0099 45.0601 48.1099 45.0101C48.2099 44.9601 48.3499 44.8901 48.3099 44.8001C48.2699 44.7101 48.0399 44.6201 48.0599 44.5501C48.0799 44.4801 48.1699 44.4701 48.3099 44.4701C48.4499 44.4701 48.6399 44.5001 48.6799 44.3001C48.7199 44.1001 48.7299 43.9901 48.5299 43.9401C48.3299 43.9001 48.1799 43.8901 48.1499 43.7501C48.1099 43.6101 48.0799 43.5701 48.1199 43.5301C48.1599 43.4901 48.2299 43.4701 48.3799 43.4601C48.5299 43.4501 48.6899 43.4501 48.7399 43.4101C48.7899 43.3801 48.7999 43.2801 48.8499 43.2401C48.9099 43.2001 49.1299 43.1701 49.1299 43.1701C49.1299 43.1701 49.3999 43.3001 49.6499 43.4901C49.8299 43.6201 50.0399 43.8701 50.0399 43.8701Z",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.98 46.48L48.95 46.39C48.95 46.39 48.87 46.15 48.82 46.08C48.8 46.05 48.78 46 48.77 45.96C48.76 45.99 48.75 46.02 48.74 46.03C48.7 46.09 48.62 46.14 48.57 46.16L48.56 46.17C48.49 46.2 48.41 46.28 48.41 46.28L48.36 46.32V46.25C48.36 46.19 48.34 46.01 48.32 45.95C48.3 45.91 48.3 45.84 48.31 45.79C48.28 45.83 48.24 45.87 48.21 45.9C48.16 45.93 48.04 46.02 47.87 46.06C47.74 46.09 47.69 46.12 47.69 46.12L47.58 46.18L47.64 46.07C47.64 46.07 47.74 45.91 47.75 45.79C47.75 45.76 47.75 45.73 47.74 45.69C47.73 45.66 47.73 45.63 47.72 45.58C47.71 45.51 47.75 45.43 47.79 45.37C47.74 45.39 47.68 45.4 47.64 45.41C47.59 45.41 47.56 45.41 47.5 45.39C47.47 45.38 47.44 45.37 47.39 45.36C47.25 45.33 47.13 45.42 47.13 45.42L47.08 45.46V45.4C47.08 45.4 47.07 45.29 47.15 45.18C47.21 45.09 47.33 45.04 47.34 45.03L47.37 45.09C47.37 45.09 47.26 45.14 47.21 45.21C47.18 45.25 47.17 45.3 47.16 45.33C47.22 45.3 47.31 45.27 47.42 45.3C47.47 45.31 47.51 45.33 47.54 45.33C47.6 45.35 47.62 45.35 47.66 45.35C47.71 45.35 47.84 45.3 47.89 45.29L48 45.25L47.92 45.34C47.88 45.38 47.8 45.51 47.81 45.58C47.82 45.62 47.82 45.66 47.83 45.68C47.84 45.72 47.85 45.76 47.84 45.8C47.83 45.88 47.8 45.97 47.77 46.03C47.8 46.02 47.84 46.01 47.89 46C48.04 45.97 48.16 45.89 48.2 45.86C48.27 45.81 48.36 45.68 48.36 45.68L48.44 45.57L48.42 45.71C48.41 45.76 48.4 45.9 48.42 45.96C48.44 46.02 48.45 46.14 48.46 46.22C48.49 46.19 48.54 46.16 48.58 46.14L48.59 46.13C48.63 46.11 48.7 46.06 48.73 46.02C48.75 45.99 48.77 45.89 48.78 45.83L48.82 45.65L48.84 45.84C48.84 45.84 48.86 46 48.91 46.07C48.94 46.12 48.99 46.24 49.01 46.32C49.03 46.27 49.06 46.21 49.09 46.17C49.19 46.06 49.21 46.01 49.21 45.99C49.21 45.95 49.2 45.87 49.2 45.84L49.15 45.59L49.33 45.98L49.27 46.01C49.26 46.06 49.22 46.12 49.13 46.22C49.08 46.28 49.03 46.43 49.03 46.43L48.98 46.48Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2701 48.5301L49.2201 48.4901C49.2201 48.4901 49.4101 48.2401 49.4201 48.0601C49.4301 47.9201 49.1701 47.7301 49.0701 47.6701L49.1001 47.6201C49.1201 47.6301 49.4901 47.8601 49.4801 48.0701C49.4701 48.2701 49.2801 48.5201 49.2701 48.5301Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1101 43.7301C48.1101 43.7301 48.08 43.6401 48.07 43.6201C48.06 43.6001 48.05 43.5701 48.05 43.5701C48.05 43.5701 48.21 43.5701 48.21 43.6201C48.21 43.6701 48.1601 43.6701 48.1501 43.6901C48.1401 43.7001 48.1101 43.7301 48.1101 43.7301Z",
    fill: "#020203",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8501 43.47L48.8401 43.39C48.8401 43.39 48.9801 43.39 49.0501 43.44C49.1601 43.51 49.2201 43.63 49.2201 43.63C49.2001 43.65 49.1201 43.58 49.0601 43.56C49.0601 43.56 49.0201 43.57 48.9801 43.57C48.9401 43.57 48.9201 43.55 48.9101 43.53C48.9001 43.51 48.9201 43.47 48.9201 43.47H48.8501Z",
    fill: "#020203",
    stroke: "#020203",
    strokeWidth: 0.008062,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1201 44.4501L48.1801 44.3501L48.2401 44.4401L48.1201 44.4501Z",
    fill: "#020203",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.27 44.4501L48.34 44.3501L48.42 44.4401L48.27 44.4501Z",
    fill: "#020203",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2 43.8401L48.3499 43.8901L48.2099 43.9601L48.2 43.8401Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2 43.8401L48.3499 43.8901L48.2099 43.9601L48.2 43.8401Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3801 43.89L48.5201 43.92L48.4101 44.01L48.3801 43.89Z",
    fill: "#020203",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.05 43.7001C46.05 43.7001 46.14 43.7601 46.21 43.7701C46.28 43.7801 46.3501 43.7801 46.3601 43.7801C46.3701 43.7801 46.3901 43.6801 46.3801 43.6101C46.3401 43.3901 46.14 43.3401 46.14 43.3401C46.14 43.3401 46.2 43.4801 46.17 43.5401C46.13 43.6301 46.05 43.7001 46.05 43.7001Z",
    fill: "#C14A46",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6201 43.89C45.6201 43.89 45.5401 43.75 45.3701 43.77C45.2001 43.79 45.0901 43.92 45.0901 43.92C45.0901 43.92 45.2801 43.91 45.3201 43.94C45.3901 43.98 45.4101 44.1 45.4101 44.1C45.4101 44.1 45.5101 44.04 45.5401 44C45.5801 43.96 45.6201 43.89 45.6201 43.89Z",
    fill: "#C14A46",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.42 44.4701C45.42 44.4701 45.28 44.4901 45.2 44.5801C45.12 44.6701 45.13 44.8401 45.13 44.8401C45.13 44.8401 45.22 44.7401 45.31 44.7401C45.39 44.7401 45.52 44.7701 45.52 44.7701C45.52 44.7701 45.48 44.6701 45.48 44.6201C45.48 44.5701 45.42 44.4701 45.42 44.4701Z",
    fill: "#C14A46",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9 46.3401C45.9 46.3401 45.82 46.2601 45.69 46.2801C45.55 46.3101 45.46 46.4601 45.46 46.4601C45.46 46.4601 45.58 46.4301 45.65 46.4401C45.72 46.4601 45.76 46.5201 45.76 46.5201C45.76 46.5201 45.82 46.4701 45.84 46.4401C45.86 46.4201 45.9 46.3401 45.9 46.3401Z",
    fill: "#C14A46",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7399 46.89C45.7399 46.89 45.6299 46.87 45.5299 46.95C45.4299 47.03 45.4299 47.18 45.4299 47.18C45.4299 47.18 45.5199 47.1 45.5999 47.11C45.6699 47.12 45.7599 47.16 45.7599 47.16C45.7599 47.16 45.7699 47.07 45.7799 47.04C45.7899 46.97 45.7399 46.89 45.7399 46.89Z",
    fill: "#C14A46",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.01 47.4C46.01 47.4 46 47.55 46.07 47.64C46.14 47.73 46.28 47.75 46.28 47.75C46.28 47.75 46.24 47.65 46.23 47.6C46.22 47.53 46.29 47.46 46.29 47.46C46.29 47.46 46.22 47.39 46.15 47.39C46.08 47.38 46.01 47.4 46.01 47.4Z",
    fill: "#C14A46",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3601 48.7001C47.3601 48.7001 47.2701 48.5801 47.1401 48.5801C47.0101 48.5901 46.8701 48.7101 46.8701 48.7101C46.8701 48.7101 47.0301 48.7001 47.0701 48.7501C47.1101 48.8101 47.1501 48.8701 47.1501 48.8701C47.1501 48.8701 47.2201 48.8301 47.2601 48.8001C47.3001 48.7901 47.3601 48.7001 47.3601 48.7001Z",
    fill: "#C14A46",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9601 49.22C46.9601 49.22 46.7901 49.19 46.7001 49.28C46.6201 49.37 46.6201 49.53 46.6201 49.53C46.6201 49.53 46.7201 49.42 46.8201 49.43C46.9101 49.44 47.0201 49.49 47.0201 49.49C47.0201 49.49 47.0001 49.39 46.9901 49.35C46.9901 49.3 46.9601 49.22 46.9601 49.22Z",
    fill: "#C14A46",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3301 49.77C47.3301 49.77 47.2401 49.89 47.3101 49.98C47.3701 50.07 47.5001 50.12 47.5001 50.12C47.5001 50.12 47.4501 50.05 47.4701 49.97C47.4901 49.91 47.5901 49.82 47.5901 49.82L47.3301 49.77Z",
    fill: "#C14A46",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.63 49.99C49.63 49.99 49.48 49.95 49.39 50C49.31 50.05 49.24 50.26 49.24 50.26C49.24 50.26 49.38 50.15 49.48 50.16C49.58 50.18 49.65 50.22 49.65 50.22C49.65 50.22 49.67 50.13 49.65 50.08C49.65 50.04 49.63 49.99 49.63 49.99Z",
    fill: "#C14A46",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7001 50.54C49.7001 50.54 49.5901 50.66 49.6301 50.76C49.6701 50.86 49.7401 50.96 49.7401 50.96C49.7401 50.96 49.7401 50.81 49.7801 50.77C49.8501 50.71 49.9701 50.7 49.9701 50.7C49.9701 50.7 49.8701 50.61 49.8401 50.6C49.8101 50.6 49.7001 50.54 49.7001 50.54Z",
    fill: "#C14A46",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.28 50.71C50.28 50.71 50.22 50.85 50.33 50.95C50.44 51.05 50.54 51.06 50.54 51.06C50.54 51.06 50.46 50.91 50.48 50.83C50.51 50.75 50.58 50.7 50.58 50.7C50.58 50.7 50.44 50.65 50.42 50.66C50.4 50.66 50.28 50.71 50.28 50.71Z",
    fill: "#C14A46",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.93 43.08H49.87C49.87 43.09 49.84 43.13 49.82 43.14C49.77 43.19 49.7 43.19 49.66 43.15C49.64 43.13 49.6301 43.1 49.6301 43.07C49.6001 43.09 49.5601 43.09 49.5401 43.07C49.4901 43.04 49.48 42.98 49.51 42.92C49.51 42.91 49.52 42.89 49.53 42.89V42.83L49.46 42.85L49.44 42.88C49.4 42.93 49.3401 42.94 49.3101 42.91C49.3001 42.9 49.2801 42.86 49.2901 42.86C49.2901 42.86 49.27 42.88 49.26 42.88C49.16 42.9 49.12 42.69 49.12 42.63L49.09 42.68C49.09 42.68 49.12 42.81 49.1 42.92C49.09 43.03 49.05 43.14 49.05 43.14C49.19 43.18 49.39 43.29 49.6 43.44C49.8 43.6 49.97 43.77 50.03 43.89C50.03 43.89 50.14 43.83 50.25 43.8C50.36 43.76 50.5 43.76 50.5 43.76L50.5401 43.72C50.4801 43.73 50.25 43.74 50.25 43.64C50.25 43.63 50.26 43.61 50.26 43.61C50.26 43.61 50.2201 43.61 50.2001 43.6C50.1701 43.58 50.1701 43.52 50.2001 43.47L50.23 43.45V43.39L50.2001 43.4C50.1901 43.41 50.18 43.42 50.17 43.43C50.12 43.47 50.05 43.48 50.01 43.44C49.99 43.42 49.9801 43.39 49.9901 43.35C49.9601 43.36 49.93 43.36 49.91 43.34C49.86 43.31 49.85 43.24 49.89 43.19C49.91 43.16 49.9401 43.13 49.9501 43.13L49.93 43.08Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.51 43.2C49.52 43.19 49.54 43.19 49.55 43.2C49.56 43.21 49.57 43.23 49.56 43.24C49.55 43.25 49.53 43.25 49.52 43.24C49.51 43.23 49.5 43.21 49.51 43.2Z",
    fill: "#020203",
    stroke: "#020203",
    strokeWidth: 0.008062,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6901 43.3501L49.6301 43.3001C49.6201 43.2901 49.6201 43.2801 49.6201 43.2701C49.6301 43.2601 49.6401 43.2601 49.6501 43.2701L49.7101 43.3201L49.7701 43.3701C49.7801 43.3801 49.7801 43.3901 49.7801 43.4001C49.7701 43.4101 49.7601 43.4101 49.7501 43.4001L49.6901 43.3501Z",
    fill: "#020203",
    stroke: "#020203",
    strokeWidth: 0.008062,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.37 43.13L49.32 43.1C49.31 43.09 49.3001 43.08 49.3101 43.07C49.3201 43.06 49.33 43.06 49.34 43.07L49.39 43.1L49.44 43.13C49.45 43.14 49.4601 43.15 49.4501 43.16C49.4501 43.17 49.43 43.17 49.42 43.16L49.37 43.13Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.37 43.13L49.32 43.1C49.31 43.09 49.3001 43.08 49.3101 43.07C49.3201 43.06 49.33 43.06 49.34 43.07L49.39 43.1L49.44 43.13C49.45 43.14 49.4601 43.15 49.4501 43.16C49.4501 43.17 49.43 43.17 49.42 43.16L49.37 43.13Z",
    stroke: "#020203",
    strokeWidth: 0.008062,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1799 43.0001C49.1899 42.9901 49.2099 42.9901 49.2199 43.0001C49.2399 43.0101 49.2399 43.0301 49.2299 43.0401C49.2199 43.0501 49.1999 43.0501 49.1899 43.0401C49.1699 43.0301 49.1699 43.0101 49.1799 43.0001Z",
    fill: "#020203",
    stroke: "#020203",
    strokeWidth: 0.008062,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8801 43.4801C49.8901 43.4701 49.8901 43.4501 49.8701 43.4401C49.8601 43.4301 49.8401 43.4301 49.8301 43.4401C49.8201 43.4501 49.8301 43.4701 49.8401 43.4801C49.8501 43.5001 49.8701 43.5001 49.8801 43.4801Z",
    fill: "#020203",
    stroke: "#020203",
    strokeWidth: 0.008062,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9901 43.61L50.0301 43.65C50.0401 43.66 50.0501 43.66 50.0601 43.66C50.0701 43.65 50.0701 43.64 50.0601 43.63L50.0201 43.59L49.9801 43.55C49.9701 43.54 49.9501 43.54 49.9501 43.54C49.9401 43.55 49.9401 43.56 49.9501 43.57L49.9901 43.61Z",
    fill: "#020203",
    stroke: "#020203",
    strokeWidth: 0.008062,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1601 43.76C50.1701 43.75 50.1701 43.73 50.1501 43.72C50.1401 43.71 50.1201 43.71 50.1101 43.72C50.1001 43.73 50.1101 43.75 50.1201 43.76C50.1401 43.76 50.1501 43.77 50.1601 43.76Z",
    fill: "#020203",
    stroke: "#020203",
    strokeWidth: 0.008062,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.66 42.64H49.55L49.53 42.8L49.54 42.83H49.57L49.71 42.74L49.66 42.64Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.66 42.64H49.55L49.53 42.8L49.54 42.83H49.57L49.71 42.74L49.66 42.64Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.66 42.64H49.55L49.53 42.8L49.54 42.83H49.57L49.71 42.74L49.66 42.64Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.66 42.64H49.55L49.53 42.8L49.54 42.83H49.57L49.71 42.74L49.66 42.64Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3601 42.7301V42.8301L49.5301 42.8501L49.5501 42.8401V42.8101L49.4501 42.6801L49.3601 42.7301Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.71 42.9301L49.62 42.9801L49.52 42.8501V42.8201L49.55 42.8101L49.72 42.8301L49.71 42.9301Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.71 42.9301L49.62 42.9801L49.52 42.8501V42.8201L49.55 42.8101L49.72 42.8301L49.71 42.9301Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4901 42.81C49.5001 42.78 49.5401 42.78 49.5601 42.79C49.5901 42.8 49.5901 42.84 49.5801 42.86C49.5701 42.88 49.5301 42.89 49.5101 42.88C49.4801 42.86 49.4801 42.83 49.4901 42.81Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.09 42.6401C49.09 42.6401 49.07 42.5601 49.04 42.5101C49.03 42.4701 48.97 42.4301 48.97 42.4301C48.98 42.4201 49.05 42.3901 49.13 42.4501C49.2 42.5101 49.12 42.6101 49.12 42.6101C49.12 42.6101 49.11 42.6301 49.09 42.6401Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2801 42.7001L49.2001 42.7701L49.0701 42.6601L49.0801 42.6501L49.0901 42.6201L49.2601 42.6101L49.2801 42.7001Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2801 42.7001L49.2001 42.7701L49.0701 42.6601L49.0801 42.6501L49.0901 42.6201L49.2601 42.6101L49.2801 42.7001Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0701 42.6301C49.0801 42.6001 49.1001 42.5901 49.1201 42.5901C49.1401 42.6001 49.1501 42.6201 49.1401 42.6501C49.1301 42.6801 49.1101 42.6901 49.0901 42.6901C49.0701 42.6801 49.0601 42.6601 49.0701 42.6301Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0799 42.9L49.9699 42.89L49.9199 43.05L49.9299 43.08H49.9599L50.1099 43L50.0799 42.9Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0799 42.9L49.9699 42.89L49.9199 43.05L49.9299 43.08H49.9599L50.1099 43L50.0799 42.9Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.77 42.95L49.75 43.05L49.92 43.09L49.95 43.08V43.05L49.87 42.9L49.77 42.95Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.77 42.95L49.75 43.05L49.92 43.09L49.95 43.08V43.05L49.87 42.9L49.77 42.95Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0899 43.1901L49.9899 43.2301L49.9099 43.0901V43.0601H49.9399L50.0999 43.1001L50.0899 43.1901Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.89 43.04C49.91 43.02 49.94 43.02 49.96 43.03C49.98 43.05 49.99 43.08 49.97 43.1C49.95 43.12 49.92 43.12 49.89 43.11C49.87 43.1 49.87 43.07 49.89 43.04Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.44 43.2401L50.46 43.3401L50.3 43.4001L50.27 43.3901V43.3601L50.34 43.2101L50.44 43.2401Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.44 43.2401L50.46 43.3401L50.3 43.4001L50.27 43.3901V43.3601L50.34 43.2101L50.44 43.2401Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.41 43.5401L50.31 43.5601L50.25 43.4101L50.26 43.3801L50.29 43.3701L50.44 43.4401L50.41 43.5401Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1301 43.2501L50.1001 43.3501L50.2601 43.4101H50.2901L50.3001 43.3801L50.2401 43.2301L50.1301 43.2501Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1301 43.2501L50.1001 43.3501L50.2601 43.4101H50.2901L50.3001 43.3801L50.2401 43.2301L50.1301 43.2501Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3001 43.4301C50.3201 43.4101 50.3201 43.3801 50.3001 43.3601C50.2801 43.3401 50.2501 43.3401 50.2301 43.3601C50.2101 43.3801 50.2101 43.4101 50.2301 43.4301C50.2501 43.4501 50.2801 43.4501 50.3001 43.4301Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5601 43.76C50.5601 43.76 50.6501 43.77 50.7101 43.78C50.7501 43.79 50.8101 43.83 50.8101 43.83C50.8201 43.82 50.8301 43.75 50.7601 43.68C50.6901 43.63 50.6001 43.72 50.6001 43.72C50.6001 43.72 50.5601 43.75 50.5601 43.76Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4599 43.6001L50.4099 43.6801L50.5499 43.7701L50.5699 43.7601L50.5899 43.7501L50.5699 43.5901L50.4599 43.6001Z",
    fill: "#BAA927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4599 43.6001L50.4099 43.6801L50.5499 43.7701L50.5699 43.7601L50.5899 43.7501L50.5699 43.5901L50.4599 43.6001Z",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5701 43.7801C50.6001 43.7701 50.6101 43.7401 50.6001 43.7201C50.5901 43.7001 50.5601 43.7001 50.5301 43.7201C50.5001 43.7401 50.4901 43.7601 50.5001 43.7801C50.5201 43.7901 50.5501 43.8001 50.5701 43.7801Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.042,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9399 52.0001C46.9399 50.1401 45.5899 48.6201 43.9299 48.6201C42.2699 48.6201 40.9199 50.1401 40.9199 52.0001C40.9199 53.8601 42.2699 55.3801 43.9299 55.3801C45.5899 55.3901 46.9399 53.8701 46.9399 52.0001Z",
    fill: "#BF1818",
    stroke: "#020203",
    strokeWidth: 0.0672,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0501 52C46.0501 50.63 45.1001 49.52 43.9301 49.52C42.7701 49.52 41.8201 50.63 41.8201 52C41.8201 53.37 42.7701 54.48 43.9301 54.48C45.1001 54.48 46.0501 53.36 46.0501 52Z",
    fill: "#3955A2",
    stroke: "#020203",
    strokeWidth: 0.0986,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.93 50.29C42.93 50.29 42.68 50.56 42.68 50.82C42.68 51.08 42.79 51.29 42.79 51.29C42.75 51.19 42.65 51.11 42.53 51.11C42.38 51.11 42.25 51.23 42.25 51.37C42.25 51.41 42.27 51.48 42.29 51.51L42.38 51.69C42.41 51.62 42.48 51.58 42.56 51.58C42.67 51.58 42.76 51.66 42.76 51.77C42.76 51.79 42.76 51.8 42.75 51.82H42.52V52.01H42.72L42.57 52.31L42.77 52.23L42.92 52.4L43.08 52.23L43.28 52.31L43.13 52.01H43.33V51.82H43.1C43.1 51.8 43.1 51.79 43.1 51.77C43.1 51.67 43.19 51.58 43.3 51.58C43.38 51.58 43.45 51.62 43.48 51.68L43.57 51.5C43.59 51.47 43.62 51.4 43.62 51.36C43.62 51.21 43.5 51.1 43.34 51.1C43.22 51.1 43.12 51.17 43.08 51.28C43.08 51.28 43.19 51.07 43.19 50.81C43.19 50.56 42.93 50.29 42.93 50.29Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.055,
    strokeMiterlimit: 22.9256,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.34 51.8301H42.53V52.0201H43.34V51.8301Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.055,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7699 41.9301H55.6499V43.0101H59.7699V41.9301Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0801 43.73C56.1101 43.72 56.1201 43.72 56.1601 43.72H59.2501C59.2801 43.72 59.3101 43.73 59.3301 43.74C59.2201 43.71 59.1501 43.61 59.1501 43.5C59.1501 43.39 59.2301 43.29 59.3401 43.25C59.3101 43.26 59.2801 43.26 59.2501 43.26H56.1601C56.1301 43.26 56.1001 43.26 56.0701 43.25H56.0901C56.2001 43.28 56.2601 43.38 56.2601 43.49C56.2601 43.59 56.1901 43.7 56.0801 43.73Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.15 43.7201H59.24C59.35 43.7201 59.43 43.7901 59.43 43.8701C59.43 43.9501 59.35 44.0201 59.24 44.0201H56.15C56.05 44.0201 55.96 43.9601 55.96 43.8701C55.97 43.7801 56.05 43.7201 56.15 43.7201Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.15 43.01H59.24C59.35 43.01 59.43 43.07 59.43 43.13C59.43 43.2 59.35 43.25 59.24 43.25H56.15C56.05 43.25 55.96 43.19 55.96 43.13C55.97 43.07 56.05 43.01 56.15 43.01Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.063,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.93 50.29C44.93 50.29 44.68 50.56 44.68 50.82C44.68 51.08 44.79 51.29 44.79 51.29C44.75 51.19 44.65 51.11 44.53 51.11C44.38 51.11 44.25 51.23 44.25 51.37C44.25 51.41 44.28 51.48 44.29 51.51L44.38 51.69C44.41 51.62 44.48 51.58 44.56 51.58C44.67 51.58 44.76 51.66 44.76 51.77C44.76 51.79 44.76 51.8 44.75 51.82H44.52V52.01H44.72L44.57 52.31L44.77 52.23L44.92 52.4L45.08 52.23L45.28 52.31L45.13 52.01H45.33V51.82H45.1C45.1 51.8 45.1 51.79 45.1 51.77C45.1 51.67 45.19 51.58 45.3 51.58C45.38 51.58 45.45 51.62 45.48 51.68L45.57 51.5C45.59 51.47 45.62 51.4 45.62 51.36C45.62 51.21 45.5 51.1 45.34 51.1C45.22 51.1 45.12 51.17 45.08 51.28C45.08 51.28 45.19 51.07 45.19 50.81C45.19 50.56 44.93 50.29 44.93 50.29Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.055,
    strokeMiterlimit: 22.9256,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.34 51.8301H44.53V52.0201H45.34V51.8301Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.055,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.94 51.9801C43.94 51.9801 43.69 52.2501 43.69 52.5101C43.69 52.7701 43.8 52.9801 43.8 52.9801C43.76 52.8801 43.66 52.8001 43.54 52.8001C43.39 52.8001 43.26 52.9201 43.26 53.0601C43.26 53.1001 43.29 53.1701 43.3 53.2001L43.39 53.3801C43.42 53.3101 43.49 53.2801 43.57 53.2801C43.68 53.2801 43.77 53.3601 43.77 53.4701C43.77 53.4901 43.77 53.5001 43.76 53.5201H43.53V53.7101H43.73L43.58 54.0101L43.78 53.9301L43.93 54.1001L44.09 53.9301L44.29 54.0101L44.14 53.7101H44.34V53.5201H44.12C44.12 53.5001 44.12 53.4901 44.12 53.4701C44.12 53.3701 44.21 53.2801 44.32 53.2801C44.4 53.2801 44.47 53.3201 44.5 53.3801L44.59 53.2001C44.61 53.1601 44.63 53.1001 44.63 53.0601C44.63 52.9101 44.51 52.8001 44.35 52.8001C44.23 52.8001 44.13 52.8701 44.09 52.9701C44.09 52.9701 44.2 52.7601 44.2 52.5001C44.2 52.2501 43.94 51.9801 43.94 51.9801Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.055,
    strokeMiterlimit: 22.9256,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.35 53.52H43.54V53.71H44.35V53.52Z",
    fill: "#BAA927",
    stroke: "#020203",
    strokeWidth: 0.055,
    strokeMiterlimit: 22.9256
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26626_59562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.63,
    height: 92.42,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEs);
export default __webpack_public_path__ + "static/media/Flag_ES.0e523a4c795078465e82e636473b52ac.svg";
export { ForwardRef as ReactComponent };